(function(){function r(e,n,t){function o(i,f){if(!n[i]){if(!e[i]){var c="function"==typeof require&&require;if(!f&&c)return c(i,!0);if(u)return u(i,!0);var a=new Error("Cannot find module '"+i+"'");throw a.code="MODULE_NOT_FOUND",a}var p=n[i]={exports:{}};e[i][0].call(p.exports,function(r){var n=e[i][1][r];return o(n||r)},p,p.exports,r,e,n,t)}return n[i].exports}for(var u="function"==typeof require&&require,i=0;i<t.length;i++)o(t[i]);return o}return r})()({1:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var Cookie = /*#__PURE__*/function () {
  function Cookie() {
    _classCallCheck(this, Cookie);
  }
  _createClass(Cookie, [{
    key: "SetCookie",
    value: function SetCookie(CookieName, CookieValue, ExpiresInDays) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInDays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=Lax;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetCookieToExpireInHours",
    value: function SetCookieToExpireInHours(CookieName, CookieValue, ExpiresInHours) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInHours * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=Lax;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetCookieSameSiteNone",
    value: function SetCookieSameSiteNone(CookieName, CookieValue, ExpiresInDays) {
      var d = new Date();
      d.setTime(d.getTime() + ExpiresInDays * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      var cookieToSet = CookieName + "=" + encodeURIComponent(CookieValue) + ";" + expires + ";Secure;SameSite=None;path=/";
      document.cookie = cookieToSet;
    }
  }, {
    key: "SetSessionCookie",
    value: function SetSessionCookie(cname, cvalue) {
      document.cookie = cname + "=" + cvalue + ";Secure;SameSite=Lax;expires=0;path=/";
    }
  }, {
    key: "GetCookie",
    value: function GetCookie(cname) {
      var name = cname + "=";
      var cookie = document.cookie;
      var ca = cookie.split(';');
      for (var i = 0; i < ca.length; i++) {
        var c = decodeURIComponent(ca[i]);
        while (c.charAt(0) === ' ') {
          c = c.substring(1);
        }
        if (c.indexOf(name) === 0) {
          return c.substring(name.length, c.length);
        }
      }
      return "";
    }
  }, {
    key: "DeleteCookie",
    value: function DeleteCookie(name) {
      document.cookie = name + '=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/';
    }
  }, {
    key: "GetValue",
    value: function GetValue(requestedValue, data) {
      var nameEQ = requestedValue + "=";
      var splits = data.split("&");
      for (var i = 0; i < splits.length; i++) {
        var c = splits[i];
        while (c.charAt(0) == ' ') {
          c = c.substring(1, c.length);
        }
        if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length, c.length);
      }
    }
  }]);
  return Cookie;
}();
var _default = Cookie;
exports["default"] = _default;

},{}],2:[function(require,module,exports){
'use strict';

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _regeneratorRuntime() { "use strict"; /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/facebook/regenerator/blob/main/LICENSE */ _regeneratorRuntime = function _regeneratorRuntime() { return exports; }; var exports = {}, Op = Object.prototype, hasOwn = Op.hasOwnProperty, defineProperty = Object.defineProperty || function (obj, key, desc) { obj[key] = desc.value; }, $Symbol = "function" == typeof Symbol ? Symbol : {}, iteratorSymbol = $Symbol.iterator || "@@iterator", asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator", toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag"; function define(obj, key, value) { return Object.defineProperty(obj, key, { value: value, enumerable: !0, configurable: !0, writable: !0 }), obj[key]; } try { define({}, ""); } catch (err) { define = function define(obj, key, value) { return obj[key] = value; }; } function wrap(innerFn, outerFn, self, tryLocsList) { var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator, generator = Object.create(protoGenerator.prototype), context = new Context(tryLocsList || []); return defineProperty(generator, "_invoke", { value: makeInvokeMethod(innerFn, self, context) }), generator; } function tryCatch(fn, obj, arg) { try { return { type: "normal", arg: fn.call(obj, arg) }; } catch (err) { return { type: "throw", arg: err }; } } exports.wrap = wrap; var ContinueSentinel = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} var IteratorPrototype = {}; define(IteratorPrototype, iteratorSymbol, function () { return this; }); var getProto = Object.getPrototypeOf, NativeIteratorPrototype = getProto && getProto(getProto(values([]))); NativeIteratorPrototype && NativeIteratorPrototype !== Op && hasOwn.call(NativeIteratorPrototype, iteratorSymbol) && (IteratorPrototype = NativeIteratorPrototype); var Gp = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(IteratorPrototype); function defineIteratorMethods(prototype) { ["next", "throw", "return"].forEach(function (method) { define(prototype, method, function (arg) { return this._invoke(method, arg); }); }); } function AsyncIterator(generator, PromiseImpl) { function invoke(method, arg, resolve, reject) { var record = tryCatch(generator[method], generator, arg); if ("throw" !== record.type) { var result = record.arg, value = result.value; return value && "object" == _typeof(value) && hasOwn.call(value, "__await") ? PromiseImpl.resolve(value.__await).then(function (value) { invoke("next", value, resolve, reject); }, function (err) { invoke("throw", err, resolve, reject); }) : PromiseImpl.resolve(value).then(function (unwrapped) { result.value = unwrapped, resolve(result); }, function (error) { return invoke("throw", error, resolve, reject); }); } reject(record.arg); } var previousPromise; defineProperty(this, "_invoke", { value: function value(method, arg) { function callInvokeWithMethodAndArg() { return new PromiseImpl(function (resolve, reject) { invoke(method, arg, resolve, reject); }); } return previousPromise = previousPromise ? previousPromise.then(callInvokeWithMethodAndArg, callInvokeWithMethodAndArg) : callInvokeWithMethodAndArg(); } }); } function makeInvokeMethod(innerFn, self, context) { var state = "suspendedStart"; return function (method, arg) { if ("executing" === state) throw new Error("Generator is already running"); if ("completed" === state) { if ("throw" === method) throw arg; return doneResult(); } for (context.method = method, context.arg = arg;;) { var delegate = context.delegate; if (delegate) { var delegateResult = maybeInvokeDelegate(delegate, context); if (delegateResult) { if (delegateResult === ContinueSentinel) continue; return delegateResult; } } if ("next" === context.method) context.sent = context._sent = context.arg;else if ("throw" === context.method) { if ("suspendedStart" === state) throw state = "completed", context.arg; context.dispatchException(context.arg); } else "return" === context.method && context.abrupt("return", context.arg); state = "executing"; var record = tryCatch(innerFn, self, context); if ("normal" === record.type) { if (state = context.done ? "completed" : "suspendedYield", record.arg === ContinueSentinel) continue; return { value: record.arg, done: context.done }; } "throw" === record.type && (state = "completed", context.method = "throw", context.arg = record.arg); } }; } function maybeInvokeDelegate(delegate, context) { var method = delegate.iterator[context.method]; if (undefined === method) { if (context.delegate = null, "throw" === context.method) { if (delegate.iterator["return"] && (context.method = "return", context.arg = undefined, maybeInvokeDelegate(delegate, context), "throw" === context.method)) return ContinueSentinel; context.method = "throw", context.arg = new TypeError("The iterator does not provide a 'throw' method"); } return ContinueSentinel; } var record = tryCatch(method, delegate.iterator, context.arg); if ("throw" === record.type) return context.method = "throw", context.arg = record.arg, context.delegate = null, ContinueSentinel; var info = record.arg; return info ? info.done ? (context[delegate.resultName] = info.value, context.next = delegate.nextLoc, "return" !== context.method && (context.method = "next", context.arg = undefined), context.delegate = null, ContinueSentinel) : info : (context.method = "throw", context.arg = new TypeError("iterator result is not an object"), context.delegate = null, ContinueSentinel); } function pushTryEntry(locs) { var entry = { tryLoc: locs[0] }; 1 in locs && (entry.catchLoc = locs[1]), 2 in locs && (entry.finallyLoc = locs[2], entry.afterLoc = locs[3]), this.tryEntries.push(entry); } function resetTryEntry(entry) { var record = entry.completion || {}; record.type = "normal", delete record.arg, entry.completion = record; } function Context(tryLocsList) { this.tryEntries = [{ tryLoc: "root" }], tryLocsList.forEach(pushTryEntry, this), this.reset(!0); } function values(iterable) { if (iterable) { var iteratorMethod = iterable[iteratorSymbol]; if (iteratorMethod) return iteratorMethod.call(iterable); if ("function" == typeof iterable.next) return iterable; if (!isNaN(iterable.length)) { var i = -1, next = function next() { for (; ++i < iterable.length;) { if (hasOwn.call(iterable, i)) return next.value = iterable[i], next.done = !1, next; } return next.value = undefined, next.done = !0, next; }; return next.next = next; } } return { next: doneResult }; } function doneResult() { return { value: undefined, done: !0 }; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, defineProperty(Gp, "constructor", { value: GeneratorFunctionPrototype, configurable: !0 }), defineProperty(GeneratorFunctionPrototype, "constructor", { value: GeneratorFunction, configurable: !0 }), GeneratorFunction.displayName = define(GeneratorFunctionPrototype, toStringTagSymbol, "GeneratorFunction"), exports.isGeneratorFunction = function (genFun) { var ctor = "function" == typeof genFun && genFun.constructor; return !!ctor && (ctor === GeneratorFunction || "GeneratorFunction" === (ctor.displayName || ctor.name)); }, exports.mark = function (genFun) { return Object.setPrototypeOf ? Object.setPrototypeOf(genFun, GeneratorFunctionPrototype) : (genFun.__proto__ = GeneratorFunctionPrototype, define(genFun, toStringTagSymbol, "GeneratorFunction")), genFun.prototype = Object.create(Gp), genFun; }, exports.awrap = function (arg) { return { __await: arg }; }, defineIteratorMethods(AsyncIterator.prototype), define(AsyncIterator.prototype, asyncIteratorSymbol, function () { return this; }), exports.AsyncIterator = AsyncIterator, exports.async = function (innerFn, outerFn, self, tryLocsList, PromiseImpl) { void 0 === PromiseImpl && (PromiseImpl = Promise); var iter = new AsyncIterator(wrap(innerFn, outerFn, self, tryLocsList), PromiseImpl); return exports.isGeneratorFunction(outerFn) ? iter : iter.next().then(function (result) { return result.done ? result.value : iter.next(); }); }, defineIteratorMethods(Gp), define(Gp, toStringTagSymbol, "Generator"), define(Gp, iteratorSymbol, function () { return this; }), define(Gp, "toString", function () { return "[object Generator]"; }), exports.keys = function (val) { var object = Object(val), keys = []; for (var key in object) { keys.push(key); } return keys.reverse(), function next() { for (; keys.length;) { var key = keys.pop(); if (key in object) return next.value = key, next.done = !1, next; } return next.done = !0, next; }; }, exports.values = values, Context.prototype = { constructor: Context, reset: function reset(skipTempReset) { if (this.prev = 0, this.next = 0, this.sent = this._sent = undefined, this.done = !1, this.delegate = null, this.method = "next", this.arg = undefined, this.tryEntries.forEach(resetTryEntry), !skipTempReset) for (var name in this) { "t" === name.charAt(0) && hasOwn.call(this, name) && !isNaN(+name.slice(1)) && (this[name] = undefined); } }, stop: function stop() { this.done = !0; var rootRecord = this.tryEntries[0].completion; if ("throw" === rootRecord.type) throw rootRecord.arg; return this.rval; }, dispatchException: function dispatchException(exception) { if (this.done) throw exception; var context = this; function handle(loc, caught) { return record.type = "throw", record.arg = exception, context.next = loc, caught && (context.method = "next", context.arg = undefined), !!caught; } for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i], record = entry.completion; if ("root" === entry.tryLoc) return handle("end"); if (entry.tryLoc <= this.prev) { var hasCatch = hasOwn.call(entry, "catchLoc"), hasFinally = hasOwn.call(entry, "finallyLoc"); if (hasCatch && hasFinally) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } else if (hasCatch) { if (this.prev < entry.catchLoc) return handle(entry.catchLoc, !0); } else { if (!hasFinally) throw new Error("try statement without catch or finally"); if (this.prev < entry.finallyLoc) return handle(entry.finallyLoc); } } } }, abrupt: function abrupt(type, arg) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc <= this.prev && hasOwn.call(entry, "finallyLoc") && this.prev < entry.finallyLoc) { var finallyEntry = entry; break; } } finallyEntry && ("break" === type || "continue" === type) && finallyEntry.tryLoc <= arg && arg <= finallyEntry.finallyLoc && (finallyEntry = null); var record = finallyEntry ? finallyEntry.completion : {}; return record.type = type, record.arg = arg, finallyEntry ? (this.method = "next", this.next = finallyEntry.finallyLoc, ContinueSentinel) : this.complete(record); }, complete: function complete(record, afterLoc) { if ("throw" === record.type) throw record.arg; return "break" === record.type || "continue" === record.type ? this.next = record.arg : "return" === record.type ? (this.rval = this.arg = record.arg, this.method = "return", this.next = "end") : "normal" === record.type && afterLoc && (this.next = afterLoc), ContinueSentinel; }, finish: function finish(finallyLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.finallyLoc === finallyLoc) return this.complete(entry.completion, entry.afterLoc), resetTryEntry(entry), ContinueSentinel; } }, "catch": function _catch(tryLoc) { for (var i = this.tryEntries.length - 1; i >= 0; --i) { var entry = this.tryEntries[i]; if (entry.tryLoc === tryLoc) { var record = entry.completion; if ("throw" === record.type) { var thrown = record.arg; resetTryEntry(entry); } return thrown; } } throw new Error("illegal catch attempt"); }, delegateYield: function delegateYield(iterable, resultName, nextLoc) { return this.delegate = { iterator: values(iterable), resultName: resultName, nextLoc: nextLoc }, "next" === this.method && (this.arg = undefined), ContinueSentinel; } }, exports; }
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { Promise.resolve(value).then(_next, _throw); } }
function _asyncToGenerator(fn) { return function () { var self = this, args = arguments; return new Promise(function (resolve, reject) { var gen = fn.apply(self, args); function _next(value) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value); } function _throw(err) { asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err); } _next(undefined); }); }; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e2) { throw _e2; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e3) { didErr = true; err = _e3; }, f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
var Lightbox = /*#__PURE__*/function () {
  function Lightbox() {
    _classCallCheck(this, Lightbox);
    this.allowedFileTypes = ["image/jpeg", "image/png", "image/gif", "image/webp", "image/heic", "image/heif"];
    this.tmp_files = new Array();
    $('.lb-nav a.lb-next').on('click', function (e) {
      e.preventDefault();
      var dialogWithNext = $(e.target).closest('.has-next');
      if (dialogWithNext.length) {
        var currentIndex = dialogWithNext.data('currentIndex');
        if (currentIndex === null || currentIndex === undefined) {
          currentIndex = 0;
        }
        var gallery = dialogWithNext.data('gallery');
        var nextIndex = parseInt(currentIndex + 1, 10);
        dialogWithNext.data('currentIndex', nextIndex);
        if (nextIndex === parseInt(gallery.length - 1, 10)) {
          dialogWithNext.removeClass('has-next');
        } else {
          dialogWithNext.addClass('has-next');
        }
        if (parseInt(currentIndex, 10) === 0) {
          dialogWithNext.addClass('has-prev');
        }
        $('#' + dialogWithNext.attr('id') + " img.lightbox-image").attr('src', gallery[nextIndex].src);
        $('.XofY .x').html(nextIndex + 1);
      }
    });
    $('.lb-nav a.lb-prev').on('click', function (e) {
      e.preventDefault();
      var dialogWithPrevious = $(e.target).closest('.has-prev');
      if (dialogWithPrevious.length) {
        var currentIndex = dialogWithPrevious.data('currentIndex');
        if (currentIndex === null || currentIndex === undefined) {
          currentIndex = 0;
        }
        var gallery = dialogWithPrevious.data('gallery');
        dialogWithPrevious.data('currentIndex', currentIndex - 1);
        console.log(parseInt(currentIndex - 1, 10));
        if (parseInt(currentIndex - 1, 10) === 0) {
          dialogWithPrevious.removeClass('has-prev');
        }
        console.log(parseInt(currentIndex + 1, 10), parseInt(gallery.length - 1, 10));
        if (parseInt(currentIndex, 10) === parseInt(gallery.length - 1, 10)) {
          dialogWithPrevious.addClass('has-next');
        }
        $('#' + dialogWithPrevious.attr('id') + " img.lightbox-image").attr('src', gallery[parseInt(currentIndex - 1, 10)].src);
        $('.XofY .x').html(currentIndex);
      }
    });
  }
  _createClass(Lightbox, [{
    key: "InitializeLBImages",
    value: function InitializeLBImages(containerClass) {
      var images = $('.' + containerClass + ' img.lightbox-slide:not(.lightbox-image)');
      for (var i = 0; i < images.length; i++) {
        if ($(images[i]).parent().is('a')) continue;
        var srcLink = $(images[i]).attr('src');
        $(images[i]).wrap('<a href="' + srcLink + '" data-toggle="lightbox-image" data-target-id="lightbox-image-holder">');
      }
      $('[data-toggle="lightbox-image"]').on('click', function (e) {
        var _this = this;
        var clickedIndex = 0;
        e.preventDefault();
        var gallery = $(this).closest('.image-row').find('img');
        var id = $(this).data("target-id");
        ;
        var srclink = $(this).attr('href');
        $('#' + id + " img.lightbox-image").attr('src', srclink);
        var modelPopUp = $('#' + id);
        modelPopUp.removeClass('has-next');
        modelPopUp.removeClass('has-prev');
        modelPopUp.data('gallery', []);
        if (gallery.length > 1) {
          modelPopUp.data('gallery', gallery);
          gallery.map(function (i, el) {
            if (el.src === _this.href) {
              clickedIndex = i;
            }
          });
          modelPopUp.data('currentIndex', clickedIndex);
          if (clickedIndex > 0) {
            modelPopUp.addClass('has-prev');
          }
          if (clickedIndex + 1 < gallery.length) {
            modelPopUp.addClass('has-next');
          }
        }
        $('.XofY .x').html(clickedIndex + 1);
        $('.XofY .y').html(gallery.length);
        setTimeout(function () {
          modelPopUp.modal('show');
        }, 100);
        return false;
      });
    }
  }, {
    key: "RemoveImage",
    value: function RemoveImage(image) {
      var frameId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#img-frames";
      var i;
      var _iterator = _createForOfIteratorHelper(this.tmp_files.entries()),
        _step;
      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var _step$value = _slicedToArray(_step.value, 2),
            index = _step$value[0],
            item = _step$value[1];
          if (item.name === image) {
            i = index;
          }
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
      if (i > -1) {
        this.tmp_files.splice(i, 1);
      }
      $(frameId).html('');
      var _iterator2 = _createForOfIteratorHelper(this.tmp_files.entries()),
        _step2;
      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _step2$value = _slicedToArray(_step2.value, 2),
            _index = _step2$value[0],
            file = _step2$value[1];
          var img = "<div class='attached-files'>\n                                <img src = '".concat(URL.createObjectURL(file), "' class=\"review-image\" />\n                                <svg fill=\"currentColor\" onclick=\"window.Lightbox.RemoveImage('").concat(file.name, "','").concat(frameId, "')\" preserveAspectRatio=\"xMidYMid meet\" height=\"25\" width=\"25\" viewBox=\"0 0 40 40\" class=\"delete-review-image\" style=\"vertical-align: middle; color: rgb(51, 51, 51);\"><g><path d=\"m30.1 21.4v-2.8q0-0.6-0.4-1t-1-0.5h-17.1q-0.6 0-1 0.5t-0.5 1v2.8q0 0.6 0.5 1t1 0.5h17.1q0.6 0 1-0.5t0.4-1z m7.2-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z\"></path></g></svg>\n                            </div>");
          $(frameId).append(img);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }
    }
  }, {
    key: "PaintImage",
    value: function PaintImage(file) {
      var frameId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "#img-frames";
      var image = "<div class='attached-files'>\n                                <img src = '".concat(URL.createObjectURL(file), "' class=\"review-image\">\n                                <svg fill=\"currentColor\" onclick=\"window.Lightbox.RemoveImage('").concat(file.name, "','").concat(frameId, "')\" preserveAspectRatio=\"xMidYMid meet\" height=\"25\" width=\"25\" viewBox=\"0 0 40 40\" class=\"delete-review-image\" style=\"vertical-align: middle; color: rgb(51, 51, 51);\"><g><path d=\"m30.1 21.4v-2.8q0-0.6-0.4-1t-1-0.5h-17.1q-0.6 0-1 0.5t-0.5 1v2.8q0 0.6 0.5 1t1 0.5h17.1q0.6 0 1-0.5t0.4-1z m7.2-1.4q0 4.7-2.3 8.6t-6.3 6.2-8.6 2.3-8.6-2.3-6.2-6.2-2.3-8.6 2.3-8.6 6.2-6.2 8.6-2.3 8.6 2.3 6.3 6.2 2.3 8.6z\"></path></g></svg>\n                            </div>");
      $(frameId).append(image);
    }
  }, {
    key: "IgniteAddPhotoButton",
    value: function IgniteAddPhotoButton() {
      var _this2 = this;
      console.log("IgniteAddPhotoButton");
      imgInp.onchange = function (evt) {
        var _imgInp$files = _slicedToArray(imgInp.files, 1),
          file = _imgInp$files[0];
        if (file) {
          if (!_this2.allowedFileTypes.includes(file.type)) {
            alert(window.INVALID_FILE_TYPE);
            return;
          }
          if (file.size > 2097152) {
            // more than 2MB
            alert(window.FILE_SIZE_TOO_BIG);
            return;
          }
          _this2.PaintImage(file);
          _this2.tmp_files.push(file);
        }
      };
    }
  }, {
    key: "IgniteAddPostPhotoButton",
    value: function IgniteAddPostPhotoButton() {
      var _this3 = this;
      var handleImageInput = /*#__PURE__*/function () {
        var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee(file, targetSelector) {
          var formData, response, webpBlob, convertedFile;
          return _regeneratorRuntime().wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  if (file) {
                    _context.next = 2;
                    break;
                  }
                  return _context.abrupt("return");
                case 2:
                  if (!(file.size > 26214400)) {
                    _context.next = 5;
                    break;
                  }
                  // 25 MB = 25 * 1024 * 1024
                  alert(window.FILE_SIZE_TOO_BIG);
                  return _context.abrupt("return");
                case 5:
                  if (targetSelector === "#img-post-frames") {
                    $('#submit-post-progress').show();
                  } else if (targetSelector === "#img-comment-frames") {
                    $('#submit-comment-progress').show();
                  }
                  formData = new FormData();
                  formData.append("file", file);
                  _context.prev = 8;
                  _context.next = 11;
                  return fetch("/assets/images/convert/", {
                    method: "POST",
                    body: formData
                  });
                case 11:
                  response = _context.sent;
                  if (response.ok) {
                    _context.next = 18;
                    break;
                  }
                  _context.t0 = Error;
                  _context.next = 16;
                  return response.text();
                case 16:
                  _context.t1 = _context.sent;
                  throw new _context.t0(_context.t1);
                case 18:
                  _context.next = 20;
                  return response.blob();
                case 20:
                  webpBlob = _context.sent;
                  // Preview
                  _this3.PaintImage(webpBlob, targetSelector);
                  convertedFile = new File([webpBlob], file.name.replace(/\.(heic|heif|jpeg|jpg|png|gif|bmp|webp)$/i, ".webp"), {
                    type: "image/webp"
                  });
                  _this3.tmp_files.push(convertedFile);
                  if (targetSelector === "#img-post-frames") {
                    $('#submit-post-progress').hide();
                  } else if (targetSelector === "#img-comment-frames") {
                    $('#submit-comment-progress').hide();
                  }
                  _context.next = 30;
                  break;
                case 27:
                  _context.prev = 27;
                  _context.t2 = _context["catch"](8);
                  alert("Conversion failed: " + _context.t2.message);
                case 30:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, null, [[8, 27]]);
        }));
        return function handleImageInput(_x, _x2) {
          return _ref.apply(this, arguments);
        };
      }();

      //const handleImageInput = async (file, targetSelector) => {
      //    if (!file) return;

      //    const isHeifOrHeic = (
      //        file.name.toLowerCase().endsWith(".heic") ||
      //        file.name.toLowerCase().endsWith(".heif") ||
      //        file.type === "image/heic" ||
      //        file.type === "image/heif"
      //    );

      //    if (isHeifOrHeic) {
      //        if (targetSelector === "#img-post-frames") {
      //            $('#submit-post-progress').show();
      //        } else if (targetSelector === "#img-comment-frames") {
      //            $('#submit-comment-progress').show();
      //        }
      //        if (file.size > 2097152) {
      //            alert(window.FILE_SIZE_TOO_BIG);
      //            return;
      //        }

      //        const formData = new FormData();
      //        formData.append("file", file);

      //        try {
      //            const response = await fetch("/assets/images/convert/heic", {
      //                method: "POST",
      //                body: formData
      //            });

      //            if (!response.ok) throw new Error("Server error during HEIC/HEIF conversion");

      //            const blob = await response.blob(); // You can call it just `blob`

      //            this.PaintImage(blob, targetSelector);

      //            const convertedFile = new File(
      //                [blob],
      //                file.name.replace(/\.(heic|heif)$/i, ".webp"),
      //                { type: "image/webp" }
      //            );

      //            this.tmp_files.push(convertedFile);
      //            if (targetSelector === "#img-post-frames") {
      //                $('#submit-post-progress').hide();
      //            } else if (targetSelector === "#img-comment-frames") {
      //                $('#submit-comment-progress').hide();
      //            }
      //        } catch (error) {
      //            alert("Conversion failed: " + error.message);
      //        }

      //    } else {
      //        if (!this.allowedFileTypes.includes(file.type)) {
      //            alert(window.INVALID_FILE_TYPE);
      //            return;
      //        }

      //        if (file.size > 2097152) {
      //            alert(window.FILE_SIZE_TOO_BIG);
      //            return;
      //        }

      //        this.PaintImage(file, targetSelector);
      //        this.tmp_files.push(file);
      //    }
      //};

      if (imgInpPost !== undefined) {
        imgInpPost.onchange = function (evt) {
          var _imgInpPost$files = _slicedToArray(imgInpPost.files, 1),
            file = _imgInpPost$files[0];
          handleImageInput.call(_this3, file, "#img-post-frames");
        };
      }
      if (imgInpComment !== undefined) {
        imgInpComment.onchange = function (evt) {
          var _imgInpComment$files = _slicedToArray(imgInpComment.files, 1),
            fileComment = _imgInpComment$files[0];
          handleImageInput.call(_this3, fileComment, "#img-comment-frames");
        };
      }
    }
  }]);
  return Lightbox;
}();
var _default = Lightbox;
exports["default"] = _default;

},{}],3:[function(require,module,exports){
'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
function _readOnlyError(name) { throw new TypeError("\"" + name + "\" is read-only"); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function (_e2) { function e(_x2) { return _e2.apply(this, arguments); } e.toString = function () { return _e2.toString(); }; return e; }(function (e) { throw e; }), f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function (_e3) { function e(_x3) { return _e3.apply(this, arguments); } e.toString = function () { return _e3.toString(); }; return e; }(function (e) { didErr = true; err = e; }), f: function f() { try { if (!normalCompletion && it["return"] != null) it["return"](); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
var DataContainer = /*#__PURE__*/_createClass(function DataContainer() {
  var dataState = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var pagerContainer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "";
  var forumMode = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
  var topicId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
  var categoryId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
  var moderator = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
  _classCallCheck(this, DataContainer);
  this.dataState = dataState; // Object
  this.pagerContainer = pagerContainer; // String
  this.forumMode = forumMode; // String
  this.topicId = topicId; // int
  this.moderator = moderator; // bool
  this.categoryId = categoryId; // int  
});
var SocialProfile = /*#__PURE__*/function () {
  function SocialProfile(lightbox, cookie) {
    var _this = this;
    _classCallCheck(this, SocialProfile);
    this.dataStateMap = new Map();
    this.notificationChangeState = false;
    this.JumpToPostId = 0;
    this.jumpToCommentId = 0;
    this.LoadedComments = [];
    this.now = moment().utc();
    //this.TopicId = 0;
    //this.CategoryId = 0;
    this.Cookie = cookie;
    this.Lightbox = lightbox;
    this.LoadedComments = [];
    this.MyPendingComments = [];
    this.MyProfile = {};
    this.DeviceId = localStorage.getItem('SocialProfileDevice');
    this.AnonSocialProfileLikes = [];
    this.imagepath = "/content/dist/social/brokers/images/";
    this.avatarPath = "".concat(window.assetServer, "/assets/images/profiles/");
    this.imagePathComment = this.imagePathForum = "".concat(window.assetServer, "/assets/images/forum/");
    this.findUserPostsSummaryUrl = '/admin/socialprofile/moderation/user/activity/summary';
    this.findUserActivityStatusUrl = '/admin/socialprofile/moderation/user/activity/status';
    this.banUserUrl = '/admin/socialprofile/moderation/user/ban';
    this.updateUserActivityURl = '/admin/socialprofile/moderation/user/activity/update';
    this.SaveNewComment = this.SaveNewComment.bind(this);
    $('#heart-rate li').click(function () {
      if ($('#no-rating-checkbox').is(":checked")) {
        $('#no-rating-checkbox').trigger("click");
      }
      $('#heart-rate li').removeClass('clicked');
      $('.hovered').addClass('clicked');
      $('#review-rating').val($('#heart-rate li.clicked').length);
    });
    $(document).on("click", ".postPager a", function (event) {
      var data = {};
      var containerIdValue = '';
      var CurrentPage = event.target.href;
      var query = CurrentPage.split("?");
      if (query[1] !== undefined && query[1] !== null) {
        var urlParams = new URLSearchParams(query[1]);
        var entries = urlParams.entries(); //returns an iterator of decoded [key,value] tuples
        var _iterator = _createForOfIteratorHelper(entries),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _step$value = _slicedToArray(_step.value, 2),
              key = _step$value[0],
              value = _step$value[1];
            // each 'entry' is a [key, value] tupple
            data[key] = value;
            if (key === 'ContainerId' || key === 'containerId') {
              containerIdValue = value;
            }
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      $.ajax({
        url: query[0],
        type: 'Post',
        cache: false,
        data: data,
        success: function success(result) {
          var currentState = _this.GetState(containerIdValue);
          currentState.dataState = result;
          if (result.ForumMode !== undefined && result.ForumMode === "latest") {
            if (result.Posts.length) {
              _this.WaitForProcessLatestPostsForumData(containerIdValue).then(function () {
                var el = document.getElementById('activity-head');
                el.scrollIntoView({
                  block: "start",
                  behavior: 'smooth'
                });
              });
            }
          } else if (result.ForumMode !== undefined && result.ForumMode === "activity") {
            if (result.Posts.length) {
              _this.WaitForProcessReviewDataFeed(containerIdValue).then(function () {
                var el = document.getElementById('activity-head');
                el.scrollIntoView({
                  block: "start",
                  behavior: 'smooth'
                });
              });
            }
          } else if (result.ForumMode !== undefined && result.ForumMode === "review-comments") {
            if (result.Posts.length) {
              _this.WaitForProcessReviewCommentsFeedData(containerIdValue).then(function () {
                var el = document.getElementById('activity-head');
                el.scrollIntoView({
                  block: "start",
                  behavior: 'smooth'
                });
              });
            }
          } else {
            _this.CurrentForumMode = 'InlineForum';
            if (result.reviewModel.Posts.length) {
              _this.WaitForProcessInlineForumData(0, 0, containerIdValue).then(function () {
                var el = document.getElementById(containerIdValue);
                el.scrollIntoView({
                  block: "start",
                  behavior: 'smooth'
                });
              });
            } else {}
          }
          if ($('#forum-items-container').length) {
            _this.Lightbox.InitializeLBImages('forum-items-container');
          }
          if ($('#inline-forum-template').length) {
            _this.Lightbox.InitializeLBImages('inline-forum-template');
          }
          if ($('#activity-list-wrap').length) {
            _this.Lightbox.InitializeLBImages('activity-list-wrap');
          }
        },
        error: function error(result) {
          alert("there was an error");
        }
      });
      return false;
    });
    $(document).on("click", "#VotePager a", function (event) {
      var data = {};
      var CurrentTransactionListPage = event.target.href;
      ;
      var query = CurrentTransactionListPage.split("?");
      if (query[1] !== undefined && query[1] !== null) {
        var urlParams = new URLSearchParams(query[1]);
        var entries = urlParams.entries(); //returns an iterator of decoded [key,value] tuples
        var _iterator2 = _createForOfIteratorHelper(entries),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _step2$value = _slicedToArray(_step2.value, 2),
              key = _step2$value[0],
              value = _step2$value[1];
            // each 'entry' is a [key, value] tupple
            data[key] = value;
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
      $.ajax({
        url: query[0],
        type: 'Post',
        cache: false,
        data: data,
        success: function success(result) {
          if (result.Votes !== null && result.Votes !== undefined) {
            _this.WaitForProcessVotesFeedData(result.Votes).then(function () {
              var el = document.getElementById('activity-head');
              el.scrollIntoView({
                block: "start",
                behavior: 'smooth'
              });
            });
          }
        },
        error: function error(result) {
          alert("there was an error");
        }
      });
      return false;
    });
    $(document).on("click", "#ReviewPager a, #RejectedReviewPager a", function () {
      var data = {
        brokerId: window.SocialProfile.brokerId
      };
      var CurrentTransactionListPage = $(this).attr("href");
      var query = CurrentTransactionListPage.split("?");
      if (query[1] !== undefined && query[1] !== null) {
        var urlParams = new URLSearchParams(query[1]);
        var entries = urlParams.entries(); //returns an iterator of decoded [key,value] tuples
        var _iterator3 = _createForOfIteratorHelper(entries),
          _step3;
        try {
          for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
            var _step3$value = _slicedToArray(_step3.value, 2),
              key = _step3$value[0],
              value = _step3$value[1];
            // each 'entry' is a [key, value] tupple
            data[key] = value;
          }
        } catch (err) {
          _iterator3.e(err);
        } finally {
          _iterator3.f();
        }
      }
      $.ajax({
        url: query[0],
        type: 'Post',
        cache: false,
        data: data,
        success: function success(result) {
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          //        AjaxComplete();
          window.SocialProfile.ProcessReviewData(result, data, false);
          //return false;
        },

        error: function error(result) {
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          //        AjaxComplete();
          alert("there was an error");
          //return false;
        }
      });

      return false;
    });
    $('.validation-error-killer').on('click', function () {
      $(_this).removeClass("form-control-danger").closest(".form-group").removeClass("has-danger");
      $(_this).parent().find('.form-control-feedback').hide();
    });
    $(document).on('click', '.social-posting-navigate', function (e) {
      var entityId = $(e.target).data('entity-id');
      var topicId = $(e.target).data('topic-id');
      var entityType = $(e.target).data('entity-type');
      var expireNotification = $(e.target).data('expire-notification');
      if (isNaN(expireNotification)) {
        expireNotification = 0;
      }
      if (isNaN(topicId)) {
        topicId = 0;
      }
      if (window.CURRENT_LANG === window.DEFAULT_LANG) {
        if (isNaN(entityId)) {
          entityId = 0;
        }
        document.location.href = "/social-post/find/" + entityType + "/" + entityId + "/" + topicId + "/" + expireNotification;
      } else {
        var langSlug = "/" + CURRENT_LANG;
        document.location.href = langSlug + "/social-post/find/" + entityType + "/" + entityId + "/" + topicId + "/" + expireNotification;
      }
    });
  }

  // Method to add a key-value pair
  _createClass(SocialProfile, [{
    key: "AddState",
    value: function AddState(key) {
      var dataState = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
      var pagerId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var forumMode = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'InlineForum';
      var topicId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 0;
      var moderator = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : false;
      if (typeof key === "string") {
        var entry = new DataContainer(dataState, pagerId, forumMode, topicId, moderator);
        this.dataStateMap.set(key, entry);
      } else {
        alert("Invalid key type. " + key);
      }
    }
    // Method to remove a key-value pair
  }, {
    key: "RemoveState",
    value: function RemoveState(key) {
      this.dataStateMap["delete"](key);
    }
    // Method to get the value by key
  }, {
    key: "GetState",
    value: function GetState(key) {
      return this.dataStateMap.get(key);
    }
    // Method to check if a key exists
  }, {
    key: "HasState",
    value: function HasState(key) {
      return this.dataStateMap.has(key);
    }
  }, {
    key: "FindUserActivityStatus",
    value: function FindUserActivityStatus(id) {
      return $.ajax({
        url: this.findUserActivityStatusUrl,
        type: 'POST',
        cache: false,
        data: {
          SocialProfileId: id
        },
        success: function success(result) {},
        error: function error(result) {
          alert("there was an error");
        }
      });
    }
  }, {
    key: "UpdateUserActivity",
    value: function UpdateUserActivity(data) {
      return $.ajax({
        url: this.updateUserActivityURl,
        type: 'POST',
        cache: false,
        data: data,
        success: function success(result) {},
        error: function error(result) {
          alert("there was an error");
        }
      });
    }
  }, {
    key: "SetUserAsBanned",
    value: function SetUserAsBanned(data) {
      return $.ajax({
        url: this.banUserUrl,
        type: 'POST',
        cache: false,
        data: data,
        success: function success(result) {},
        error: function error(result) {
          alert("there was an error");
        }
      });
    }
  }, {
    key: "FindUserPosts",
    value: function FindUserPosts(id) {
      return $.ajax({
        url: this.findUserPostsSummaryUrl,
        type: 'POST',
        cache: false,
        data: {
          SocialProfileId: id
        },
        success: function success(result) {},
        error: function error(result) {
          alert("there was an error");
        }
      });
    }
  }, {
    key: "RemoveUserActivity",
    value: function RemoveUserActivity(id) {
      var _this2 = this;
      this.ResetPopOverMenus();
      $('#confirmationModal').on('hidden.bs.modal', function () {
        $('#confirmation-control').on('click', null);
        $('#confirmation-control').unbind('click');
        $('#confirmationModal').unbind('hidden.bs.modal');
      });
      $('#confirmation-message-body').html("Searching for user activity...");
      $('#confirmation-buttons').hide();
      $('#confirmation-progress').show();
      $('#confirmationModal').modal('show');
      this.FindUserPosts(id).done(function (data) {
        $('#confirmation-message-body').html(data.pageView);
        $('#confirmation-buttons').show();
        $('#confirmation-progress').hide();
        $('#confirmation-control').on('click', function () {
          $('#confirmation-progress').show();
          var state = {};
          state.Review = false;
          state.Comment = false;
          state.Vote = false;
          state.Post = false;
          state.Topic = false;
          state.SocialProfileId = id;
          if ($('#review_activity').is(':checked')) {
            state.Review = true;
          }
          if ($('#comment_activity').is(':checked')) {
            state.Comment = true;
          }
          if ($('#vote_activity').is(':checked')) {
            state.Vote = true;
          }
          if ($('#post_activity').is(':checked')) {
            state.Post = true;
          }
          if ($('#topic_activity').is(':checked')) {
            state.Topic = true;
          }
          _this2.UpdateUserActivity(state).done(function (d) {
            $('#confirmationModal').modal('hide');
            $('#confirmation-progress').hide();
            $('#confirmation-control').on('click', null);
            $('#confirmation-control').unbind('click');
            $('#confirmationModal').unbind('hidden.bs.modal');
            SearchSocialProfile();
            if (d.done == true) {
              toastr.success("User activity has been updated");
            } else {
              toastr.error("No user activity was updated");
            }
          }).fail(function (d) {
            $('#confirmationModal').modal('hide');
            $('#confirmation-progress').hide();
            $('#confirmation-control').on('click', null);
            $('#confirmation-control').unbind('click');
            $('#confirmationModal').unbind('hidden.bs.modal');
            toastr.error("An error has occurred");
          });
        });
      });
    }
  }, {
    key: "CurtailUserActivity",
    value: function CurtailUserActivity(id) {
      var _this3 = this;
      this.ResetPopOverMenus();
      $('#confirmationModal').on('hidden.bs.modal', function () {
        $('#confirmation-control').on('click', null);
        $('#confirmation-control').unbind('click');
        $('#confirmationModal').unbind('hidden.bs.modal');
      });
      $('#confirmation-message-body').html("Reading current user activity status...");
      $('#confirmation-buttons').hide();
      $('#confirmation-progress').show();
      $('#confirmationModal').modal('show');
      this.FindUserActivityStatus(id).done(function (data) {
        $('#confirmation-message-body').html(data.pageView);
        $('#confirmation-buttons').show();
        $('#confirmation-progress').hide();
        $('#confirmation-control').on('click', function () {
          $('#confirmation-progress').show();
          var state = {};
          state.Review = false;
          state.Comment = false;
          state.Vote = false;
          state.SocialProfileId = id;
          state.Topic = false;
          state.Message = $('#ban-message').val();
          if ($('#topic_activity').is(':checked')) {
            state.Topic = true;
          }
          if ($('#post_activity').is(':checked')) {
            state.Post = true;
          }
          if ($('#review_activity').is(':checked')) {
            state.Review = true;
          }
          if ($('#comment_activity').is(':checked')) {
            state.Comment = true;
          }
          if ($('#vote_activity').is(':checked')) {
            state.Vote = true;
          }
          _this3.SetUserAsBanned(state).done(function (d) {
            $('#confirmationModal').modal('hide');
            $('#confirmation-progress').hide();
            $('#confirmation-control').on('click', null);
            $('#confirmation-control').unbind('click');
            $('#confirmationModal').unbind('hidden.bs.modal');
            if (d.done == true) {
              toastr.success("User posting permissions have been successfully updated");
            } else {
              toastr.error("NUser posting permissions remain unchanged");
            }
          }).fail(function (d) {
            $('#confirmationModal').modal('hide');
            $('#confirmation-progress').hide();
            $('#confirmation-control').on('click', null);
            $('#confirmation-control').unbind('click');
            $('#confirmationModal').unbind('hidden.bs.modal');
            toastr.error("An error has occurred");
          });
        });
      });
    }
  }, {
    key: "ReviewPager",
    value: function ReviewPager() {}
  }, {
    key: "AcknowledgeNotification",
    value: function AcknowledgeNotification(notificationId) {
      if (isNaN(notificationId)) {} else {
        if (window.CURRENT_LANG === window.DEFAULT_LANG) {
          document.location.href = "/notification/execute/" + notificationId;
        } else {
          var langSlug = "/" + CURRENT_LANG;
          document.location.href = langSlug + "/notification/execute/" + notificationId;
        }
      }
    }
  }, {
    key: "IgniteReviews",
    value: function IgniteReviews(brokerId) {
      this.brokerId = brokerId;
      this.LoadReviews();
      this.LoadCustomReviewData();

      // this.LoadMTBrokers();
    }
  }, {
    key: "IgniteMiniReviews",
    value: function IgniteMiniReviews(brokerId) {
      this.LoadMiniReviews(brokerId, 0);
    }
  }, {
    key: "IgniteInlineForum",
    value: function IgniteInlineForum(topicId, jumpToPostId) {
      var counterId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var jumpToCommentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var containerId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'inline-forum';
      this.LoadTopicPosts(topicId, jumpToPostId, counterId, jumpToCommentId, containerId);
      this.Lightbox.IgniteAddPostPhotoButton();
    }
  }, {
    key: "IgniteForumTopicPage",
    value: function IgniteForumTopicPage(topicId, jumpToPostId) {
      var jumpToCommentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      /*this.TopicId = topicId;*/
      this.InitForumTopicPage(topicId, jumpToPostId, jumpToCommentId);
      this.Lightbox.IgniteAddPostPhotoButton();
    }
  }, {
    key: "IgnitePopOverMenus",
    value: function IgnitePopOverMenus() {
      $('[data-toggle="post-edit-menu"]').popover({
        html: true,
        trigger: "click",
        container: 'body',
        content: function content() {
          var postId = $(this).data('postid');
          var authorId = $(this).data('authorid');
          var commentId = $(this).data('commentid');
          var containerKey = $(this).data('forum-holder');
          var out = '';
          if (parseInt(commentId, 10) > 0) {
            out = "<div class=\"post-edit-menu-options\">\n                        <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.OpenCommentForEdit('".concat(containerKey, "',").concat(commentId, ", ").concat(postId, ")\">").concat(window.EDIT_COMMENT, "</a>\n                        <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.DeleteComment('").concat(containerKey, "',").concat(commentId, ", ").concat(postId, ")\">").concat(window.DELETE_COMMENT, "</a>");
            if (window.SocialProfile.moderator) {
              out += " <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.CurtailUserActivity(".concat(authorId, ")\">Ban user</a>\n                            <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.RemoveUserActivity(").concat(authorId, ")\">Scrub user activity</a>");
            }
            out += "</div>";
          } else {
            out = "<div class=\"post-edit-menu-options\">\n                        <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.OpenPostForEdit('".concat(containerKey, "',").concat(postId, ")\">").concat(window.EDIT_POST, "</a>\n                        <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.DeletePost('").concat(containerKey, "',").concat(postId, ")\">").concat(window.DELETE_POST, "</a>");
            if (window.SocialProfile.moderator) {
              out += " <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.CurtailUserActivity(".concat(authorId, ")\">Ban user</a>\n                            <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.RemoveUserActivity(").concat(authorId, ")\">Scrub user activity</a>");
            }
            out += "</div>";
          }
          return out;
        }
      });
      $('[data-toggle="comment-edit-menu"]').popover({
        html: true,
        trigger: "click",
        container: 'body',
        content: function content() {
          var commentId = $(this).data('commentid');
          var authorId = $(this).data('authorid');
          var postId = $(this).data('postid');
          var containerKey = $(this).data('forum-holder');
          var out = "<div class=\"comment-edit-menu-options\">\n                        <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.OpenCommentForEdit('".concat(containerKey, "',").concat(commentId, ", ").concat(postId, ")\">").concat(window.EDIT_COMMENT, "</a>\n                        <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.DeleteComment('").concat(containerKey, "',").concat(commentId, ", ").concat(postId, ")\">").concat(window.DELETE_COMMENT, "</a>");
          if (window.SocialProfile.moderator) {
            out += " <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.CurtailUserActivity(".concat(authorId, ")\">Ban user</a>\n                            <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.RemoveUserActivity(").concat(authorId, ")\">Scrub user activity</a>");
          }
          out += "</div>";
          return out;
        }
      });
      $('body').on('click', function (e) {
        window.SocialProfile.ResetPopOverMenus(e);
      });
    }
  }, {
    key: "IgniteReviewerStatusTooltip",
    value: function IgniteReviewerStatusTooltip() {
      $('.reviewer-status.unverified').tooltip('dispose').tooltip({
        boundary: 'window',
        title: window.APPROVED_REVIEWER_POPOVER
      });
      $('.reviewer-status.verified').tooltip('dispose').tooltip({
        boundary: 'window',
        title: window.VERIFIED_REVIEWER_POPOVER
      });
    }
  }, {
    key: "ResetPopOverMenus",
    value: function ResetPopOverMenus(e) {
      if (e === undefined) {
        $('body').trigger('click');
      } else {
        $('[data-toggle="post-edit-menu"]').each(function () {
          // Hide the popover when clicking outside
          if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
            $(this).popover('hide');
          }
        });
        $('[data-toggle="comment-edit-menu"]').each(function () {
          // Hide the popover when clicking outside
          if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
            $(this).popover('hide');
          }
        });
      }
    }
  }, {
    key: "LoadNotificationsSummary",
    value: function LoadNotificationsSummary() {
      var _this4 = this;
      $.ajax({
        url: forumNotificationsSummaryUrl,
        type: 'POST',
        cache: false,
        success: function success(result) {
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope

          if (result && !result.isError && result.data && result.data.length) {
            $('#notifications-popover-payload').html('');
            result.data.forEach(function (num, index) {
              $('#notifications-popover-payload').append(_this4.RenderNotification(result.data[index]));
            });
            $('#notifications-popover-payload').append(_this4.RenderNotificationFooter());
            if (result.hasNew) {
              $('.notification-ellipse-icon').show();
            }
          } else {
            $('#notifications-popover-payload').html('No new notifications');
          }
        },
        error: function error(result) {
          $('#notifications-popover-payload').html('Notifications could not be loaded');
        }
      });
    }
  }, {
    key: "IgniteLatestPostsList",
    value: function IgniteLatestPostsList() {
      this.LoadLatestPosts(1, 'forum-list-wrap');
      this.Lightbox.IgniteAddPostPhotoButton();
    }
  }, {
    key: "ProbeInlineForum",
    value: function ProbeInlineForum(entityId, entityType) {
      var _this5 = this;
      var counterId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var forumContainerId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : '';
      var forumPagerId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
      var addId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : '';
      var subscribeId = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : '';
      var startButtonId = arguments.length > 7 ? arguments[7] : undefined;
      var tabId = arguments.length > 8 && arguments[8] !== undefined ? arguments[8] : '';
      var callback = arguments.length > 9 && arguments[9] !== undefined ? arguments[9] : '';
      var urlParams = new URLSearchParams(window.location.search);
      var commentId = urlParams.get('commentId');
      var postId = urlParams.get('postId');
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.forumProbeUrl,
        dataType: "json",
        data: {
          entityId: entityId,
          entityType: entityType,
          postId: postId,
          commentId: commentId,
          containerId: forumContainerId
        },
        success: function success(result) {
          if (result.success == true) {
            if (tabId !== '') {
              $("#" + tabId).show();
            }
            _this5.AddState(forumContainerId, result, forumPagerId, 'InlineForum', result.reviewModel.TopicId);
            _this5.moderator = result.Moderate == true;
            if (result.topicExists) {
              if (addId !== '') {
                $("#" + addId).show();
              }
              if (subscribeId !== '') {
                $("#" + subscribeId).show();
              }
              if (counterId !== '' && counterId !== undefined && parseInt(result.reviewModel.TotalPostAndReplies, 10) > 0 && counterId !== null && $('#' + counterId).length) {
                var outString = $('#' + counterId).html();
                $('#' + counterId).html(outString.replace("0", result.reviewModel.TotalPostAndReplies));
              } else if (counterId !== '' && counterId !== undefined && parseInt(result.reviewModel.TotalPosts, 10) > 0 && counterId !== null && $('#' + counterId).length) {
                var _outString = $('#' + counterId).html();
                $('#' + counterId).html(_outString.replace("0", result.reviewModel.TotalPosts));
              }
              _this5.ProcessInlineForumData(postId, commentId, forumContainerId);
            } else {
              if (startButtonId !== '') {
                $("#" + startButtonId).show();
              }
              if ($("#".concat(forumContainerId)).length) {
                $("#".concat(forumContainerId)).html("<h3>".concat(window.BE_THE_FIRST_PERSON_TO_POST_IN_THIS_DISCUSSION, "</h3>"));
              }
            }
          }
          if (callback !== '') {
            if (typeof callback == "string") {
              window[callback](result);
            }
          }
        },
        error: function error(result) {}
      });
    }
  }, {
    key: "IgniteActivityList",
    value: function IgniteActivityList(result) {
      if (result.forum != null && result.forum.Posts != null) {
        var containerId = 'activity-list-wrap';
        this.AddState(containerId, result.forum, 'activity-list-wrap-pager', 'LatestPosts', 0, result.Moderate == true);
        this.ProcessLatestPostsForumData(containerId);
      }
      if (result.review != null && result.review.Posts != null) {
        var _containerId = 'review-list-wrap';
        this.AddState(_containerId, result.review, 'review-list-wrap-pager', 'BrokerReview', 0, result.Moderate == true);
        this.ProcessReviewFeedData(_containerId);
      }
      if (result.review_comments != null && result.review_comments != null) {
        var _containerId2 = 'review-comments-list-wrap';
        this.AddState(_containerId2, result.review_comments, 'review-comments-list-wrap-pager', 'BrokerReview', 0, result.Moderate == true);
        this.ProcessReviewCommentsFeedData(_containerId2);
      }
      this.Lightbox.InitializeLBImages('social-profile-activity');
    }
  }, {
    key: "IgniteVoteActivityList",
    value: function IgniteVoteActivityList(result) {
      if (result.List != null) {
        this.ProcessVotesFeedData(result);
      }
    }
  }, {
    key: "DeleteCategory",
    value: function DeleteCategory(categoryId) {
      $('#dialog-delete-forum-category').modal('show').data('categoryid', categoryId);
    }
  }, {
    key: "DeleteTopic",
    value: function DeleteTopic(topicId) {
      $('#dialog-delete-forum-topic').modal('show').data('topicid', topicId);
    }
  }, {
    key: "DeletePost",
    value: function DeletePost(statekey, postid) {
      $('#dialog-delete-forum-post').modal('show').data('postid', postid).data('statekey', statekey);
      $('[data-toggle="post-edit-menu"]').each(function () {
        // Hide the popover when clicking outside
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
          $(this).popover('hide');
        }
      });
    }
  }, {
    key: "DeleteComment",
    value: function DeleteComment(statekey, commentid, postid) {
      $('#dialog-delete-forum-comment').modal('show').data('postid', postid).data('commentid', commentid).data('statekey', statekey);
      $('[data-toggle="comment-edit-menu"]').each(function () {
        // Hide the popover when clicking outside
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
          $(this).popover('hide');
        }
      });
    }
  }, {
    key: "CommitSubscriptionDelete",
    value: function CommitSubscriptionDelete() {
      $('#subscription-delete-progress').show();
      var id = parseInt($('#dialog-delete-subscription').data('id'), 10);
      if (!isNaN(id) && id > 0) {
        $.ajax({
          type: "POST",
          cache: false,
          async: true,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          url: window.deleteSocialSubscriptionUrl,
          dataType: "json",
          data: {
            Id: id
          },
          success: function success(result) {
            if (result.Ok === true) {
              toastr.success(window.YOUR_SUBSCRIPTION_HAS_BEEN_DELETED);
              if ($('#subscription-row-' + id).length) {
                $('#subscription-row-' + id).remove();
              }
            } else {
              toastr.error(result.Message);
            }
            $('#subscription-delete-progress').hide();
            $('#dialog-delete-subscription').modal('hide').data('id', null);
          },
          error: function error(result) {
            $('#subscription-delete-progress').hide();
            alert("Network failure");
          }
        });
      }
    }
  }, {
    key: "CommitCategoryDelete",
    value: function CommitCategoryDelete() {
      $('#category-delete-progress').show();
      setTimeout(function () {
        var categoryId = parseInt($('#dialog-delete-forum-category').modal('show').data('categoryid'), 10);
        if (!isNaN(categoryId) && categoryId > 0) {
          $.ajax({
            type: "POST",
            cache: false,
            // ReSharper disable once UseOfImplicitGlobalInFunctionScope
            url: "/api/forum/categories/delete",
            dataType: "json",
            data: {
              categoryId: categoryId
            },
            success: function success(result) {
              if (result.Success === true) {
                toastr.success("Your category has been deleted");
                if ($('.forum-item.category[data-categoryid=' + categoryId + ']').length) {
                  $('.forum-item.category[data-categoryid=' + categoryId + ']').remove();
                }
              } else {
                toastr.error(result.Message);
              }
              $('#category-delete-progress').hide();
              $('#dialog-delete-forum-category').modal('hide').data('categoryid', null);
            },
            error: function error(result) {
              $('#category-delete-progress').hide();
              alert("Network failure");
            }
          });
        }
      }, 0);
    }
  }, {
    key: "CommitTopicDelete",
    value: function CommitTopicDelete() {
      $('#topic-delete-progress').show();
      setTimeout(function () {
        var topicId = parseInt($('#dialog-delete-forum-topic').modal('show').data('topicid'), 10);
        if (!isNaN(topicId) && topicId > 0) {
          $.ajax({
            type: "POST",
            cache: false,
            // ReSharper disable once UseOfImplicitGlobalInFunctionScope
            url: "/api/forum/topics/delete",
            dataType: "json",
            data: {
              topicId: topicId
            },
            success: function success(result) {
              if (result.Success === true) {
                toastr.success("Your discussion has been deleted");
                if ($('.forum-item.topic[data-topicid="' + topicId + '"]').length) {
                  $('.forum-item.topic[data-topicid="' + topicId + '"]').remove();
                }
              } else {
                toastr.error(result.Message);
              }
              $('#topic-delete-progress').hide();
              $('#dialog-delete-forum-topic').modal('hide').data('topicid', null);
            },
            error: function error(result) {
              $('#topic-delete-progress').hide();
              alert("Network failure");
            }
          });
        }
      }, 0);
    }
  }, {
    key: "CommitPostDelete",
    value: function CommitPostDelete() {
      var _this6 = this;
      $('#post-delete-progress').show();
      setTimeout(function () {
        var postId = parseInt($('#dialog-delete-forum-post').modal('show').data('postid'), 10);
        var statekey = $('#dialog-delete-forum-post').data('statekey');
        if (!isNaN(postId) && postId > 0) {
          $.ajax({
            type: "POST",
            cache: false,
            // ReSharper disable once UseOfImplicitGlobalInFunctionScope
            url: window.deleteSocialPostUrl,
            dataType: "json",
            data: {
              postId: postId
            },
            success: function success(result) {
              var state = _this6.GetState(statekey);
              if (result.Ok === true) {
                toastr.success(window.YOUR_POST_HAS_BEEN_DELETED);
                var _index = 0;
                if (state.forumMode === 'InlineForum') {
                  var _index2 = state.dataState.reviewModel.Posts.findIndex(function (obj) {
                    return obj.PostId === postId;
                  });
                  if (result.HasReplies === true) {
                    state.dataState.reviewModel.Posts[_index2].DeletedPost = true;
                    state.dataState.reviewModel.Posts[_index2].Content = '';
                  } else {
                    if (_index2 > -1) {
                      state.dataState.reviewModel.Posts.splice(_index2, 1); // Remove the element at the specified index
                    }
                  }

                  _this6.ProcessInlineForumData(0, 0, statekey);
                } else if (state.forumMode === 'LatestPosts') {
                  _index = state.dataState.Posts.findIndex(function (obj) {
                    return obj.EntityId === postId && obj.EntityType == 'post';
                  });
                  if (result.HasReplies === true) {
                    state.dataState.Posts[_index].DeletedPost = true;
                    state.dataState.Posts[_index].Content = '';
                  } else {
                    if (_index > -1) {
                      state.dataState.Posts.splice(_index, 1); // Remove the element at the specified index
                    }
                  }

                  _this6.ProcessLatestPostsForumData(statekey);
                }
              } else {
                toastr.error(result.Message);
              }
              $('#post-delete-progress').hide();
              $('#dialog-delete-forum-post').modal('hide').data('postid', null).data('statekey', null);
            },
            error: function error(result) {
              $('#post-delete-progress').hide();
              alert("Network failure");
            }
          });
        }
      }, 0);
    }
  }, {
    key: "CommitCommentDelete",
    value: function CommitCommentDelete() {
      var _this7 = this;
      $('#comment-delete-progress').show();
      setTimeout(function () {
        var postId = parseInt($('#dialog-delete-forum-comment').data('postid'), 10);
        var commentId = parseInt($('#dialog-delete-forum-comment').data('commentid'), 10);
        var statekey = $('#dialog-delete-forum-comment').data('statekey');
        if (!isNaN(postId) && postId > 0 && !isNaN(commentId) && commentId > 0) {
          $.ajax({
            type: "POST",
            cache: false,
            // ReSharper disable once UseOfImplicitGlobalInFunctionScope
            url: window.deleteSocialCommentUrl,
            dataType: "json",
            data: {
              postId: postId,
              commentId: commentId
            },
            success: function success(result) {
              if (result.Ok === true) {
                var state = _this7.GetState(statekey);
                var stateresult = state.dataState;
                toastr.success(window.YOUR_POST_HAS_BEEN_DELETED);
                $('#comment-delete-progress').hide();
                $('#dialog-delete-forum-comment').modal("hide");
                if (state.forumMode === 'InlineForum') {
                  var _index3 = stateresult.reviewModel.Comments.findIndex(function (obj) {
                    return obj.Id === commentId;
                  });
                  if (result.HasReplies) {
                    stateresult.reviewModel.Comments[_index3].DeletedComment = true;
                    stateresult.reviewModel.Comments[_index3].Content = '';
                    stateresult.reviewModel.Comments[_index3].Status = 'deleted';
                  } else {
                    if (_index3 > -1) {
                      stateresult.reviewModel.Comments[_index3] = stateresult.reviewModel.Comments[stateresult.reviewModel.Comments.length - 1]; // Swap with the last element
                      stateresult.reviewModel.Comments.pop(); // Remove the last element
                    }
                  }

                  _this7.ProcessInlineForumData(postId, 0, statekey);
                  var commentsForPost = stateresult.reviewModel.Comments.filter(function (obj) {
                    return obj.PostId === postId;
                  });
                  window.SocialProfile.OpenCommentToView(statekey, postId, commentsForPost);
                } else if (state.forumMode === 'LatestPosts') {
                  var _index4 = stateresult.Posts.findIndex(function (obj) {
                    return obj.EntityId === commentId && obj.EntityType === 'comment';
                  });
                  if (_index4 > -1) {
                    stateresult.Posts[_index4] = stateresult.Posts[stateresult.Posts.length - 1]; // Swap with the last element
                    stateresult.Posts.pop(); // Remove the last element
                  }

                  _this7.ProcessLatestPostsForumData(statekey);
                }
                _this7.UpdateReplyCounts(result);
              } else {
                toastr.error(result.Message);
              }
              $('#post-delete-progress').hide();
              $('#dialog-delete-forum-post').modal('hide').data('postid', null).data('statekey', null);
            },
            error: function error(result) {
              $('#post-delete-progress').hide();
              alert("Network failure");
            }
          });
        }
      }, 0);
    }
  }, {
    key: "NotRated",
    value: function NotRated() {
      $('#heart-rate li').removeClass('clicked');
      $('#review-rating').val(0);
    }
  }, {
    key: "ScrollTo",
    value: function ScrollTo(forumStateKey, elementId) {
      var postId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
      var el = document.getElementById(elementId);
      var div = $(el);
      if (div.length) {
        div.find('.review-box').first().addClass('highlight');
        setTimeout(function () {
          div.find('.review-box').removeClass('highlight');
          ;
        }, 1000);
        if (postId != undefined) {
          div.find('.review-box').first().get(0).scrollIntoView({
            block: "center",
            behavior: 'smooth'
          });
        } else {
          el.scrollIntoView({
            block: "center",
            behavior: 'smooth'
          });
        }
      } else if (parseInt(postId, 10) > 0) {
        window.SocialProfile.OpenCommentToView(forumStateKey, postId).then(function () {
          setTimeout(function () {
            var el = document.getElementById(elementId);
            div = $(el);
            el.scrollIntoView({
              block: "center",
              behavior: 'smooth'
            });
            div.find('.review-box').first().addClass('highlight');
            setTimeout(function () {
              div.find('.review-box').removeClass('highlight');
              ;
            }, 1000);
          }, 100);
        });
      }
    }
  }, {
    key: "GoToNotifications",
    value: function GoToNotifications() {
      var langSlug = "";
      if (CURRENT_LANG !== DEFAULT_LANG) {
        langSlug = "/" + CURRENT_LANG;
      }
      document.location.href = langSlug + "/dashboard/notifications";
    }
  }, {
    key: "GoToPost",
    value: function GoToPost(postId) {
      document.location.href = "/forum/go-to-post/" + postId;
    }
  }, {
    key: "GoToComment",
    value: function GoToComment(commentId, postId) {
      document.location.href = "/forum/go-to-post/" + postId + "/" + commentId;
    }
  }, {
    key: "GoToThread",
    value: function GoToThread(topicId) {
      document.location.href = "/forum/go-to-thread/" + topicId;
    }
  }, {
    key: "GoToReview",
    value: function GoToReview(reviewId) {
      document.location.href = "/forum/go-to-review/" + reviewId;
    }
  }, {
    key: "GoToReviewComment",
    value: function GoToReviewComment(commentId) {
      document.location.href = "/forum/go-to-review/comment/" + commentId;
    }
  }, {
    key: "GoToSocialProfile",
    value: function GoToSocialProfile(profileId) {
      if (profileId == null) {
        profileId = $('#social-profile-id').val();
      }
      if (profileId !== undefined && profileId !== null) {
        if (window.CURRENT_LANG === window.DEFAULT_LANG) {
          if (isNaN(profileId)) {
            profileId = 0;
          }
          document.location.href = "/social-profile/view?spid=" + profileId;
        } else {
          var langSlug = "/" + CURRENT_LANG;
          document.location.href = langSlug + "/social-profile/view?spid=" + profileId;
        }
      }
    }
  }, {
    key: "GoToStatsPage",
    value: function GoToStatsPage(statsId) {
      if (statsId !== undefined && statsId !== null) {
        if (window.CURRENT_LANG === window.DEFAULT_LANG) {
          if (isNaN(statsId)) {
            statsId = 0;
          }
          document.location.href = "/trading-account?said=".concat(statsId, "&tab=discuss");
        } else {
          var langSlug = "/" + CURRENT_LANG;
          document.location.href = langSlug + "/trading-account?said=".concat(statsId, "&tab=discuss");
        }
      }
    }
  }, {
    key: "GoToContestPage",
    value: function GoToContestPage(contestId) {
      if (contestId !== undefined && contestId !== null) {
        if (window.CURRENT_LANG === window.DEFAULT_LANG) {
          if (isNaN(contestId)) {
            contestId = 0;
          }
          document.location.href = "/contests/".concat(contestId, "?tab=discuss");
        } else {
          var langSlug = "/" + CURRENT_LANG;
          document.location.href = langSlug + "/contests/".concat(contestId, "?tab=discuss");
        }
      }
    }
  }, {
    key: "GoToThreadHostPage",
    value: function GoToThreadHostPage(threadId) {
      if (threadId !== undefined && threadId !== null) {
        if (window.CURRENT_LANG === window.DEFAULT_LANG) {
          if (isNaN(threadId)) {
            threadId = 0;
          }
          document.location.href = "/forum/go-to-thread/".concat(threadId);
        } else {
          var langSlug = "/" + CURRENT_LANG;
          document.location.href = langSlug + "/forum/go-to-thread/".concat(threadId);
        }
      }
    }
  }, {
    key: "ActivityFeed",
    value: function ActivityFeed(el, socProfId) {
      var action = $(el).val();
      $('#feed-load-progress').show();
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.feedUrl,
        dataType: "json",
        data: {
          action: action,
          socProfileId: socProfId
        },
        success: function success(result) {
          if (result.Success === true) {
            $('#activity-feed').html(result.pageView);
            $('#feed-load-progress').hide();
          } else {}
        },
        error: function error(result) {
          alert("Network failure");
        }
      });
    }
  }, {
    key: "SwitchToRejectedTab",
    value: function SwitchToRejectedTab() {
      // if spam is selected, need to switch to Rejected tab
      if ($("#check-spam").is(":checked")) {
        $('.fxv-review-tab').removeClass('fxv-review-tab-active');
        $('.fxv-review-tab[data-target="#fxv-rejected-review-content"]').addClass('fxv-review-tab-active');
        $(".fxv-review-tab-content").removeClass('fxv-review-tab-active');
        $('#fxv-rejected-review-content').addClass('fxv-review-tab-active');
      } else {
        $('.fxv-review-tab').removeClass('fxv-review-tab-active');
        $('.fxv-review-tab[data-target="#fxv-approved-review-content"]').addClass('fxv-review-tab-active');
        $(".fxv-review-tab-content").removeClass('fxv-review-tab-active');
        $('#fxv-approved-review-content').addClass('fxv-review-tab-active');
      }
    }
  }, {
    key: "FilterReviews",
    value: function FilterReviews() {
      var filter = {};
      filter.OneStar = $("#check-one").is(":checked");
      filter.TwoStar = $("#check-two").is(":checked");
      filter.ThreeStar = $("#check-three").is(":checked");
      filter.FourStar = $("#check-four").is(":checked");
      filter.FiveStar = $("#check-five").is(":checked");
      filter.Page = $('#reviews-page').val();
      filter.AccTypeId = $('#review-acc-types option:selected').val();
      filter.Sort = $('#review-sort option:selected').val();
      this.LoadReviews(filter, true);
    }
  }, {
    key: "AddReviewComment",
    value: function AddReviewComment(elementId, parentId) {
      var el = document.getElementById(elementId);
      var input = $(el).closest('div.add-comment.frn-flex-row').find('input');
      if (input.val() === "" || input.val() === undefined || input.val() === null) {
        input.closest('div.cell').addClass('has-danger');
      } else {
        if (window.userIsOnline) {
          this.SaveReviewComment(el, parentId);
        } else {
          var accountData = {};
          accountData.elId = el.id;
          accountData.parentId = parentId;
          var data = JSON.stringify(accountData);
          window.Access.LoginWithPurpose('InflateComment', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', data, 'window.SocialProfile');
        }
      }
    }
  }, {
    key: "AddReview",
    value: function AddReview(brokerId) {
      if (window.userIsOnline) {
        this.BringToReview(brokerId);
      } else {
        window.Access.LoginWithPurpose('BringToReview', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', '', 'window.SocialProfile');
      }
    }
  }, {
    key: "EditReview",
    value: function EditReview() {
      if (window.userIsOnline) {
        this.BringToAddOrEditReview();
      } else {
        window.Access.LoginWithPurpose('BringToAddOrEditReview', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', '', 'window.SocialProfile');
      }
    }
  }, {
    key: "BringToReview",
    value: function BringToReview(brokerId) {
      if (!brokerId) brokerId = this.brokerId;
      $('#dialog-add-review .has-danger').removeClass('has-danger');
      $('#no-rating-checkbox').prop('checked', false);
      $('li.clicked').removeClass('clicked');
      $('#review-rating').val('');
      $('#submit-review-progress').hide();
      $('#add-review-verified').hide();
      $('#add-review-unverified').hide();
      $('#is-verified-value').val('');
      $("#img-frames").html('');
      this.Lightbox.tmp_files = new Array();
      $('#add-review-body').show();
      $('#dialog-add-review').modal('show');
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.verifyForBrokerUrl,
        dataType: "json",
        data: {
          brokerId: brokerId
        },
        success: function success(result) {
          if (result.isVerified) {
            $('#add-review-verified').show();
            $('#is-verified-value').val('1');
          } else {
            $('#add-review-unverified').show();
            $('#is-verified-value').val('0');
          }
        },
        error: function error(result) {}
      });
    }
  }, {
    key: "BringToEditReview",
    value: function BringToEditReview() {
      var _this8 = this;
      $('#add-review-body').hide();
      $('#submit-review-progress').show();
      $('#dialog-add-review').modal('show');
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.editReviewUrl,
        dataType: "json",
        data: {
          brokerId: this.brokerId
        },
        success: function success(result) {
          $('#add-review-body').html(result.output);
          $('#add-review-body').show();
          $('#submit-review-progress').hide();
          _this8.IgniteForm();
        },
        error: function error(result) {}
      });
    }
  }, {
    key: "ExpandPostPreview",
    value: function ExpandPostPreview(entityType, entityId, action) {
      var textbox = $('#post-box-' + entityType + "-" + entityId).find('.text-body');
      var $this = $(textbox);
      var targetHeight = $this.data('target-height');
      var fade = $this.next('.preview-fade');
      var shown = $(fade).next('.preview-show');
      if (action == "open") {
        $this.animate({
          'max-height': targetHeight
        }, 500, function () {
          $(shown).show().css('display', 'flex');
          $(fade).hide();
        });
      } else {
        $(shown).hide();
        $(fade).show(); //.css('background', 'linear-gradient(180deg,rgba(244,245,247,0) 1.04%,#f4f5f7 55.78%)');

        $this.animate({
          'max-height': 96
        }, 500);
      }
    }
  }, {
    key: "InflateComment",
    value: function InflateComment() {
      var dataString = $('#loginModal').data('task-data');
      $('#loginModal').removeData('task-data');
      $('#loginModal').removeData('callback');
      var data = JSON.parse(dataString);
      var el = $('#' + data.elId);
      this.SaveReviewComment(el, data.parentId);
    }
  }, {
    key: "SaveReviewComment",
    value: function SaveReviewComment(el, parentId) {
      var _this9 = this;
      var url = window.postBrokerReviewCommentUrl;
      var data = {};
      var input = $(el).closest('div.add-comment.frn-flex-row').find('input');
      if (input.val() === "" || input.val() === undefined || input.val() === null) {
        input.closest('div.cell').addClass('has-danger');
      } else {
        data = {
          parentId: parentId,
          entityId: this.brokerId,
          body: input.val(),
          Action: 'ReviewComment'
        };
        input.closest('div.cell').removeClass('has-danger').find('.progress').show();
        $.ajax({
          type: "POST",
          cache: false,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          url: url,
          dataType: "json",
          data: data,
          success: function success(result) {
            if (result.Success) {
              toastr.success(window.YOUR_COMMENT_HAS_BEEN_SUBMITTED);
              var comm = _this9.RenderComment(result.Comment, '');
              input.closest('div.cell').removeClass('has-danger').find('.progress').hide();
              $('#comment-list-' + parentId).append(comm);
              _this9.now = moment().utc();
              _this9.AddToReviewComments(result.Comment);
            } else {
              input.closest('div.cell').addClass('has-danger').find('.progress').hide();
              if (result.Message != undefined && result.Message != "") {
                toastr.error(result.Message);
              }
            }
          },
          error: function error(result) {
            input.closest('div.cell').addClass('has-danger').find('.progress').hide();
            alert("Network failure");
          }
        });
      }
      ;
    }
  }, {
    key: "SaveReply",
    value: function SaveReply(el, postId, replyToCommentId) {
      var _this10 = this;
      var url = window.postCommentReplyUrl;
      var data = {};
      var input = $(el).closest('div.add-reply.frn-flex-row').find('input');
      if (input.val() === "" || input.val() === undefined || input.val() === null) {
        input.closest('div.cell').addClass('has-danger');
      } else {
        input.closest('div.cell').removeClass('has-danger').find('.progress').show();
        data = {
          parentId: replyToCommentId,
          grandParentId: postId,
          entityId: this.brokerId,
          body: input.val(),
          Action: 'ReviewCommentReply'
        };
        $.ajax({
          type: "POST",
          cache: false,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          url: url,
          dataType: "json",
          data: data,
          success: function success(result) {
            if (result.Success) {
              _this10.now = moment().utc();
              input.closest('div.cell').find('.progress').hide();
              input.val('');
              var comm = '';
              _this10.now = moment().utc();
              comm = _this10.RenderReply(result.Comment, '');
              $('#reply-list-' + result.Comment.ReplyToCommentId).append(comm);
              _this10.IgnitePopOverMenus();
              _this10.IgniteReviewerStatusTooltip();
            } else {
              input.closest('div.cell').addClass('has-danger').find('.progress').hide();
              if (result.Message != undefined && result.Message != "") {
                toastr.error(result.Message);
              }
            }
          },
          error: function error(result) {
            input.closest('div.cell').addClass('has-danger').find('.progress').hide();
            alert("Network failure");
          }
        });
      }
      ;
    }
  }, {
    key: "AddTopic",
    value: function AddTopic(categoryId, containerId) {
      this.RemoveState(containerId);
      if (window.userIsOnline) {
        this.BringToAddTopic(categoryId, containerId);
      } else {
        var data = JSON.stringify({
          categoryId: categoryId,
          containerId: containerId
        });
        window.Access.LoginWithPurpose('BringToAddTopic', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', data, 'window.SocialProfile');
      }
    }
  }, {
    key: "EditTopic",
    value: function EditTopic(topicId) {
      if (!window.userIsOnline) {
        return;
      }
      var topicDiv = $(".forum-item.topic[data-topicid=\"".concat(topicId, "\"]"));
      var title = topicDiv.find('.item-title').text();
      this.BringToEditTopic(null, {
        id: topicId,
        title: title
      });
    }
  }, {
    key: "CreateInlineTopic",
    value: function CreateInlineTopic(entityType, entityId) {
      $("#dialog-add-post #topic-title-input").hide();
      if (window.userIsOnline) {
        this.Lightbox.IgniteAddPostPhotoButton();
        this.BringToPost(entityType, entityId);
      } else {
        window.Access.LoginWithPurpose('BringToPost', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', '', 'window.SocialProfile');
      }
    }
  }, {
    key: "AddInlineEntityPost",
    value: function AddInlineEntityPost(categoryId, entityType, entityId) {
      $("#dialog-add-post #topic-title-input").hide();
      $('#dialog-add-post').data('postId', '');
      $('#dialog-add-post').data('entityType', entityType);
      $('#dialog-add-post').data('entityId', entityId);
      $('#dialog-add-post').data('categoryId', categoryId);
      var containerId = 'dummy-container-id';
      if (window.userIsOnline) {
        this.Lightbox.IgniteAddPostPhotoButton();
        this.BringToPost(containerId);
      } else {
        var data = {};
        data.containerId = containerId;
        window.Access.LoginWithPurpose('BringToPost', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', data, 'window.SocialProfile');
      }
    }
  }, {
    key: "AddPost",
    value: function AddPost(containerId) {
      $("#dialog-add-post #topic-title-input").hide();
      $('#dialog-add-post').data('postId', '');
      if (window.userIsOnline) {
        this.Lightbox.IgniteAddPostPhotoButton();
        this.BringToPost(containerId);
      } else {
        var data = {};
        data.containerId = containerId;
        window.Access.LoginWithPurpose('BringToPost', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', data, 'window.SocialProfile');
      }
    }
  }, {
    key: "EditCategory",
    value: function EditCategory(categoryId) {
      if (window.userIsOnline) {
        var categoryDiv = $(".forum-item.category[data-categoryid=\"".concat(categoryId, "\"]"));
        var weight = categoryDiv.data('categoryweight');
        var title = categoryDiv.find('.item-title').text();
        var description = categoryDiv.find('.item-description').text();
        this.BringToAddOrEditCategory({
          id: categoryId,
          title: title,
          description: description,
          weight: weight
        });
      }
    }
  }, {
    key: "AddCategory",
    value: function AddCategory() {
      if (window.userIsOnline) {
        this.BringToAddOrEditCategory();
      }
    }
  }, {
    key: "SubscribeToDiscussion",
    value: function SubscribeToDiscussion(r) {
      var state = this.GetState(r);
      if (window.userIsOnline) {
        this.BringToSubscription("Topic", state.topicId);
      } else {
        var subscribeData = {};
        subscribeData.EntityId = state.topicId;
        subscribeData.EntityType = "Topic";
        var data = JSON.stringify(subscribeData);
        window.Access.LoginWithPurpose('BringToSubscription', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', data, 'window.SocialProfile');
      }
    }
  }, {
    key: "SubscribeToReview",
    value: function SubscribeToReview() {
      if (window.userIsOnline) {
        this.BringToReviewSubscription("BrokerReviews", this.brokerId);
      } else {
        var subscribeData = {};
        subscribeData.EntityId = this.brokerId;
        subscribeData.EntityType = "BrokerBeingReviewed";
        var data = JSON.stringify(subscribeData);
        window.Access.LoginWithPurpose('BringToReviewSubscription', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', data, 'window.SocialProfile');
      }
    }
  }, {
    key: "DeleteSubscription",
    value: function DeleteSubscription(id) {
      $('#dialog-delete-subscription').data('id', id);
      $('#dialog-delete-subscription').modal('show');
    }
  }, {
    key: "AddOrEditReview",
    value: function AddOrEditReview(brokerId) {
      if (window.userIsOnline) {
        this.BringToAddOrEditReview(brokerId);
      } else {
        window.Access.LoginWithPurpose('BringToAddOrEditReview', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', '', 'window.SocialProfile');
      }
    }
  }, {
    key: "BringToSubscription",
    value: function BringToSubscription(EntityType, EntityId) {
      $('#subscribe-to-discussion-dialog-progress').addClass('hide');
      $('#subscribe-to-discussion-dialog').off('shown.bs.modal');
      if (EntityId !== undefined && EntityId !== null) {
        $('#subscribe-to-discussion-dialog').data('entityId', EntityId);
      }
      if (EntityType !== undefined && EntityType !== null) {
        $('#subscribe-to-discussion-dialog').data('entityType', EntityType);
      }
      $('#subscribe-to-discussion-dialog').modal('show');
    }
  }, {
    key: "BringToReviewSubscription",
    value: function BringToReviewSubscription() {
      var entityType = 'BrokerBeingReviewed';
      var entityId = this.brokerId;
      $('#subscribe-to-discussion-dialog-progress').addClass('hide');
      $('#subscribe-to-discussion-dialog').off('shown.bs.modal');
      if (entityId !== undefined && entityId !== null) {
        $('#subscribe-to-discussion-dialog').data('entityId', entityId);
      }
      if (entityType !== undefined && entityType !== null) {
        $('#subscribe-to-discussion-dialog').data('entityType', entityType);
      }
      $('#subscribe-to-discussion-dialog').modal('show');
    }
  }, {
    key: "BringToPost",
    value: function BringToPost(containerId) {
      $('#dialog-add-post .has-danger').removeClass('has-danger');
      $('#submit-post-progress').hide("");
      $("#img-post-frames").html('');
      this.Lightbox.tmp_files = new Array();
      $("#post-input").val("");
      $('#dialog-add-post').off('shown.bs.modal');
      $('#add-post-body').show();
      if (containerId !== undefined && containerId !== null) {
        $('#dialog-add-post').data('containerId', containerId);
      }
      this.GetNotificationStatus();
      $('#dialog-add-post').modal('show');
    }
  }, {
    key: "BringToAddOrEditReview",
    value: function BringToAddOrEditReview(brokerId) {
      var _this11 = this;
      if (!brokerId) brokerId = this.brokerId;
      $('#add-review-body').hide();
      $('#submit-review-progress').show();
      $('#dialog-add-review').modal('show');
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.editReviewUrl,
        dataType: "json",
        data: {
          brokerId: brokerId
        },
        success: function success(result) {
          if (!result.brokerImage) result.brokerImage = 'no-image';
          $("#dialog-add-review [data-id=broker-image]").attr('src', '/Content/dist/brokers/images/' + result.brokerImage + '?w=50&h=50');
          $("#dialog-add-review [data-id=broker-name]").html(result.brokerName);
          $('#add-review-body').html(result.output);
          $('#add-review-body').show();
          $('#submit-review-progress').hide();

          // this.LoadMTBrokers(brokerId);

          _this11.IgniteForm();
        },
        error: function error(result) {}
      });
    }
  }, {
    key: "IgniteForm",
    value: function IgniteForm() {
      $('#acc-type-all').click(function () {
        if ($(this).is(":checked")) {
          $('.acc-type').each(function (i, e) {
            if ($(e).is(":checked")) {} else {
              $(e).trigger('click');
            }
          });
        }
      });
      $('.acc-type').click(function () {
        if ($(this).is(":checked")) {} else {
          if ($('#acc-type-all').is(":checked")) {
            $('#acc-type-all').trigger('click');
          }
        }
      });
      $('#heart-rate li').mouseover(function () {
        var current = $(this);
        $("#heart-rate li").each(function (i) {
          $(this).addClass('hovered');
          if (i === current.index()) {
            return false;
          }
        });
      });
      $('#heart-rate li').mouseleave(function () {
        $("#heart-rate li").removeClass('hovered');
      });
      $('#heart-rate li').click(function () {
        if ($('#no-rating-checkbox').is(":checked")) {
          $('#no-rating-checkbox').trigger("click");
        }
        $('#heart-rate li').removeClass('clicked');
        $('.hovered').addClass('clicked');
        $('#review-rating').val($('#heart-rate li.clicked').length);
      });
      $('li').mouseover(function () {
        var _this12 = this;
        var current = $(this);
        $("li").each(function (i) {
          $(_this12).add('hovered');
          if (i === current.index()) {
            return false;
          }
        });
      });
      this.Lightbox.IgniteAddPhotoButton();
    }
  }, {
    key: "LoadMTBrokers",
    value: function LoadMTBrokers(brokerId) {
      if (!brokerId) brokerId = this.brokerId;
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.loadMTBrokersUrl,
        dataType: "json",
        data: {
          brokerId: brokerId
        },
        success: function success(result) {
          if (result.length > 0) {
            var options = '';
            for (var i = 0; i < result.length; i++) {
              var srv = result[i].BrokerName + ' (' + (result[i].PlatformType == 0 ? 'MT4' : 'MT5') + ')';
              options += '<option value="' + srv + '">' + srv + '</option>';
            }
            $("#mt-broker-select").append(options);
            $("#mt-broker-select-cell").show();
          } else {
            $("#mt-broker-select-cell").hide();
          }
        },
        error: function error(result) {}
      });
    }
  }, {
    key: "LoadReviews",
    value: function LoadReviews(data) {
      var _this13 = this;
      var socialProfileId = 0;
      var commentId = 0;
      if (data == undefined) {
        data = {
          brokerId: this.brokerId
        };
      } else {
        data.BrokerId = this.brokerId;
      }
      var searchParams = new URLSearchParams(window.location.search);
      if (searchParams.has('socialprofileid')) {
        socialProfileId = parseInt(searchParams.get('socialprofileid'), 10);
      }
      if (searchParams.has('commentid')) {
        commentId = parseInt(searchParams.get('commentid'), 10);
      }
      data.commentId = commentId;
      data.SocialProfileId = socialProfileId;
      if (!(data.SocialProfileId > 0)) {
        $.ajax({
          type: "POST",
          cache: false,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          url: window.loadAccountTypeRatingsUrl,
          dataType: "json",
          data: data,
          success: function success(result) {
            if (result != null) {
              $('#account-type-ratings').html(result.output);
            }
          },
          error: function error(result) {}
        });
      }
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.loadReviewsUrl,
        dataType: "json",
        data: data,
        success: function success(result) {
          if (result.reviewModel.BrokerRatings != null) {
            var fiveStarPercent = _this13.RoundNumberToTwoDecimalPlaces(result.reviewModel.BrokerRatings.PercentageFive * 100);
            var fourStarPercent = _this13.RoundNumberToTwoDecimalPlaces(result.reviewModel.BrokerRatings.PercentageFour * 100);
            var threeStarPercent = _this13.RoundNumberToTwoDecimalPlaces(result.reviewModel.BrokerRatings.PercentageThree * 100);
            var twoStarPercent = _this13.RoundNumberToTwoDecimalPlaces(result.reviewModel.BrokerRatings.PercentageTwo * 100);
            var oneStarPercent = _this13.RoundNumberToTwoDecimalPlaces(result.reviewModel.BrokerRatings.PercentageOne * 100);

            /*
            $('#rank-value').html(result.reviewModel.BrokerRatings.Rank);
            $('#rank-volume').html(result.reviewModel.BrokerRatings.RankedNthofR);
            $('#user-rating-value').html(result.reviewModel.BrokerRatings.UserRating);
            $('#user-rating-value').html(result.reviewModel.BrokerRatings.UserRating);
            */
            $('#inner-bar-five').css('width', fiveStarPercent + "%");
            $('#broker-ratings-five').html(fiveStarPercent + "%");
            $('#inner-bar-four').css('width', fourStarPercent + "%");
            $('#broker-ratings-four').html(fourStarPercent + "%");
            $('#inner-bar-three').css('width', threeStarPercent + "%");
            $('#broker-ratings-three').html(threeStarPercent + "%");
            $('#inner-bar-two').css('width', twoStarPercent + "%");
            $('#broker-ratings-two').html(twoStarPercent + "%");
            $('#inner-bar-one').css('width', oneStarPercent + "%");
            $('#broker-ratings-one').html(oneStarPercent + "%");
            $('#review-acc-type-select').html(result.reviewModel.AccountTypeSelectList);
            var spamStarPercent = 0;
            if (!result.reviewModel.BrokerRatings.ReviewCount) result.reviewModel.BrokerRatings.ReviewCount = 0;
            if (!result.reviewModel.BrokerRatings.RejectedCount) result.reviewModel.BrokerRatings.RejectedCount = 0;
            if (result.reviewModel.BrokerRatings.ReviewCount + result.reviewModel.BrokerRatings.RejectedCount != 0) spamStarPercent = _this13.RoundNumberToTwoDecimalPlaces(result.reviewModel.BrokerRatings.RejectedCount / (result.reviewModel.BrokerRatings.ReviewCount + result.reviewModel.BrokerRatings.RejectedCount) * 100);
            $('#inner-bar-spam').css('width', spamStarPercent + "%");
            $('#broker-ratings-spam').html(spamStarPercent + "%");
            $("#review-approved-review-count").html('(' + result.reviewModel.BrokerRatings.ReviewCount + ')');
            $("#review-rejected-review-count").html('(' + result.reviewModel.BrokerRatings.RejectedCount + ')');
          }
          _this13.ProcessReviewData(result, data);
        },
        error: function error(result) {}
      });
    }
  }, {
    key: "LoadMiniReviews",
    value: function LoadMiniReviews(brokerId, page) {
      var _this14 = this;
      var data = {
        brokerId: brokerId,
        page: page
      };
      $("#mini-review-paginator").html('<img src="/content/dist/images/PageElements/ajax-loader.gif" />');
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.loadMiniReviewsUrl,
        dataType: "json",
        data: data,
        success: function success(result) {
          _this14.ProcessMiniReviewData(result, data, page == 0);
          _this14.Lightbox.InitializeLBImages('review-template');
        },
        error: function error(result) {
          $("#mini-review-paginator").html('');
        }
      });
    }
  }, {
    key: "LoadLatestPosts",
    value: function LoadLatestPosts() {
      var _this15 = this;
      var page = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 1;
      var containerId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'forum-list-wrap';
      var data = {
        Page: page,
        RenderPagination: true,
        ContainerId: containerId
      };
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.loadLatestPostsUrl,
        dataType: "json",
        data: data,
        success: function success(result) {
          if (result != null) {
            _this15.AddState('forum-list-wrap', result, 'forum-list-wrap-pager', 'LatestPosts', 0, result.Moderate == true);
            _this15.moderator = result.Moderate == true;
            _this15.ProcessLatestPostsForumData('forum-list-wrap');
          }
        },
        error: function error(result) {}
      });
    }
  }, {
    key: "LoadTopicPosts",
    value: function LoadTopicPosts(topicId) {
      var _this16 = this;
      var jumpToPostId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var counterId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
      var jumpToCommentId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      var containerId = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : 'inline-forum';
      var pagerId = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 'inline-forum-pager';
      var jumpTo = parseInt(jumpToPostId, 10);
      var jumpToC = parseInt(jumpToCommentId, 10);
      if (parseInt(topicId, 10) > 0) {
        var data = {
          TopicId: topicId,
          RenderPagination: true,
          JumpToPostId: jumpTo,
          ContainerId: containerId
        };
        $.ajax({
          type: "POST",
          cache: false,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          url: window.loadInlineTopicUrl,
          dataType: "json",
          data: data,
          success: function success(result) {
            _this16.AddState(containerId, result, pagerId, 'InlineForum', topicId);
            _this16.moderator = result.Moderate == true;
            if (result != null) {
              var topicTitle = result.reviewModel.TopicTitle;
              if (topicTitle === null || topicTitle === undefined) {
                topicTitle = '';
              }
              // reload topic meta details
              //$('div.topic-meta-information').html(this.InitForumTopicMetaControl(result.reviewModel.TopicCreatedAt, result.reviewModel.TotalPostAndReplies, result.reviewModel.NumParticipants, topicId, topicTitle));

              _this16.moderator = result.Moderate == true;
              if (counterId !== '' && counterId !== undefined && parseInt(result.reviewModel.TotalPostAndReplies, 10) > 0 && counterId !== null && $('#' + counterId).length) {
                var outString = $('#' + counterId).html();
                $('#' + counterId).html(outString.replace("0", result.reviewModel.TotalPostAndReplies));
              } else if (counterId !== '' && counterId !== undefined && parseInt(result.reviewModel.TotalPosts, 10) > 0 && counterId !== null && $('#' + counterId).length) {
                var _outString2 = $('#' + counterId).html();
                $('#' + counterId).html(_outString2.replace("0", result.reviewModel.TotalPosts));
              }
              _this16.ProcessInlineForumData(jumpToPostId, jumpToC, containerId);
            }
          },
          error: function error(result) {}
        });
      }
    }
  }, {
    key: "WaitForProcessInlineForumData",
    value: function WaitForProcessInlineForumData() {
      var _this17 = this;
      var jumpToPostId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var jumpToCommentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var containerId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'inline-forum';
      return new Promise(function (resolve, reject) {
        _this17.ProcessInlineForumData(jumpToPostId, jumpToCommentId, containerId);
        resolve(true);
      });
    }
  }, {
    key: "ProcessInlineForumData",
    value: function ProcessInlineForumData() {
      var _this18 = this;
      var jumpToPostId = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
      var jumpToCommentId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var containerId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'inline-forum';
      var state = this.GetState(containerId);
      var result = state.dataState;
      var commentDivToJumpTo = '';
      var jumpTo = parseInt(jumpToPostId, 10);
      var jumpToC = parseInt(jumpToCommentId, 10);
      var myVote = '';
      var isAnon = !(result.reviewModel && result.reviewModel.MyProfile && result.reviewModel.MyProfile.Id !== null && result.reviewModel.MyProfile.Id !== undefined && parseInt(result.reviewModel.MyProfile.Id, 10) > 0);
      if (isAnon) {
        this.GetAnonLikesFromStorage();
      } else {
        this.MyProfile = result.reviewModel.MyProfile;
      }
      if (result.reviewModel == undefined || result.reviewModel == null || result.reviewModel.Posts == null || result.reviewModel.Posts.length == 0) {
        $('#' + containerId).html("<h3>".concat(window.BE_THE_FIRST_PERSON_TO_POST_IN_THIS_DISCUSSION, "</h3>"));
      } else {
        $('#' + containerId).html('');
      }
      result.reviewModel.Posts && result.reviewModel.Posts.forEach(function (num, index) {
        myVote = '';
        if (!isAnon) {
          var downString = result.reviewModel.Posts[index].DownVoters;
          var upString = result.reviewModel.Posts[index].UpVoters;
          if (upString != null && upString != '') {
            var UpVotes = upString.split(',');
            if (UpVotes.includes(result.reviewModel.MyProfile.Id.toString())) {
              myVote = 'up';
            }
          }
          if (myVote == '') {
            if (downString != null && downString != '') {
              var DownVotes = downString.split(',');
              if (DownVotes.includes(result.reviewModel.MyProfile.Id.toString())) {
                myVote = 'down';
              }
            }
          }
        } else if (_this18.AnonSocialProfileLikes.length) {
          var intId = parseInt(result.reviewModel.Posts[index].PostId, 10);
          myVote = _this18.GetAnonThumbState(intId, 'Post');
        }
        var commentsForPost = result.reviewModel.Comments.filter(function (item) {
          return item.AttachedToPostId === parseInt(result.reviewModel.Posts[index].PostId, 10);
        });
        if (result.reviewModel.Posts[index].DeletedPost !== true || commentsForPost.length > 0) {
          var post = _this18.RenderForumPost(containerId, result.reviewModel.Posts[index], myVote, result.reviewModel.TopicOwnerId);
          $('#' + containerId).append(post);
          if (commentsForPost.length > 0) {
            var doCommentDiv = true;
            if (jumpToCommentId > 0) {
              if (commentDivToJumpTo === '' && commentsForPost.filter(function (c) {
                return c.Id == jumpToCommentId;
              }).length) {
                commentDivToJumpTo = 'forum-comment-box-' + jumpToCommentId;
              }
              ;
            }
            if (doCommentDiv) {
              var commentToPaint = commentsForPost[0];
              var isLast = true;
              var numMoreComments = 0;
              var moreCommentsLink = '';
              if (commentsForPost && commentsForPost.length > 1) {
                isLast = false;
                numMoreComments = commentsForPost.length;
                moreCommentsLink = _this18.RenderMoreCommentsLink(containerId, numMoreComments, commentToPaint.AttachedToPostId);
              }
              var startWith = _this18.RenderForumComment(containerId, commentToPaint, isAnon, true, isLast);
              if (moreCommentsLink != '') {
                $('#comment-list-' + commentToPaint.AttachedToPostId).html(startWith + moreCommentsLink);
              } else {
                $('#comment-list-' + commentToPaint.AttachedToPostId).html(startWith);
              }
              $('#comment-post-' + commentToPaint.AttachedToPostId).show();
            }
          }
        }
      });
      this.Lightbox.InitializeLBImages('forum-items-container');
      this.Lightbox.InitializeLBImages('inline-forum-template');
      if (result.reviewModel.PagerHtml) {
        $('#' + containerId + '-pager').html(result.reviewModel.PagerHtml).show();
      }
      if (!isNaN(jumpTo) && jumpTo > 0 && document.getElementById('post-box-' + jumpTo) != null) {
        var div = '';
        if (!isNaN(jumpToC) && jumpToC > 0) {
          var commentsForPost = result.reviewModel.Comments.filter(function (item) {
            return item.AttachedToPostId === parseInt(jumpTo, 10);
          });
          window.SocialProfile.OpenCommentToView(containerId, jumpTo, commentsForPost).then(function () {
            document.getElementById(commentDivToJumpTo);
            div = $('#' + commentDivToJumpTo);
            div.find('.review-box').first().addClass('highlight').get(0).scrollIntoView({
              block: "center",
              behavior: 'smooth'
            });
            setTimeout(function () {
              div.find('.review-box').removeClass('highlight');
            }, 1000);
          });
        } else {
          document.getElementById('post-box-' + jumpTo).scrollIntoView({
            block: "center",
            behavior: 'smooth'
          });
          div = $('#post-box-' + jumpTo);
          div.find('.review-box').first().addClass('highlight');
          setTimeout(function () {
            div.find('.review-box').removeClass('highlight');
            ;
          }, 1000);
        }
      }
      if ($('#topic-meta-information').length) {
        if (result.reviewModel && result.reviewModel.LastPostBySocialProfileId > 0) {
          var topicTitle = result.reviewModel.TopicTitle;
          if (topicTitle === null || topicTitle === undefined) {
            topicTitle = '';
          }
          var controlHtml = this.InitForumTopicMetaControl(result.reviewModel.TopicCreatedAt, result.reviewModel.TotalPostAndReplies, result.reviewModel.NumParticipants, result.reviewModel.TopicId, topicTitle);
          $('#topic-meta-information').html(controlHtml);
        } else {
          $('#topic-meta-information').html('');
        }
      }
      this.IgnitePopOverMenus();
    }
  }, {
    key: "WaitForProcessLatestPostsForumData",
    value: function WaitForProcessLatestPostsForumData(forumStateKey) {
      var _this19 = this;
      return new Promise(function (resolve, reject) {
        _this19.ProcessLatestPostsForumData(forumStateKey);
        resolve(true);
      });
    }
  }, {
    key: "ProcessLatestPostsForumData",
    value: function ProcessLatestPostsForumData(stateForumKey) {
      var _this20 = this;
      var myVote = '';
      var stateForForum = this.GetState(stateForumKey);
      if (stateForForum instanceof DataContainer) {
        var result = stateForForum.dataState;
        var isAnon = !(result.SocialProfileId && result.SocialProfileId !== null && result.SocialProfileId !== undefined && parseInt(result.SocialProfileId, 10) > 0);
        if (isAnon) {
          this.GetAnonLikesFromStorage();
        }
        $('#' + stateForumKey).html('');
        result && result.Posts && result.Posts.forEach(function (num, index) {
          myVote = '';
          if (!isAnon) {
            var downString = result.Posts[index].DownVotes;
            var upString = result.Posts[index].UpVotes;
            if (upString != null && upString != '') {
              var UpVotes = upString.split(',');
              if (UpVotes.includes(result.SocialProfileId.toString())) {
                myVote = 'up';
              }
            }
            if (myVote == '') {
              if (downString != null && downString != '') {
                var DownVotes = downString.split(',');
                if (DownVotes.includes(result.SocialProfileId.toString())) {
                  myVote = 'down';
                }
              }
            }
          } else if (_this20.AnonSocialProfileLikes.length) {
            var intId;
            if (result.Posts[index].EntityType == "comment") {
              intId = parseInt(result.Posts[index].EntityId, 10);
              myVote = _this20.GetAnonThumbState(intId, 'ForumComment');
            } else {
              intId = parseInt(result.Posts[index].PostId, 10);
              myVote = _this20.GetAnonThumbState(intId, 'Post');
            }
          }
          $('#' + stateForumKey).append(_this20.RenderLatestForumPost(stateForumKey, result.Posts[index], myVote));
        });
        result && result.HotTopics && result && result.HotTopics.length > 0 && $('#hot-topics-list').html('');
        result && result.HotTopics && result.HotTopics.forEach(function (num, index) {
          $('#hot-topics-list').append(_this20.RenderHotTopic(result.HotTopics[index]));
        });
        if (result.PagerHtml && $('#' + stateForumKey + '-pager').length) {
          if ($('#' + stateForumKey + '-pager').length) {
            $('#' + stateForumKey + '-pager').html(result.PagerHtml).show();
          } else if ($('#' + stateForForum.pagerContainer).length) {
            $('#' + stateForForum.pagerContainer).html(result.PagerHtml).show();
          }
        }

        /* setTimeout(() => {*/
        $('.text-body').each(function (index, el) {
          if (el.scrollHeight > el.clientHeight) {
            $(el).data('target-height', el.scrollHeight).next('.preview-fade').css('display', 'flex');
          }
        });
        /*  }, 0);*/

        this.Lightbox.InitializeLBImages('forum-page-wrap');
        this.IgnitePopOverMenus();
      } else {
        console.log("stateForForum is NOT an instance of DataContainer");
      }
    }
  }, {
    key: "WaitForProcessReviewDataFeed",
    value: function WaitForProcessReviewDataFeed(forumStateKey) {
      var _this21 = this;
      return new Promise(function (resolve, reject) {
        _this21.ProcessReviewFeedData(forumStateKey);
        resolve(true);
      });
    }
  }, {
    key: "ProcessReviewFeedData",
    value: function ProcessReviewFeedData(forumStateKey) {
      var _this22 = this;
      var state = this.GetState(forumStateKey);
      var result = state.dataState;
      var myVote = '';
      var isAnon = !(result.MySocialProfileId && result.MySocialProfileId !== null && result.MySocialProfileId !== undefined && parseInt(result.MySocialProfileId, 10) > 0);
      if (isAnon) {
        this.GetAnonLikesFromStorage();
      }
      $('#' + forumStateKey).html('');
      result && result.Posts && result.Posts.forEach(function (num, index) {
        myVote = '';
        if (!isAnon) {
          var downString = result.Posts[index].DownVotes;
          var upString = result.Posts[index].UpVotes;
          if (upString != null && upString != '') {
            var UpVotes = upString.split(',');
            if (UpVotes.includes(result.MySocialProfileId.toString())) {
              myVote = 'up';
            }
          }
          if (myVote == '') {
            if (downString != null && downString != '') {
              var DownVotes = downString.split(',');
              if (DownVotes.includes(result.MySocialProfileId.toString())) {
                myVote = 'down';
              }
            }
          }
        } else if (_this22.AnonSocialProfileLikes.length) {
          var intId;
          intId = parseInt(result.Posts[index].EntityId, 10);
          myVote = _this22.GetAnonThumbState(intId, result.Posts[index].ActivityType);
        }
        if (result.Posts[index].ActivityType == 'Comment') {
          $('#' + forumStateKey).append(_this22.RenderReviewCommentForProfileFeed(result.Posts[index], myVote));
        } else {
          $('#' + forumStateKey).append(_this22.RenderReviewForProfileFeed(result.Posts[index], myVote));
        }
      });
      if (result.PagerHtml) {
        $('#' + forumStateKey + "-pager").html(result.PagerHtml);
      }

      /* setTimeout(() => {*/
      $('.text-body').each(function (index, el) {
        if (el.scrollHeight > el.clientHeight) {
          $(el).data('target-height', el.scrollHeight).next('.preview-fade').css('display', 'flex');
        }
      });
      /*  }, 0);*/

      this.Lightbox.InitializeLBImages('review-list-wrap');
      this.IgnitePopOverMenus();
      this.IgniteReviewerStatusTooltip();
    }
  }, {
    key: "WaitForProcessReviewCommentsFeedData",
    value: function WaitForProcessReviewCommentsFeedData(forumStateKey) {
      var _this23 = this;
      return new Promise(function (resolve, reject) {
        _this23.ProcessReviewCommentsFeedData(forumStateKey);
        resolve(true);
      });
    }
  }, {
    key: "ProcessReviewCommentsFeedData",
    value: function ProcessReviewCommentsFeedData(stateKey) {
      var _this24 = this;
      var myVote = '';
      var state = this.GetState(stateKey);
      var result = state.dataState;
      var isAnon = !(result.SocialProfileId && result.SocialProfileId !== null && result.SocialProfileId !== undefined && parseInt(result.SocialProfileId, 10) > 0);
      if (isAnon) {
        this.GetAnonLikesFromStorage();
      }
      $('#' + stateKey).html('');
      result && result.Posts && result.Posts.forEach(function (num, index) {
        myVote = '';
        if (!isAnon) {
          var downString = result.Posts[index].DownVotes;
          var upString = result.Posts[index].UpVotes;
          if (upString != null && upString != '') {
            var UpVotes = upString.split(',');
            if (UpVotes.includes(result.SocialProfileId.toString())) {
              myVote = 'up';
            }
          }
          if (myVote == '') {
            if (downString != null && downString != '') {
              var DownVotes = downString.split(',');
              if (DownVotes.includes(result.SocialProfileId.toString())) {
                myVote = 'down';
              }
            }
          }
        } else if (_this24.AnonSocialProfileLikes.length) {
          var intId;
          intId = parseInt(result.Posts[index].EntityId, 10);
          myVote = _this24.GetAnonThumbState(intId, 'ReviewComment');
        }
        $('#' + stateKey).append(_this24.RenderReviewCommentForProfileFeed(result.Posts[index], myVote));
      });
      if (result.PagerHtml) {
        $('#' + stateKey + '-pager').html(result.PagerHtml).show();
      }

      /* setTimeout(() => {*/
      $('.text-body').each(function (index, el) {
        if (el.scrollHeight > el.clientHeight) {
          $(el).data('target-height', el.scrollHeight).next('.preview-fade').css('display', 'flex');
        }
      });
      /*  }, 0);*/

      this.Lightbox.InitializeLBImages('review-comments-list-wrap');
      this.IgnitePopOverMenus();
      this.IgniteReviewerStatusTooltip();
    }
  }, {
    key: "WaitForProcessVotesFeedData",
    value: function WaitForProcessVotesFeedData(result) {
      var _this25 = this;
      return new Promise(function (resolve, reject) {
        _this25.ProcessVotesFeedData(result);
        resolve(true);
      });
    }
  }, {
    key: "ProcessVotesFeedData",
    value: function ProcessVotesFeedData(result) {
      var _this26 = this;
      var myVote = '';
      var isAnon = !(result.SocialProfileId && result.SocialProfileId !== null && result.SocialProfileId !== undefined && parseInt(result.SocialProfileId, 10) > 0);
      if (isAnon) {
        this.GetAnonLikesFromStorage();
      }
      $('#vote-list-wrap').html('');
      result && result.List && result.List.forEach(function (num, index) {
        var entityType = result.List[index].EntityType;
        myVote = '';
        if (!isAnon) {
          var downString = result.List[index].DownVotes;
          var upString = result.List[index].UpVotes;
          if (upString != null && upString != '') {
            var UpVotes = upString.split(',');
            if (UpVotes.includes(result.SocialProfileId.toString())) {
              myVote = 'up';
            }
          }
          if (myVote == '') {
            if (downString != null && downString != '') {
              var DownVotes = downString.split(',');
              if (DownVotes.includes(result.SocialProfileId.toString())) {
                myVote = 'down';
              }
            }
          }
        } else if (_this26.AnonSocialProfileLikes.length) {
          var intId;
          intId = parseInt(result.List[index].EntityId, 10);
          myVote = _this26.GetAnonThumbState(intId, entityType);
        }
        $('#vote-list-wrap').append(_this26.RenderVoteEntityForProfileFeed(result.List[index], myVote));
      });
      if (result.PagerHtml) {
        $('#vote-list-pagination').html(result.PagerHtml).show();
      }

      /* setTimeout(() => {*/
      $('.text-body').each(function (index, el) {
        if (el.scrollHeight > el.clientHeight) {
          $(el).data('target-height', el.scrollHeight).next('.preview-fade').css('display', 'flex');
        }
      });
      /*  }, 0);*/

      this.Lightbox.InitializeLBImages('vote-list-wrap');
    }
  }, {
    key: "ProcessReviewData",
    value: function ProcessReviewData(result, data) {
      var lochash = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : "";
      var isAnon = !(result.reviewModel && result.reviewModel.MyProfile && result.reviewModel.MyProfile.Id !== null && result.reviewModel.MyProfile.Id !== undefined && parseInt(result.reviewModel.MyProfile.Id, 10) > 0);
      if (isAnon) {
        this.GetAnonLikesFromStorage();
      } else {
        this.MyProfile = result.reviewModel.MyProfile;
      }
      this.PopulateReviewTab(result.reviewModel.Reviews, result.reviewModel.MyProfile, 'review-template', isAnon);
      this.PopulateReviewTab(result.reviewModel.RejectedReviews, result.reviewModel.MyProfile, 'rejected-review-template', isAnon);
      this.LoadedReviewComments = result.reviewModel.Comments;
      if (result.reviewModel.PagerHtml) {
        $('#review-paginator').html(result.reviewModel.PagerHtml);
      }
      if (result.reviewModel.RejectedTabPagerHtml) {
        $('#rejected-review-paginator').html(result.reviewModel.RejectedTabPagerHtml);
      }
      if (data.SocialProfileId > 0) {
        var div = '';
        if ($('#review-author-' + data.SocialProfileId).length) {
          if (data.commentId > 0) {
            var selectedReview = result.reviewModel.Reviews.find(function (review) {
              return review.Reviewer.Id === data.SocialProfileId;
            });
            if (selectedReview) {
              this.OpenComment(selectedReview.Id);
              if ($('#comment-post-' + selectedReview.Id).length) {
                var selectedComment = this.LoadedReviewComments.find(function (comment) {
                  return comment.Id === data.commentId;
                });
                if (selectedComment) {
                  if (selectedComment.ReplyToCommentId == null) {
                    div = $('#review-comment-' + selectedComment.AttachedToPostId + '-' + selectedComment.Id);
                    div.addClass('highlight').get(0).scrollIntoView({
                      block: "center",
                      behavior: 'smooth'
                    });
                    setTimeout(function () {
                      div.removeClass('highlight');
                      ;
                    }, 1000);
                  } else {
                    this.OpenReply(selectedComment.ReplyToCommentId, selectedComment.AttachedToPostId, 'Review');
                    div = $("#review-comment-reply-".concat(selectedReview.Id, "-").concat(selectedComment.ReplyToCommentId, "-").concat(selectedComment.Id));
                    div.addClass('highlight').get(0).scrollIntoView({
                      block: "center",
                      behavior: 'smooth'
                    });
                    setTimeout(function () {
                      div.removeClass('highlight');
                      ;
                    }, 1000);
                  }
                }
              } else {
                div = $('#review-author-' + data.SocialProfileId);
                div.find('.review-box').first().addClass('highlight').get(0).scrollIntoView({
                  block: "center",
                  behavior: 'smooth'
                });
                setTimeout(function () {
                  div.find('.review-box').first().removeClass('highlight');
                  ;
                }, 1000);
              }
            } else {
              div = $('#review-author-' + data.SocialProfileId);
              div.find('.review-box').first().addClass('highlight').get(0).scrollIntoView({
                block: "center",
                behavior: 'smooth'
              });
              setTimeout(function () {
                div.find('.review-box').first().removeClass('highlight');
                ;
              }, 1000);
            }
          } else {
            div = $('#review-author-' + data.SocialProfileId);
            div.find('.review-box').first().addClass('highlight').get(0).scrollIntoView({
              block: "center",
              behavior: 'smooth'
            });
            setTimeout(function () {
              div.find('.review-box').first().removeClass('highlight');
              ;
            }, 1000);
          }
        }
      }
    }
  }, {
    key: "ProcessMiniReviewData",
    value: function ProcessMiniReviewData(result, data, isInit) {
      var isAnon = !(result.reviewModel && result.reviewModel.MyProfile && result.reviewModel.MyProfile.Id !== null && result.reviewModel.MyProfile.Id !== undefined && parseInt(result.reviewModel.MyProfile.Id, 10) > 0);
      if (isAnon) {
        this.GetAnonLikesFromStorage();
      } else {
        this.MyProfile = result.reviewModel.MyProfile;
      }
      this.PopulateReviewTab(result.reviewModel.Reviews, result.reviewModel.MyProfile, 'mini-review-template', isAnon, result.reviewModel.Page != 1);
      $("#mini-review-template").data('page', result.reviewModel.Page);
      if (result.reviewModel.HasNextPage) {
        var nextPage = isInit ? 1 : result.reviewModel.Page + 1;
        $('#mini-review-paginator').html("<a class=\"waves-effect frn-button medium navy curved\" role=\"button\" href=\"javascript:void(0);\" onclick=\"window.SocialProfile.LoadMiniReviews(".concat(data.brokerId, ", ").concat(nextPage, ")\">Show more (").concat(result.reviewModel.TotalReviews, " total)</a>"));
      } else {
        $('#mini-review-paginator').html("");
      }
      this.LoadedReviewComments = result.reviewModel.Comments;
    }
  }, {
    key: "PopulateReviewTab",
    value: function PopulateReviewTab(reviews, myProfile, id, isAnon) {
      var _this27 = this;
      var append = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var myVote = '';
      if (!append) {
        $('#' + id).html('');
      }
      reviews && reviews.forEach(function (num, index) {
        myVote = '';
        if (!isAnon) {
          if (reviews[index].UpVotes.includes(myProfile.Id.toString())) {
            myVote = 'up';
          } else if (reviews[index].DownVotes.includes(myProfile.Id.toString())) {
            myVote = 'down';
          }
        } else if (_this27.AnonSocialProfileLikes.length) {
          var intId = parseInt(reviews[index].Id, 10);
          myVote = _this27.GetAnonThumbState(intId, 'Review');
        }
        $('#' + id).append(_this27.RenderReview(reviews[index], myVote));
      });
      this.Lightbox.InitializeLBImages(id);
      this.IgniteReviewerStatusTooltip();
    }
  }, {
    key: "GetAnonThumbState",
    value: function GetAnonThumbState(intId, channel) {
      var myVote = '';
      var upThumbData = {
        direction: 'up',
        channel: channel,
        id: intId
      };
      var upThumb = this.Hash(JSON.stringify(upThumbData), 23);
      var downThumbData = {
        direction: 'down',
        channel: channel,
        id: intId
      };
      var downThumb = this.Hash(JSON.stringify(downThumbData), 23);
      if (this.AnonSocialProfileLikes.includes(downThumb)) {
        myVote = 'down';
      } else if (this.AnonSocialProfileLikes.includes(upThumb)) {
        myVote = 'up';
      }
      return myVote;
    }
  }, {
    key: "GetAnonLikesFromStorage",
    value: function GetAnonLikesFromStorage() {
      if (localStorage.getItem("SocialProfileLikes") != null) {
        var storedLikeData = localStorage.getItem("SocialProfileLikes");
        if (storedLikeData !== null) {
          this.AnonSocialProfileLikes = JSON.parse(storedLikeData);
        }
      }
    }
  }, {
    key: "LoadCustomReviewData",
    value: function LoadCustomReviewData() {
      var _this28 = this;
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.loadCustomReviewDataUrl,
        dataType: "json",
        data: {
          brokerId: this.brokerId
        },
        success: function success(result) {
          if (result.reviewModel !== undefined) {
            if (result.reviewModel.MyReview !== null && result.reviewModel.MyReview.Id !== undefined) {
              $("#submit-review-btn").hide();
              $('#my-review').html('');
              $('#my-review').append(_this28.RenderPreview(result.reviewModel.MyReview));
              _this28.Lightbox.InitializeLBImages('review-template');
              $('#my-review-card').show();
            }
            if (result.reviewModel.Comments.length > 0) {
              _this28.MyPendingComments = result.reviewModel.Comments;
              if (result.reviewModel !== undefined && result.reviewModel.MyProfile !== null && result.reviewModel.MyProfile !== undefined) {
                _this28.MyProfile = result.reviewModel.MyProfile;
              }
            }
          }
        },
        error: function error(result) {}
      });
    }
  }, {
    key: "RenderNotification",
    value: function RenderNotification(notification) {
      var who = "<span class=\"notification-field actor\">".concat(notification.Actor, " ");
      if (notification.NumActors > 1) {
        if (notification.NumActors == 2) {
          who += "&nbsp;".concat(AND_ONE_OTHER);
        } else {
          who += "&nbsp;".concat(AND_X_OTHERS.replace('{0}', notification.NumActors - 1));
        }
      }
      who += "</span>";
      var myDate = moment.duration(moment.utc(notification.CreatedAt).diff(this.now)).humanize(true);
      return "<div id=\"\" class=\"notification-wrap-".concat(notification.Id, " notification-wrap ").concat(function () {
        if (notification.CreatorShownAt == null) {
          return "active";
        }
        return "";
      }(), "\">\n        <div class=\"notification-item font-13\">\n        <div class=\"notification-left\">\n            <div class=\"notification-field avatar social-profile-navigate\" data-profile-id=\"").concat(notification.ActorId, "\">\n                <img class=\"social-profile-navigate\" src=\"").concat(this.avatarPath).concat(notification.ActorAvatar, "\" data-profile-id=\"").concat(notification.ActorId, "\">\n            </div>\n            </div>\n            <div class=\"notification-right  acknowledge-notification\" onclick=\"window.SocialProfile.AcknowledgeNotification(").concat(notification.Id, ")\">\n\n            ").concat(function () {
        switch (notification.ActionType) {
          case "ReviewApprovedOnBrokerUserOwns":
            return "".concat(who, " ").concat(HAS_POSTED_A_REVIEW_OF_X.replace('{0}', notification.ContentPreview));
            break;
          case "ReviewCommentApprovedOnBrokerUserOwns":
            return "".concat(who, " ").concat(REVIEWED_A_BROKER_YOU_REPRESENT);
            break;
          case "ReviewApprovedOnBrokerUserSubscribed":
            return "".concat(who, " ").concat(REVIEWED_A_BROKER_YOU_SUBSCRIBED_TO);
            break;
          case "ReviewApprovedOnBrokerUserOwns":
            return "".concat(who, " ").concat(HAS_POSTED_A_REVIEW_OF_X.replace('{0}', notification.ContentPreview));
            break;
          case "PostCreatedOnTopicUserSubscribed":
            return "".concat(who, " ").concat(POSTED_IN_A_DISCUSSION_YOU_SUBSCRIBED_TO);
            break;
          case "SubscribedToTopic":
            return "".concat(who, " ").concat(SUBSCRIBED_TO_A_DISCUSSION_YOU_STARTED);
            break;
          case "SubscribedToBrokerReview":
            return "".concat(X_SUBSCRIBED_TO_A_BROKER_YOU_OWN.replace('{0}', who));
            break;
          case "BrokerReviewApproved":
            return "".concat(who, " ").concat(HAS_POST_A_REVIEW_OF_A_BROKER_YOU_FOLLOW);
            break;
          case "MyReviewApproved":
            return "".concat(who, " ").concat(HAS_APPROVED_YOUR_BROKER_REVIEW);
            break;
          case "MyReviewCommentApproved":
            return "".concat(X_HAS_APPROVED_YOUR_BROKER_REVIEW_COMMENT.replace('{0}', who));
            break;
          case "PostCreatedOnTopicUserCreated":
            return "".concat(who, " ").concat(POSTED_IN_A_DISCUSSION_YOU_STARTED);
            break;
          case "RespondToComment":
          case "RespondedToComment":
            return "".concat(who, " ").concat(RESPONDED_TO_YOUR_COMMENT);
            break;
          case "RespondToPost":
          case "RespondedToPost":
          case "CommentedOnPost":
            return "".concat(who, " ").concat(RESPONDED_TO_YOUR_POST);
            break;
          case "CommentedOnReview":
            return "".concat(X_COMMENTED_ON_REVIEW.replace('{0}', who));
            break;
          case "UserUpVoted":
            if (notification.EntityType == "ForumComment" || notification.EntityType == "ReviewComment") {
              return "".concat(who, " ").concat(UPVOTED_YOUR_COMMENT);
            } else if (notification.EntityType == "Post") {
              return "".concat(who, " ").concat(UPVOTED_YOUR_POST);
            } else if (notification.EntityType == "Review") {
              return "".concat(who, " ").concat(UPVOTED_YOUR_REVIEW);
            }
            break;
          case "UserDownVoted":
            if (notification.EntityType == "ForumComment" || notification.EntityType == "ReviewComment") {
              return "".concat(who, " ").concat(DOWNVOTED_YOUR_COMMENT);
            } else if (notification.EntityType == "Post") {
              return "".concat(who, " ").concat(DOWNVOTED_YOUR_POST);
            } else if (notification.EntityType == "Review") {
              return "".concat(who, " ").concat(DOWNVOTED_YOUR_REVIEW);
            }
            break;
          default:
            return notification.ActionType;
            break;
        }
        return "";
      }(), "\n            \n            <span class=\"notification-field preview\">\n            ").concat(function () {
        switch (notification.ActionType) {
          case "ReviewApprovedOnBrokerUserOwns":
          case "UserUpVoted":
          case "UserDownVoted":
            return "\"".concat(notification.UserActionContentPreview, "\"");
            break;
          default:
            return "\"".concat(notification.ContentPreview, "\"");
            break;
        }
        return "";
      }(), "\n            </span>\n            <div class=\"notificaiton-position\">\n                <div class=\"notification-field date\">").concat(myDate, "</div>\n            </div>\n            </div>\n        </div>\n    </div >");
    }
  }, {
    key: "RenderNotificationFooter",
    value: function RenderNotificationFooter() {
      return "<div onclick=\"window.SocialProfile.GoToNotifications()\" class=\"notification-footer\">".concat(SEE_ALL_NOTIFICATIONS, " <i class=\"arrow-right-icon icon-16\"> </i></div>");
    }
  }, {
    key: "RenderPreview",
    value: function RenderPreview(review) {
      var _this29 = this;
      var stringTemplate = "<div class='review-wrap'>\n            <div class=\"frn-flex-row column review-box\">\n                <div class=\"cell-group review-header\">\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image social-profile-navigate\" src=\"".concat(this.avatarPath).concat(review.Reviewer.ImageKey, "\" data-profile-id=\"").concat(review.Reviewer.Id, "\"/>\n                    </div>\n                    <div class=\"cell-group reviewer-info column\">\n                        <div class=\"cell-group verification-group\">\n                            <span class=\"name-cell social-profile-navigate\" data-profile-id=\"").concat(review.Reviewer.Id, "\">").concat(review.Reviewer.PublicName, "</span>\n                        </div>\n                        ").concat(function () {
        if (review.Reviewer.Country != null && review.Reviewer.Country != undefined) {
          return "<div class=\"cell reviewer-info lesser-text\">".concat(window.LOCATION, ":").concat(review.Reviewer.Country, "</div>");
        }
        return '';
      }(), "\n                    </div>\n                    <div class=\"cell-group last column\">\n                        <div class= \"cell lesser-text mb-1\"><a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.EditReview()\" class=\"btn btn-primary FXV frn-override waves-effect waves-light\">").concat(window.EDIT_MY_REVIEW, "</a></div>\n                        <div class= \"cell lesser-text\"><span class=\"status-badge\">").concat(review.Status, "</span></div>\n                    </div>\n                </div>\n                ").concat(function () {
        if (review.Rating > 0) {
          return "<div class=\"star-holder\" style=\"font-size: 20px; color: #FDC240;\">\n                                    <span class=\"typcn stars-".concat(review.Rating, "\"></span><span class=\"typcn outline-stars-").concat(5 - review.Rating, "\"></span><span class=\"user-review-rating\">").concat(parseFloat(review.Rating).toFixed(1), "</span>\n                                </div>");
        } else return "<div class='user-review-rating pl-0'>".concat(window.NO_RATING, "</div>");
      }(), "\n                \n                <div class=\"cell-group review-body row\">\n                ").concat(review.Content, "</div>\n              ").concat(function () {
        var imageGallery = '';
        if (review.Images.length) {
          imageGallery = "<div class=\"image-row\">";
        }
        review.Images.forEach(function (num, index) {
          var img = review.Images[index];
          imageGallery += "<img src=\"".concat(_this29.imagepath).concat(img, "\" class=\"review-img lightbox-slide\" />");
        });
        if (imageGallery.length > 0) {
          imageGallery += "</div>";
        }
        return imageGallery;
      }(), "\n        </div>\n    ");
      return stringTemplate;
    }
  }, {
    key: "RenderReview",
    value: function RenderReview(review, myVote) {
      var _this30 = this;
      var myDate = moment.utc(review.CreatedAt);
      var stringTemplate = "<div class='review-wrap' id='review-author-".concat(review.Reviewer.Id, "'>\n            <div class=\"frn-flex-row column review-box\">\n                <div class=\"cell last lesser-text d-block d-sm-none\">").concat(myDate.format('LL'), "</div>\n                <div class=\"cell-group review-header\">\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image social-profile-navigate\" src=\"").concat(this.avatarPath).concat(review.Reviewer.ImageKey, "\" data-profile-id=\"").concat(review.Reviewer.Id, "\"/>\n                    </div>\n                    <div class=\"cell-group reviewer-info column\">\n                        <div class=\"cell-group verification-group\">\n                            <span class=\"name-cell social-profile-navigate\" data-profile-id=\"").concat(review.Reviewer.Id, "\">").concat(review.Reviewer.PublicName, "</span>\n                            ").concat(function () {
        if (review.ReviewerIsCompanyRep) {
          return "<div class=\"reviewer-status representitive d-none d-sm-flex\"><div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/checkcircle.svg\" caption=\"false\"></div><div class=\"verified-icon-text\">".concat(window.COMPANY_REPRESENTATIVE, "</div></div>");
        } else {
          if (review.ReviewerIsVerified) {
            return "<div class=\"reviewer-status verified d-none d-sm-flex\"><div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/checkcircle.svg\" caption=\"false\"></div><div class=\"verified-icon-text\">".concat(window.VERIFIED_REVIEWER, "</div></div>");
          } else {
            return "<div class=\"reviewer-status unverified d-none d-sm-flex\"><div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/warningcircle.svg\" caption=\"false\"></div><div class=\"verified-icon-text\">".concat(window.UNVERIFIED_REVIEWER, "</div></div>");
          }
        }
      }(), "\n                        </div>\n                        ").concat(function () {
        if (review.Reviewer.Country != null && review.Reviewer.Country != undefined) {
          return "<div class=\"cell reviewer-info lesser-text\">".concat(window.LOCATION, ": ").concat(review.Reviewer.Country, "</div>");
        }
        return "";
      }(), "\n                        ").concat(function () {
        if (review.VerifiedAccountsList !== "") {
          return "<div class=\"cell reviewer-info lesser-text\">\n                                            ".concat(window.ACCOUNT_TYPES, ": ").concat(review.VerifiedAccountsList, "\n                                        </div>");
        }
        return "";
      }(), "\n\n                    </div>\n                    <div class=\"cell last lesser-text d-none d-sm-block\">").concat(myDate.format('LL'), "</div>\n                </div>\n                ").concat(function () {
        var stars = '<div class="d-flex align-items-center">';
        if (review.Rating == 5) {
          stars += "\n                        <div class=\"star-holder\" style=\"font-size: 20px; color: #27AE1E;\">\n                            <span class=\"typcn stars-".concat(review.Rating, "\"></span><span class=\"typcn outline-stars-").concat(5 - review.Rating, "\"></span><span class=\"user-review-rating\">").concat(parseFloat(review.Rating).toFixed(1), "</span>\n                            </div>");
        } else if (review.Rating == 4) {
          stars += "\n                    <div class=\"star-holder\" style=\"font-size: 20px; color: #85DF2C;\">\n                        <span class=\"typcn stars-".concat(review.Rating, "\"></span><span class=\"typcn outline-stars-").concat(5 - review.Rating, "\"></span><span class=\"user-review-rating\">").concat(parseFloat(review.Rating).toFixed(1), "</span>\n                        </div>");
        } else if (review.Rating == 3) {
          stars += "\n                    <div class=\"star-holder\" style=\"font-size: 20px; color: #FDC240;\">\n                        <span class=\"typcn stars-".concat(review.Rating, "\"></span><span class=\"typcn outline-stars-").concat(5 - review.Rating, "\"></span><span class=\"user-review-rating\">").concat(parseFloat(review.Rating).toFixed(1), "</span>\n                        </div>");
        } else if (review.Rating == 2) {
          stars += "\n                    <div class=\"star-holder\" style=\"font-size: 20px; color: #FA9529;\">\n                        <span class=\"typcn stars-".concat(review.Rating, "\"></span><span class=\"typcn outline-stars-").concat(5 - review.Rating, "\"></span><span class=\"user-review-rating\">").concat(parseFloat(review.Rating).toFixed(1), "</span>\n                        </div>");
        } else if (review.Rating == 1) {
          stars += "\n                    <div class=\"star-holder\" style=\"font-size: 20px; color: #FA4C3B;\">\n                        <span class=\"typcn stars-".concat(review.Rating, "\"></span><span class=\"typcn outline-stars-").concat(5 - review.Rating, "\"></span><span class=\"user-review-rating\">").concat(parseFloat(review.Rating).toFixed(1), "</span>\n                        </div>");
        } else {
          stars += "<div class='user-review-rating pl-0'>".concat(window.NO_RATING, "</div>");
        }
        if (review.ReviewerIsCompanyRep) {
          stars += "<div class=\"reviewer-status representitive d-flex d-sm-none\"><div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/checkcircle.svg\" caption=\"false\"></div><div class=\"verified-icon-text\">".concat(window.COMPANY_REPRESENTATIVE, "</div></div>");
        } else {
          if (review.ReviewerIsVerified) {
            stars += "<div class=\"reviewer-status verified d-flex d-sm-none\"><div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/checkcircle.svg\" caption=\"false\"></div><div class=\"verified-icon-text\">".concat(window.VERIFIED_REVIEWER, "</div></div>");
          } else {
            if (review.ReviewerIsVerified) {
              stars += "<div class=\"reviewer-status verified d-flex d-sm-none\"><div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/checkcircle.svg\" caption=\"false\"></div><div class=\"verified-icon-text\">".concat(window.VERIFIED_REVIEWER, "</div></div>");
            } else {
              stars += "<div class=\"reviewer-status unverified d-flex d-sm-none\"><div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/warningcircle.svg\" caption=\"false\"></div><div class=\"verified-icon-text\">".concat(window.UNVERIFIED_REVIEWER, "</div></div>");
            }
          }
        }
        stars += "</div>";
        return stars;
      }(), "\n            ").concat(function () {
        var moderatorNotes = '';
        if (review.ModeratorNotes) {
          moderatorNotes = "<div class=\"alert alert-primary\">\n                    <strong>".concat(window.MODERATOR_NOTES, "</strong>\n                    <br>").concat(review.ModeratorNotes, "</div>");
        }
        return moderatorNotes;
      }(), "\n                <div class=\"cell-group review-body row\">\n                ").concat(review.Content, "</div>\n                \n                ").concat(function () {
        var imageGallery = '';
        if (review.Images.length) {
          imageGallery = "<div class=\"image-row\">";
        }
        review.Images.forEach(function (num, index) {
          var img = review.Images[index];
          imageGallery += "<img src=\"".concat(_this30.imagepath).concat(img, "\" class=\"review-img lightbox-slide\" />");
        });
        if (imageGallery.length > 0) {
          imageGallery += "</div>";
        }
        return imageGallery;
      }(), "\n                ").concat(function () {
        if (review.HasTranslation) {
          return "<div class='translation-div font-13'><br /><em>".concat(window.TRANSLATION, ":</em><br />").concat(review.Translation, "</div>");
        }
        return '';
      }(), "\n                <div class=\"cell hr expand\"></div>\n                <div class=\"baseline-controls\">\n                    <div class=\"control\">\n                        <i class=\"thumbsup icon buffer ").concat(function () {
        if (myVote === 'up') {
          return "my";
        }
      }() || '', "\" onClick=\"window.SocialProfile.Thumbs('up','Review','").concat(review.Id, "',this)\"></i>\n                    </div>\n                    <div class=\"control vote-score\">").concat(function () {
        if (review !== undefined && review !== null && review.VoteScore !== undefined) {
          return "".concat(review.VoteScore);
        } else {
          return "0";
        }
      }(), "\n            </div>\n                    <div class=\"control\">\n                        <i class=\"thumbsdown icon ").concat(function () {
        if (myVote === 'down') {
          return "my";
        }
      }() || '', "\" onClick=\"window.SocialProfile.Thumbs('down','Review','").concat(review.Id, "',this)\"></i>\n                    </div>\n                    <div class=\"control open-comment\">\n                    ").concat(function () {
        if (review.CommentCount === 1) {
          return "<a href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.OpenComment('".concat(review.Id, "')\">").concat(window.ONE_COMMENTS, "</a>");
        } else if (review.CommentCount > 0) {
          return "<a href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.OpenComment('".concat(review.Id, "')\">").concat(window.X_COMMENTS.replace('{X}', review.CommentCount), "</a>");
        } else {
          return "<a href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.OpenComment('".concat(review.Id, "')\">").concat(window.LEAVE_A_COMMENT, "</a >");
        }
      }(), "\n                    </div>\n                </div>\n            </div>\n            <div class='comment-wrap review-comment-wrap' id='comment-post-").concat(review.Id, "'>\n                <div class='add-comment frn-flex-row mb-2'>\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image social-profile-navigate\" src=\"").concat(this.avatarPath).concat(function () {
        if (_this30.MyProfile.ImageKey !== "" && _this30.MyProfile.ImageKey !== undefined && _this30.MyProfile.ImageKey !== null) {
          return _this30.MyProfile.ImageKey;
        }
        return "null";
      }(), "\" data-profile-id=\"").concat(this.MyProfile.Id, "\"/>\n                    </div>\n                    <div class=\"cell comment-box expand form-group\">\n                        <input type=\"text\" class=\"comment-box-input form-control mb-0 frn-override text-box single-line\" style=\"padding-left:0; padding-right:0; text-indent: 10px\"/>\n                        <div class=\"progress primary-color-light tab-progress\" style=\"display: none;\">\n                            <div class=\"indeterminate\"></div>\n                        </div>\n                    </div>\n   \n                    <div class=\"submit-comment-div last d-none d-sm-flex\">\n                        <a href=\"javascript:void(0)\" id=\"comment-button-").concat(review.Id, "-desktop\" onclick=\"window.SocialProfile.AddReviewComment('comment-button-").concat(review.Id, "-desktop','").concat(review.Id, "')\" role=\"button\" class=\"button waves-effect add-comment-button\">").concat(window.SUBMIT_COMMENT, "</a>\n                    </div>\n                    <div class=\"submit-comment-div last d-flex d-sm-none\">\n                        <a href=\"javascript:void(0)\" id=\"comment-button-").concat(review.Id, "-mobile\" onclick=\"window.SocialProfile.AddReviewComment('comment-button-").concat(review.Id, "-mobile','").concat(review.Id, "')\" role=\"button\" class=\"button waves-effect add-comment-button\"><img style=\"width:16px; height: 16px;\" src=\"/Content/dist/images/icons/send-icon-white.svg\" /></a>\n                    </div>\n                </div>\n                <div id='comment-list-").concat(review.Id, "'></div>\n            </div> \n        </div>");
      return stringTemplate;
    }
  }, {
    key: "RenderHotTopic",
    value: function RenderHotTopic(topic) {
      var topicString = "<div class='hot-topic'>\n            <div class=\"discussion-icon\">\n                <div class=\"icon-wrap\">\n                    <img style=\"width:24px; height: 24px;\" src=\"/Content/dist/images/icons/discussion.svg\" />\n                </div>\n            </div>\n            <div class=\"hot-topic-text\">\n                <div class=\"hot-topic-headline\"><a href=\"/forum?discussion=".concat(topic.TopicId, "\">").concat(topic.Headline, "</a></div>\n                <div class=\"hot-topic-meta\">\n                    <div class=\"control-group\">\n                        <div class=\"control first\">\n                            <i class=\"participants-in-thread icon\"></i>\n                        </div>\n                        <div class=\"control\"><span class=\"topic-").concat(topic.TopicId, "-participants\">\n                        ").concat(function () {
        if (topic.Participants === 1) {
          return "".concat(window.ONE_PARTICIPANT);
        } else {
          return "".concat(window.X_PARTICIPANTS.replace('{0}', topic.Participants));
        }
        return "";
      }(), "</span>\n                        </div>\n                    </div>\n                    <div class=\"control-group\">\n                        <div class=\"control\">\n                            <i class=\"reply-to-post icon\"></i>\n                        </div>\n                        <div class=\"control\"><span class=\"topic-").concat(topic.TopicId, "-replies\">\n                        ").concat(function () {
        if (topic.Replies === 1) {
          return "".concat(window.ONE_POST);
        } else {
          return "".concat(window.X_POSTS.replace('{0}', topic.Replies));
        }
        return "";
      }(), "</span>\n                        </div>\n                    </div>\n                </div>\n            </div>\n        </div>");
      return topicString;
    }
  }, {
    key: "RenderLatestForumPost",
    value: function RenderLatestForumPost(forumStateKey, post, myVote) {
      var _this31 = this;
      console.log(post);
      var myDate = moment.duration(moment.utc(post.CreatedAtString).diff(this.now)).humanize(true);
      var stringTemplate = "<div class='forum-post-wrap latest-post' id='post-box-".concat(post.EntityType, "-").concat(post.EntityId, "'>\n            <div class=\"frn-flex-row column review-box\">\n                <div class=\"cell-group review-header\">\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image social-profile-navigate\" src=\"").concat(this.avatarPath).concat(post.Author.ImageKey, "\" data-profile-id=\"").concat(post.Author.Id, "\"/>\n                    </div>\n                    <div class=\"cell-group reviewer-info column buffer min-144\">\n\n                        <div class=\"cell-group verification-group\">\n                            <span class=\"name-cell social-profile-navigate title-text\" data-profile-id=\"").concat(post.Author.Id, "\">").concat(post.Author.PublicName, "</span>\n                        </div>\n                         ").concat(function () {
        if (post.Author.Country != null && post.Author.Country != undefined) {
          return "<div class=\"cell reviewer-info lesser-text\">".concat(window.LOCATION, ": ").concat(post.Author.Country, "</div>");
        }
        return "";
      }(), "\n            ").concat(function () {
        if (post.Author.JoinedDate != null && post.Author.JoinedDate != undefined) {
          return "<div class=\"cell reviewer-info lesser-text\">".concat(window.JOINED, ": ").concat(moment.duration(moment.utc(post.Author.JoinedDateString).diff(_this31.now)).humanize(true), "</div>");
        }
        return "";
      }(), "\n                    </div>\n\n                    <div class=\"cell-group column buffer hide-when-small\">\n                    ").concat(function () {
        if (post.InlineEntity === window.ENTITY_TYPE_SOCIAL_PROFILE_PAGE) {
          var linkToPost = "<a href=\"/forum?discussion=".concat(post.TopicId, "\">").concat(post.Headline, "</a>");
          return " <div class=\"cell-group verification-group\">\n                            <img style=\"width:16px; height: 16px;\" class=\"reviewer-image social-profile-navigate\" src=\"".concat(_this31.avatarPath).concat(post.TopicOwnerAvatar, "?w=16&h=16\" data-profile-id=\"").concat(post.TopicOwnerId, "\">\n                            <span class=\"link-to-post\">").concat(linkToPost, "</span>\n                        </div>");
        }
        return " <div class=\"cell-group verification-group\">\n                            <img style=\"width:16px; height: 16px;\" src=\"/Content/dist/images/icons/discussion.svg\" />\n                            <span class=\"link-to-post\"><a href=\"/forum?discussion=".concat(post.TopicId, "\">").concat(post.Headline, "</a></span>\n                        </div>");
      }(), "\n                       \n                        ").concat(function () {
        if (post.EntityType == 'comment') {
          if (post.ReplyToCommentId != undefined && post.ReplyToCommentId != null && post.ReplyToCommentId > 0) {
            return "<div class='cell replying-to-info'>".concat(window.REPLYING_TO_COMMENT_BY.replace('{0}', "<a href=\"/forum?discussion=".concat(post.TopicId, "&post=").concat(post.PostId, "&comment=").concat(post.ReplyToCommentId, "\">@").concat(post.ReplyingTo, "</a>")), "</div>");
          }
          return "<div class=\"cell replying-to-info\">".concat(window.REPLYING_TO_COMMENT_BY.replace('{0}', "<a href=\"/forum?discussion=".concat(post.TopicId, "&post=").concat(post.PostId, "\">@").concat(post.ReplyingTo, "</a>")), "</div>");
        }
        return "";
      }(), "\n                    </div>\n                    <div class=\"cell-group last\">\n                        <div class=\"cell buffer lesser-text date-block\">").concat(myDate, "</div>\n                        ").concat(function () {
        if (post.ViewerCanEdit === true) {
          return "<div class=\"cell last dots\"><img src=\"/Content/dist/images/icons/3dots.svg\"  \n                                                        data-toggle='post-edit-menu'\n                                                        data-forum-holder='".concat(forumStateKey, "'\n                                                        data-target-id='forum-edit-menu'\n                                                        data-placement='top'\n                                                        data-trigger='hover toggle'\n                                                        data-html='true'\n                                                        data-authorid='").concat(post.Author.Id, "'\n                                                        ").concat(function () {
            if (post.EntityType === 'comment') {
              return "data-commentid=".concat(post.EntityId);
            }
            return "";
          }(), "\n                                                        data-postid='").concat(post.PostId, "'/></div>");
        }
        return "";
      }(), "\n                    </div>\n\n\n                </div>                    \n                <div class=\"cell-group column show-when-small\" style=\"padding-top:16px\" >\n\n             \n\n                        <div class=\"cell-group verification-group\">\n                         ").concat(function () {
        if (post.InlineEntity === window.ENTITY_TYPE_SOCIAL_PROFILE_PAGE) {
          var linkToPost = "<a href=\"/forum?discussion=".concat(post.TopicId, "\">").concat(post.Headline, "</a>");
          return " \n                            <img style=\"width:16px; height: 16px;\" class=\"reviewer-image social-profile-navigate\" src=\"".concat(_this31.avatarPath).concat(post.TopicOwnerAvatar, "?w=16&h=16\" data-profile-id=\"").concat(post.TopicOwnerId, "\">\n                            <span class=\"link-to-post\">").concat(linkToPost, "</span>\n                        ");
        } else {
          var link = "";
          if (post.EntityType == 'comment') {
            link = "<a id=\"link-to-post-".concat(post.EntityId, "\" href=\"/forum?discussion=").concat(post.TopicId, "&post=").concat(post.PostId, "&comment=").concat(post.EntityId, "\">").concat(post.Headline, "</a>");
          } else {
            link = "<a id=\"link-to-post-".concat(post.PostId, "\" href=\"/forum?discussion=").concat(post.TopicId, "&post=").concat(post.PostId, "\">").concat(post.Headline, "</a>");
          }
          return " \n                            <img style=\"width:16px; height: 16px;\" src=\"/Content/dist/images/icons/discussion.svg\" />\n                            <span class=\"link-to-post\">".concat(link, "</span>\n                        ");
        }
      }(), "\n\n                            </span>\n                        </div>\n                    </div>\n                <div class=\"cell review-body text-body\" ").concat(function () {
        if (post.EntityType == 'comment') {
          return " id='comment-content-".concat(post.EntityId, "' ");
        }
        return " id='post-content-".concat(post.PostId, "'");
      }(), " data-comment-author='").concat(post.Author.PublicName, "' >").concat(function () {
        if (post.DeletedPost === true) {
          return window.DELETED_POST;
        }
        if (post.Content !== undefined && post.Content !== null) {
          return post.Content.trim();
        }
        return "";
      }()).concat(function () {
        if (post.DeletedPost !== true) {
          var imageGallery = '';
          if (post.DeletedPost != true && post.Images !== undefined) {
            if (post.Images.length) {
              imageGallery = "<div class=\"image-row\">";
            }
            post.Images.forEach(function (num, index) {
              var img = post.Images[index];
              if (post.EntityType == 'comment') {
                imageGallery += "<img src=\"".concat(_this31.imagePathComment).concat(img.FileName, "\" class=\"review-img lightbox-slide\" />");
              } else {
                imageGallery += "<img src=\"".concat(_this31.imagePathForum).concat(img.FileName, "\" class=\"review-img lightbox-slide\" />");
              }
            });
            if (imageGallery.length > 0) {
              imageGallery += "</div>";
            }
          }
          return imageGallery;
        }
        return "";
      }(), "</div>\n                <div class=\"cell preview-fade\">\n                    <a id=\"expand-button-post-").concat(post.EntityType, "-").concat(post.EntityId, "\" href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.ExpandPostPreview('").concat(post.EntityType, "','").concat(post.EntityId, "','open')\">").concat(window.SHOW_MORE, "  <img style=\"width:13px; height: 13px;\" src=\"/Content/dist/images/icons/DownArrow.svg\" /></a>\n                </div>\n                <div class=\"cell preview-show\">\n                    <a id=\"contract-button-post-").concat(post.EntityType, "-").concat(post.EntityId, "\" href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.ExpandPostPreview('").concat(post.EntityType, "','").concat(post.EntityId, "','close')\">").concat(window.SHOW_LESS, "  <img style=\"width:13px; height: 13px;\" src=\"/Content/dist/images/icons/UpArrow.svg\" /></a>\n                </div>\n                <div class=\"cell hr expand\"></div>\n                <div class=\"baseline-controls\">\n                <div class=\"control-group\">\n\n                ").concat(function () {
        if (forumStateKey === 'activity-list-wrap') {
          return "<div class=\"control vote-score\">".concat(window.VOTE_SCORE, ": ").concat(function () {
            if (post !== undefined && post !== null && post.VoteScore !== undefined) {
              return "".concat(post.VoteScore);
            } else {
              return "0";
            }
          }(), "\n            </div>");
        } else {
          return "<div class=\"control\">\n                        <i class=\"thumbsup icon buffer ".concat(function () {
            if (myVote === 'up') {
              return "my";
            }
          }() || '', "\" onClick=\"window.SocialProfile.Thumbs('up','").concat(function () {
            if (post.EntityType == 'comment') return "ForumComment";
            return "Post";
          }(), "','").concat(post.EntityId, "',this)\"></i>\n                    </div>\n                    <div class=\"control vote-score\">").concat(function () {
            if (post !== undefined && post !== null && post.VoteScore !== undefined) {
              return "".concat(post.VoteScore);
            } else {
              return "0";
            }
          }(), "\n            </div>\n                    <div class=\"control\">\n                        <i class=\"thumbsdown icon ").concat(function () {
            if (myVote === 'down') {
              return "my";
            }
          }() || '', "\" onClick=\"window.SocialProfile.Thumbs('down','").concat(function () {
            if (post.EntityType == 'comment') return "ForumComment";
            return "Post";
          }(), "','").concat(post.EntityId, "',this)\"></i>\n                    </div>");
        }
      }(), "\n                    </div>\n\n                    ").concat(function () {
        if (forumStateKey === 'activity-list-wrap') {
          return "";
        }
        var control = "\n                                    <div class=\"control-group reply-control\">\n                                        <div class=\"control\">\n                                            <i class=\"reply-to-post icon\"></i>\n                                        </div>\n                                        <div class=\"control\">";
        if (post.EntityType == 'comment') {
          control += "<a href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.OpenCommentForCreate(this, '".concat(post.PostId, "','").concat(post.EntityId, "','").concat(forumStateKey, "')\">").concat(window.REPLY, "</a>");
        } else {
          control += "<a href = \"javascript:void(0)\" class=\"hover-underline\" onClick = \"window.SocialProfile.OpenCommentForCreate(this, '".concat(post.PostId, "','','").concat(forumStateKey, "')\" > ").concat(window.REPLY, "</a>");
        }
        control += "</div>\n                            </div>";
        return control;
      }(), "\n                    <div class=\"control-group last\">\n                    \n                    <div class=\"control\">\n                    ").concat(function () {
        if (post.EntityType == 'comment') {
          return "<a href=\"/forum?discussion=".concat(post.TopicId, "&post=").concat(post.PostId, "&comment=").concat(post.EntityId, "\" class=\"waves-effect go-to-task-button\">").concat(window.GO_TO_POST, "</a>");
        }
        return "<a href=\"/forum?discussion=".concat(post.TopicId, "&post=").concat(post.PostId, "\" class=\"waves-effect go-to-task-button\">").concat(window.GO_TO_POST, "</a>");
      }(), "\n\n                    </div>\n                    </div>\n                    </div>\n\n                </div>\n               \n            </div>\n        </div>");
      return stringTemplate;
    }
  }, {
    key: "RenderVoteEntityForProfileFeed",
    value: function RenderVoteEntityForProfileFeed(post, myVote) {
      var _this32 = this;
      var myDate = moment.duration(moment.utc(post.ContentCreatedOnDateString).diff(this.now)).humanize(true);
      var when = moment.duration(moment.utc(post.VotedOnDateString).diff(this.now)).humanize(true);
      var stringTemplate = "\n        <div class='forum-post-wrap latest-post' id='vote-box-".concat(post.EntityType, "-").concat(post.EntityId, "'>\n            \n                \n            <div class=\"frn-flex-row column review-box\">\n                <div class=\"cell vote-meta\">\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image reviewer-image-icon\" src=\"").concat(this.avatarPath).concat(post.Voter.ImageKey, "\"/>\n                    </div>\n                    <div class=\"vote-action\">\n                        ").concat(function () {
        if (post.EntityType == 'ForumComment' || post.EntityType == 'ReviewComment') {
          if (post.ActionType == 'UserUpVoted') {
            return "".concat(window.USERNAME_UPVOTED_COMMENT.replace('{0}', post.Voter.PublicName));
          }
          return "".concat(window.USERNAME_DOWNVOTED_COMMENT.replace('{0}', post.Voter.PublicName));
        } else if (post.EntityType == 'Review') {
          if (post.ActionType == 'UserUpVoted') {
            return "".concat(window.USERNAME_UPVOTED_REVIEW.replace('{0}', post.Voter.PublicName));
          }
          return "".concat(window.USERNAME_DOWNVOTED_REVIEW.replace('{0}', post.Voter.PublicName));
        } else if (post.EntityType == 'Post') {
          if (post.ActionType == 'UserUpVoted') {
            return "".concat(window.USERNAME_UPVOTED_POST.replace('{0}', post.Voter.PublicName));
          }
          return "".concat(window.USERNAME_DOWNVOTED_POST.replace('{0}', post.Voter.PublicName));
        }
      }(), "\n                        <span class=\"when\">").concat(when, "</span>\n                    </div>\n                </div>\n                <div class=\"cell-group review-header\">\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image social-profile-navigate\" src=\"").concat(this.avatarPath).concat(post.Author.ImageKey, "\" data-profile-id=\"").concat(post.Author.Id, "\"/>\n                    </div>\n                    <div class=\"cell-group reviewer-info column buffer min-144\">\n\n                        <div class=\"cell-group verification-group\">\n                            <span class=\"name-cell social-profile-navigate title-text\" data-profile-id=\"").concat(post.Author.Id, "\">").concat(post.Author.PublicName, "</span>\n                        </div>\n                         ").concat(function () {
        if (post.Author.Country != null && post.Author.Country != undefined) {
          return "<div class=\"cell reviewer-info lesser-text\">".concat(window.LOCATION, ": ").concat(post.Author.Country, "</div>");
        }
        return "";
      }(), "\n            ").concat(function () {
        if (post.Author.JoinedDate != null && post.Author.JoinedDate != undefined) {
          return "<div class=\"cell reviewer-info lesser-text\">".concat(window.JOINED, ": ").concat(moment.duration(moment.utc(post.Author.JoinedDateString).diff(_this32.now)).humanize(true), "</div>");
        }
        return "";
      }(), "\n                    </div>\n                    ").concat(function () {
        if ((post.EntityType == 'ForumComment' || post.EntityType == 'Post') && post.Headline !== undefined && post.Headline !== null) {
          return "\n                                    <div class=\"cell column buffer hide-when-small expand center\">\n                     \n                                            <img style=\"width:16px; height: 16px;\" src=\"/Content/dist/images/icons/discussion.svg\" />\n                                            <span class=\"link-to-post\"><a href=\"/forum?discussion=".concat(post.TopicId, "\">").concat(post.Headline, "</a></span>\n                                \n                                    </div>");
        }
        if (post.EntityType == 'Review') {
          return "\n                <div class=\"cell-group verification-group activity-description hide-when-small\">\n                    ".concat(_this32.RenderStatusBadge(post.Author.IsCompanyRepFor, post.Author.VerifiedForBroker), "\n                </div>");
        }
        return "";
      }(), "\n                    \n                    <div class=\"cell-group last\">\n                        <div class=\"cell buffer lesser-text date-block\">").concat(myDate, "</div>\n\n                \n                    </div>\n\n\n                </div>                    \n                <div class=\"cell-group column show-when-small\" style=\"padding-top:16px\" >\n                        <div class=\"cell-group verification-group\">\n                            <img style=\"width:16px; height: 16px;\" src=\"/Content/dist/images/icons/discussion.svg\"/>\n\n                            <span class=\"link-to-post\">\n                                ").concat(function () {
        if ((post.EntityType == 'ForumComment' || post.EntityType == 'Post') && post.Headline !== undefined && post.Headline !== null) {
          return "<a href=\"/forum?discussion=".concat(post.TopicId, "\">").concat(post.Headline, "</a>");
        }
        return "";
      }(), "\n                            </span>\n                        </div>\n                    </div>\n                <div class=\"cell text-body\">\n\n                ").concat(function () {
        var moderatorNotes = '';
        if (post.EntityType == 'Review' && post.ModerationNotes != null && post.ModerationNotes != '' && post.ModerationNotes != undefined) {
          moderatorNotes = "<div class=\"alert alert-primary\">\n                        <strong>".concat(window.MODERATOR_NOTES, "</strong>\n                        <br>").concat(post.ModerationNotes, "</div>");
        }
        return moderatorNotes;
      }(), "   \n                ").concat(function () {
        if (post.DeletedPost === true) {
          return window.DELETED_POST;
        }
        if (post.Content !== undefined && post.Content !== null) {
          return post.Content.trim();
        }
        return "";
      }()).concat(function () {
        var imageGallery = '';
        if (post.DeletedPost != true && post.Images !== undefined) {
          if (post.Images.length) {
            imageGallery = "<div class=\"image-row\">";
          }
          post.Images.forEach(function (num, index) {
            var img = post.Images[index];
            if (post.EntityType == 'ForumComment' || post.EntityType == 'Post') {
              imageGallery += "<img src=\"".concat(_this32.imagePathForum).concat(img, " \" class=\"review-img lightbox-slide\" />");
            }
            if (post.EntityType == 'Review') {
              imageGallery += "<img src=\"".concat(_this32.imagepath).concat(img, "\" class=\"review-img lightbox-slide\" />");
            }
          });
          if (imageGallery.length > 0) {
            imageGallery += "</div>";
          }
        }
        return imageGallery;
      }(), "</div>\n                <div class=\"cell preview-fade\">\n                    <a id=\"expand-button-post-").concat(post.EntityType, "-").concat(post.EntityId, "\" href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.ExpandPostPreview('").concat(post.EntityType, "','").concat(post.EntityId, "','open')\">").concat(window.SHOW_MORE, "  <img style=\"width:13px; height: 13px;\" src=\"/Content/dist/images/icons/DownArrow.svg\" /></a>\n                </div>\n                <div class=\"cell preview-show\">\n                    <a id=\"contract-button-post-").concat(post.EntityType, "-").concat(post.EntityId, "\" href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.ExpandPostPreview('").concat(post.EntityType, "','").concat(post.EntityId, "','close')\">").concat(window.SHOW_LESS, "  <img style=\"width:13px; height: 13px;\" src=\"/Content/dist/images/icons/UpArrow.svg\" /></a>\n                </div>\n                                <div class=\"cell hr expand\"></div>\n                <div class=\"baseline-controls\">\n                <div class=\"control-group\">\n\n                    <div class=\"control vote-score\">").concat(window.VOTE_SCORE, ": ").concat(function () {
        if (post !== undefined && post !== null && post.VoteScore !== undefined) {
          return "".concat(post.VoteScore);
        } else {
          return "0";
        }
      }(), "\n            </div>\n                   \n                    </div>\n                    \n                    <div class=\"control-group last\">\n                    \n                    <div class=\"control\">\n                    ").concat(function () {
        if (post.EntityType == 'Review') {
          return "<a href=\"javascript:void(0)\" class=\"waves-effect go-to-task-button\" onClick=\"window.SocialProfile.GoToReview('".concat(post.EntityId, "')\">").concat(window.GO_TO_BROKER_REVIEW, "</a>");
        }
        if (post.EntityType == 'ReviewComment') {
          return "<a href=\"javascript:void(0)\" class=\"waves-effect go-to-task-button\"  onClick=\"window.SocialProfile.GoToReviewComment('".concat(post.EntityId, "')\">").concat(window.GO_TO_COMMENT, "</a>");
        }
        if (post.EntityType == 'ForumComment') {
          return "<a href=\"/forum?discussion=".concat(post.TopicId, "&comment=").concat(post.AttachedToPostId, "\" class=\"waves-effect go-to-task-button\" onClick=\"window.SocialProfile.GoToComment('").concat(post.EntityId, "','").concat(post.AttachedToPostId, "')\">").concat(window.GO_TO_POST, "</a>");
        }
        return "<a href=\"/forum?discussion=".concat(post.TopicId, "&post=").concat(post.PostId, "\" class=\"waves-effect go-to-task-button\">").concat(window.GO_TO_POST, "</a>");
      }(), "\n\n                    </div>\n                    </div>\n                    </div>\n\n                </div>\n               \n            </div>\n        </div>");
      return stringTemplate;
    }
  }, {
    key: "RenderReviewForProfileFeed",
    value: function RenderReviewForProfileFeed(post, myVote) {
      var _this33 = this;
      var myDate = moment.duration(moment.utc(post.CreatedAt).diff(this.now)).humanize(true);
      var stringTemplate = "<div class='forum-post-wrap latest-post' id='post-box-".concat(post.EntityType, "-").concat(post.EntityId, "'>\n            <div class=\"frn-flex-row column review-box\">\n                <div class=\"cell-group show-when-small activity-description\" style=\"padding-bottom:16px\">\n                    ").concat(window.LEFT_A_REVIEW_FOR.replace('{0}', "".concat(post.Reviewer.PublicName)).replace('{1}', " <a href='".concat(window.langSlug, "/brokers/").concat(post.BrokerId, "/").concat(post.BrokerCode, "'>").concat(post.Name, "</a>")), "\n                </div>\n                <div class=\"cell-group review-header\">\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image\" src=\"/content/dist/brokers/images/").concat(post.FileName, "?w=56&h=56\"/>\n                    </div>\n                    <div class=\"cell image-cell image-cell-sub\">\n                        <img class=\"reviewer-image reviewer-image-sub social-profile-navigate\" src=\"").concat(this.avatarPath).concat(post.Reviewer.ImageKey, "?w=48&h=48\" data-profile-id=\"").concat(post.Reviewer.Id, "\"/>\n                    </div>\n                    <div class=\"cell-group reviewer-info column buffer min-144\">\n\n                        <div class=\"cell-group verification-group activity-description hide-when-small\">\n                           ").concat(window.LEFT_A_REVIEW_FOR.replace('{0}', "".concat(post.Reviewer.PublicName)).replace('{1}', " <a href='".concat(window.langSlug, "/brokers/").concat(post.BrokerId, "/").concat(post.BrokerCode, "'>").concat(post.Name, "</a>")), "\n                           ").concat(this.RenderStatusBadge(post.IsCompanyRepFor, post.ReviewerIsVerified), "\n                        </div>\n                        <div class=\"cell-group column\">\n                            ").concat(this.RenderStarRating(post.Rating), "\n                            <span class=\"show-when-small\">").concat(this.RenderStatusBadge(post.IsCompanyRepFor, post.ReviewerIsVerified), "</span>\n                        </div>\n                    </div>\n                    \n                   \n                    <div class=\"cell-group column last\">\n                        <div class=\"cell buffer lesser-text date-block\">").concat(myDate, "</div>\n\n                        <div class=\"cell lesser-text\"><span class=\"status-badge\">\n                        ").concat(function () {
        if (post.Status.toLowerCase() === 'approved') {
          return "Approved";
        } else if (post.Status.toLowerCase() === 'pending') {
          return "Pending";
        }
        return "Rejected";
      }(), "\n                        </span></div>\n                    </div>\n\n\n                </div>                    \n\n                <div class=\"cell text-body\" id='post-content-").concat(post.PostId, "' data-comment-author='").concat(post.Reviewer.PublicName, "' >\n                 ").concat(function () {
        var moderatorNotes = '';
        if (post.ModerationNotes != null && post.ModerationNotes != '' && post.ModerationNotes != undefined) {
          moderatorNotes = "<div class=\"alert alert-primary\">\n                        <strong>".concat(window.MODERATOR_NOTES, "</strong>\n                        <br>").concat(post.ModerationNotes, "</div>");
        }
        return moderatorNotes;
      }(), "\n                ").concat(function () {
        if (post.DeletedPost === true) {
          return window.DELETED_POST;
        }
        if (post.Comment !== undefined && post.Comment !== null) {
          return post.Comment.trim();
        }
        return "";
      }()).concat(function () {
        if (post.HasTranslation) {
          return "<div class='translation-div font-13'><br /><em>".concat(window.TRANSLATION, ":</em><br />").concat(post.Translation, "</div>");
        }
        return '';
      }()).concat(function () {
        var imageGallery = '';
        if (post.DeletedPost != true && post.Images !== undefined && post.Images != null) {
          if (post.Images.length) {
            imageGallery = "<div class=\"image-row\">";
          }
          post.Images.forEach(function (num, index) {
            var img = post.Images[index];
            imageGallery += "<img src=\"".concat(_this33.imagepath).concat(img, "\" class=\"review-img lightbox-slide\" />");
          });
          if (imageGallery.length > 0) {
            imageGallery += "</div>";
          }
        }
        return imageGallery;
      }(), "</div>\n                <div class=\"cell preview-fade\">\n                    <a id=\"expand-button-post-").concat(post.EntityType, "-").concat(post.EntityId, "\" href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.ExpandPostPreview('").concat(post.EntityType, "','").concat(post.EntityId, "','open')\">").concat(window.SHOW_MORE, "  <img style=\"width:13px; height: 13px;\" src=\"/Content/dist/images/icons/DownArrow.svg\" /></a>\n                </div>\n                <div class=\"cell preview-show\">\n                    <a id=\"contract-button-post-").concat(post.EntityType, "-").concat(post.EntityId, "\" href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.ExpandPostPreview('").concat(post.EntityType, "','").concat(post.EntityId, "','close')\">").concat(window.SHOW_LESS, "  <img style=\"width:13px; height: 13px;\" src=\"/Content/dist/images/icons/UpArrow.svg\" /></a>\n                </div>\n                                <div class=\"cell hr expand\"></div>\n                <div class=\"baseline-controls\">\n                <div class=\"control-group\">\n                    <div class=\"control\">\n                        <i class=\"thumbsup icon buffer ").concat(function () {
        if (myVote === 'up') {
          return "my";
        }
      }() || '', "\" onClick=\"window.SocialProfile.Thumbs('up','Review','").concat(post.EntityId, "',this)\"></i>\n                    </div>\n                    <div class=\"control vote-score\">").concat(function () {
        if (post !== undefined && post !== null && post.VoteScore !== undefined) {
          return "".concat(post.VoteScore);
        } else {
          return "0";
        }
      }(), "\n            </div>\n                    <div class=\"control\">\n                        <i class=\"thumbsdown icon ").concat(function () {
        if (myVote === 'down') {
          return "my";
        }
      }() || '', "\" onClick=\"window.SocialProfile.Thumbs('down','Review','").concat(post.EntityId, "',this)\"></i>\n                    </div>\n                    </div>\n                   \n                    <div class=\"control-group last\">\n                    \n                    <div class=\"control\">\n                    <a href=\"javascript:void(0)\" class=\"waves-effect go-to-task-button\" onClick=\"window.SocialProfile.GoToReview('").concat(post.ReviewId, "')\">").concat(window.GO_TO_BROKER_REVIEW, "</a>\n\n                    </div>\n                    </div>\n                    </div>\n\n                </div>\n               \n            </div>\n        </div>");
      return stringTemplate;
    }
  }, {
    key: "RenderReviewCommentForProfileFeed",
    value: function RenderReviewCommentForProfileFeed(post, myVote) {
      var myDate = moment.duration(moment.utc(post.CreatedAt).diff(this.now)).humanize(true);
      var stringTemplate = "<div class='forum-post-wrap latest-post' id='post-box-".concat(post.EntityType, "-").concat(post.EntityId, "'>\n            <div class=\"frn-flex-row column review-box\">\n                <div class=\"cell-group show-when-small activity-description\" style=\"padding-bottom:16px\">\n                        <div class=\"single-string\">\n                         ").concat(function () {
        if (parseInt(post.ReplyToCommentId, 10) > 0) {
          return "".concat(window.REPLYING_TO_COMMENT_BY_X_ON_Y.replace('{0}', "".concat(post.Reviewer.PublicName)).replace('{1}', "<a href='".concat(window.langSlug, "/social-profile/").concat(post.ReplyingToCommentUserId, "'>").concat(post.ReplyingToCommentName, "</a>")).replace('{2}', "<a href='".concat(window.langSlug, "/brokers/").concat(post.BrokerId, "/").concat(post.BrokerCode, "'>").concat(post.Name, "</a>")));
        } else {
          return "".concat(window.COMMENTED_ON_REVIEW_LEFT_BY_X.replace('{0}', "".concat(post.Reviewer.PublicName)).replace('{1}', "<a href='".concat(window.langSlug, "/brokers/").concat(post.BrokerId, "/").concat(post.BrokerCode, "'>").concat(post.Name, "</a>")).replace('{2}', "<a href='".concat(window.langSlug, "/social-profile/").concat(post.ReplyingToReviewerId, "'>").concat(post.ReplyingToReviewerName, "</a>")));
        }
      }(), "\n                         </div>\n                    \n                </div>\n                <div class=\"cell-group review-header\">\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image\" src=\"/content/dist/brokers/images/").concat(post.FileName, "?w=56&h=56\"/>\n                    </div>\n                     <div class=\"cell image-cell image-cell-sub\">\n                        <img class=\"reviewer-image reviewer-image-sub social-profile-navigate\" src=\"").concat(this.avatarPath).concat(post.Reviewer.ImageKey, "?w=48&h=48\" data-profile-id=\"").concat(post.Reviewer.Id, "\"/>\n                    </div>\n                    <div class=\"cell-group reviewer-info column buffer min-144\">\n\n                        <div class=\"cell-group verification-group activity-description hide-when-small\">\n                        <div class=\"single-string\">\n                         ").concat(function () {
        if (parseInt(post.ReplyToCommentId, 10) > 0) {
          return "".concat(window.REPLYING_TO_COMMENT_BY_X_ON_Y.replace('{0}', "".concat(post.Reviewer.PublicName)).replace('{1}', "<a href='".concat(window.langSlug, "/social-profile/").concat(post.ReplyingToCommentUserId, "'>").concat(post.ReplyingToCommentName, "</a>")).replace('{2}', "<a href='".concat(window.langSlug, "/brokers/").concat(post.BrokerId, "/").concat(post.BrokerCode, "'>").concat(post.Name, "</a>")));
        } else {
          return "".concat(window.COMMENTED_ON_REVIEW_LEFT_BY_X.replace('{0}', "".concat(post.Reviewer.PublicName)).replace('{1}', "<a href='".concat(window.langSlug, "/brokers/").concat(post.BrokerId, "/").concat(post.BrokerCode, "'>").concat(post.Name, "</a>")).replace('{2}', "<a href='".concat(window.langSlug, "/social-profile/").concat(post.ReplyingToReviewerId, "'>").concat(post.ReplyingToReviewerName, "</a>")));
        }
      }(), "\n                         </div>\n                        </div>\n                    </div>\n\n                    <div class=\"cell-group last\">\n                        <div class=\"cell buffer lesser-text date-block\">").concat(myDate, "</div>\n                    </div>\n\n\n                </div>                    \n                <div class=\"cell-group column show-when-small\" style=\"padding-top:16px\" >\n                        <div class=\"cell-group verification-group\">\n                            <img style=\"width:16px; height: 16px;\" src=\"/Content/dist/images/icons/discussion.svg\"/>\n\n                            <span class=\"link-to-post\">\n                               <a id=\"link-to-post-").concat(post.EntityId, "\" href=\"/forum?discussion=").concat(post.TopicId, "&post=").concat(post.PostId, "&comment=").concat(post.EntityId, "\">").concat(post.Headline, "</a>\n                            </span>\n                        </div>\n                    </div>\n                <div class=\"cell review-body text-body\" id='comment-content-").concat(post.EntityId, "' data-comment-author='").concat(post.Reviewer.PublicName, "' >").concat(function () {
        if (post.DeletedPost === true) {
          return window.DELETED_POST;
        }
        if (post.Comment !== undefined && post.Comment !== null) {
          return post.Comment.trim();
        }
        return "";
      }()).concat(function () {
        if (post.HasTranslation) {
          return "<div class='translation-div font-13'><br /><em>".concat(window.TRANSLATION, ":</em><br />").concat(post.Translation, "</div>");
        }
        return '';
      }(), "</div>\n                <div class=\"cell preview-fade\">\n                    <a id=\"expand-button-post-").concat(post.EntityType, "-").concat(post.EntityId, "\" href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.ExpandPostPreview('").concat(post.EntityType, "','").concat(post.EntityId, "','open')\">").concat(window.SHOW_MORE, "  <img style=\"width:13px; height: 13px;\" src=\"/Content/dist/images/icons/DownArrow.svg\" /></a>\n                </div>\n                <div class=\"cell preview-show\">\n                    <a id=\"contract-button-post-").concat(post.EntityType, "-").concat(post.EntityId, "\" href=\"javascript:void(0)\" class=\"hover-underline\" onClick=\"window.SocialProfile.ExpandPostPreview('").concat(post.EntityType, "','").concat(post.EntityId, "','close')\">").concat(window.SHOW_LESS, "  <img style=\"width:13px; height: 13px;\" src=\"/Content/dist/images/icons/UpArrow.svg\" /></a>\n                </div>\n                                <div class=\"cell hr expand\"></div>\n                <div class=\"baseline-controls\">\n                <div class=\"control-group\">\n                    <div class=\"control\">\n                        <i class=\"thumbsup icon buffer ").concat(function () {
        if (myVote === 'up') {
          return "my";
        }
      }() || '', "\" onClick=\"window.SocialProfile.Thumbs('up','ReviewComment','").concat(post.EntityId, "',this)\"></i>\n                    </div>\n                    <div class=\"control vote-score\">").concat(function () {
        if (post !== undefined && post !== null && post.VoteScore !== undefined) {
          return "".concat(post.VoteScore);
        } else {
          return "0";
        }
      }(), "\n            </div>\n                    <div class=\"control\">\n                        <i class=\"thumbsdown icon ").concat(function () {
        if (myVote === 'down') {
          return "my";
        }
      }() || '', "\" onClick=\"window.SocialProfile.Thumbs('down','ReviewComment','").concat(post.EntityId, "',this)\"></i>\n                    </div>\n                    </div>\n                   \n                    <div class=\"control-group last\">\n                    \n                        <div class=\"control\">\n                            <a href=\"javascript:void(0)\" class=\"waves-effect go-to-task-button\" onClick=\"window.SocialProfile.GoToReviewComment('").concat(post.EntityId, "')\">").concat(window.GO_TO_COMMENT, "</a>\n                        </div>\n                    </div>\n                    </div>\n\n                </div>\n            </div>\n        </div>");
      return stringTemplate;
    }
  }, {
    key: "RenderForumPost",
    value: function RenderForumPost(forumStateKey, post, myVote, topicSocialProfileId) {
      var _this34 = this;
      var myDate = moment.duration(moment.utc(post.CreatedAtString).diff(this.now)).humanize(true);
      var stringTemplate = "<div class='forum-post-wrap is-post' id='post-box-".concat(post.PostId, "'>\n            <div class=\"frn-flex-row column review-box\">\n                <div class=\"cell lesser-text show-when-small\" style=\"margin-top:-10px\">").concat(myDate, "</div>\n                <div class=\"cell-group review-header\">\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image social-profile-navigate\" src=\"").concat(this.avatarPath).concat(post.Reviewer.ImageKey, "\" data-profile-id=\"").concat(post.Reviewer.Id, "\"/>\n                    </div>\n                    <div class=\"cell-group reviewer-info column\">\n                        <div class=\"cell-group verification-group\">\n                            <span class=\"name-cell social-profile-navigate\" data-profile-id=\"").concat(post.Reviewer.Id, "\">").concat(post.Reviewer.PublicName, "</span>\n\n                            ").concat(function () {
        if (topicSocialProfileId == post.SocialProfileId) {
          return "<div class=\"cell\"> <span class=\"cell lesser-text inline-forum-label-discussion-starter ml-2\"> <img src=\"/Content/dist/images/icons/rocket.svg\" />".concat(window.DISCUSSION_STARTER, " </span> </div>");
        }
        return "";
      }(), "\n                            ").concat(function () {
        if (post.Reviewer.IsModerator) {
          return "<div class=\"cell\"> <span class=\"cell lesser-text inline-forum-label-moderator ml-2\"> ".concat(window.PortalCode, " ").concat(window.MODERATOR, " </span> </div>");
        }
        return "";
      }(), "\n                            ").concat(function () {
        if (post.IsPinned) {
          return " \n                                            <div class=\"cell pl-2\"> <img src=\"/Content/dist/images/icons/pin.svg\" /> </div > ";
        }
        return "";
      }(), "\n\n                        </div>\n                        ").concat(function () {
        if (post.Reviewer.Country != null && post.Reviewer.Country != undefined) {
          return "<div class=\"cell reviewer-info lesser-text\">".concat(window.LOCATION, ": ").concat(post.Reviewer.Country, "</div>");
        }
        return "";
      }(), "\n            ").concat(function () {
        if (post.Reviewer.JoinedDate != null && post.Reviewer.JoinedDate != undefined) {
          return "<div class=\"cell reviewer-info lesser-text\">".concat(window.JOINED, ": ").concat(moment.duration(moment.utc(post.Reviewer.JoinedDateString).diff(_this34.now)).humanize(true), "</div>");
        }
        return "";
      }(), "\n                    </div>\n                    <div class=\"cell-group last\">\n\n                        ").concat(function () {
        if (post.CanModerate && !post.IsPinned) {
          return "\n                                    <div class=\"spinner-border spinner-border-sm hide\" role=\"status\" style=\"margin-right: 15px\"> <span class=\"sr-only\">Loading...</span> </div>\n                                    <div onClick=\"window.SocialProfile.PinPost(this, ".concat(post.PostId, ", true)\" class=\"cell inline-forum-pin pr-3\"> <img src=\"/Content/dist/images/icons/unpin.svg\" style=\"height: 18px;\" /> </div>");
        } else if (post.CanModerate && post.IsPinned) {
          return "\n                                    <div class=\"spinner-border spinner-border-sm hide\" role=\"status\" style=\"margin-right: 15px\"> <span class=\"sr-only\">Loading...</span> </div>\n                                    <div onClick=\"window.SocialProfile.PinPost(this, ".concat(post.PostId, ", false)\" class=\"cell inline-forum-pin pr-3\"> <img src=\"/Content/dist/images/icons/pin.svg\" style=\"height: 18px;\" /> </div>");
        }
        return "";
      }(), "\n\n                    <div class=\"cell buffer lesser-text hide-when-small\" style=\"margin-top:-3px\">").concat(myDate, "</div>\n                     ").concat(function () {
        if (post.ViewerCanEdit === true) {
          return "<div class=\"cell dots\"><img src=\"/Content/dist/images/icons/3dots.svg\"  \n                                                        data-toggle='post-edit-menu'\n                                                        data-target-id='forum-edit-menu'\n                                                        data-placement='top'\n                                                        data-forum-holder='".concat(forumStateKey, "'\n                                                        data-trigger='hover toggle'\n                                                        data-html='true'\n                                                        data-entityType = 'POST'\n                                                        data-authorid='").concat(post.Reviewer.Id, "'\n                                                        data-postid='").concat(post.PostId, "'/></div>");
        }
        return "";
      }(), "\n                </div>\n                </div>\n\n                <div class=\"cell-group review-body row\"  data-comment-author=\"").concat(post.Reviewer.PublicName, "\"  \n                id=\"post-content-").concat(post.PostId, "\">\n                ").concat(function () {
        if (post.DeletedPost === true) {
          return window.DELETED_POST;
        }
        if (post.Content !== undefined && post.Content !== null) {
          return post.Content.trim();
        }
        return "";
      }(), "</div>").concat(function () {
        if (post.DeletedPost != true && post.Images !== undefined) {
          var imageGallery = '';
          if (post.Images.length) {
            imageGallery = "<div class=\"image-row\">";
          }
          post.Images.forEach(function (num, index) {
            var img = post.Images[index];
            imageGallery += "<img src=\"".concat(_this34.imagePathForum).concat(img.FileName, "\" class=\"review-img lightbox-slide\" />");
          });
          if (imageGallery.length > 0) {
            imageGallery += "</div>";
          }
          return imageGallery;
        }
        return "";
      }(), "<div class=\"cell hr expand\"></div>\n                <div class=\"baseline-controls\">\n                <div class=\"control-group\">\n                    <div class=\"control\">\n                    ").concat(function () {
        if (post.DeletedPost !== true) {
          return "<i class=\"thumbsup icon buffer ".concat(function () {
            if (myVote === 'up') {
              return "my";
            }
          }() || '', "\" onClick=\"window.SocialProfile.Thumbs('up','Post','").concat(post.PostId, "',this)\"></i>");
        }
      }() || '', "\n                    </div>\n                    <div class=\"control vote-score\">").concat(function () {
        if (post !== undefined && post !== null && post.VoteScore !== undefined) {
          return "".concat(post.VoteScore);
        } else {
          return "0";
        }
      }(), "</div>\n                    <div class=\"control\">\n                                        ").concat(function () {
        if (post.DeletedPost !== true) {
          return "<i class=\"thumbsdown icon ".concat(function () {
            if (myVote === 'down') {
              return "my";
            }
          }() || '', "\" onClick=\"window.SocialProfile.Thumbs('down','Post','").concat(post.PostId, "',this)\"></i>");
        }
      }() || '', "</div>\n                    </div>\n                    <div class=\"control-group\">\n                        <div class=\"control\">\n                        <i class=\"reply-to-post icon\"></i>\n                        </div> \n                        <div class=\"control\">\n                            <a href=\"javascript:void(0)\"  id='open-post-comment-").concat(post.PostId, "' onClick=\"window.SocialProfile.OpenCommentForCreate(this, '").concat(post.PostId, "','','").concat(forumStateKey, "')\">").concat(window.LEAVE_A_REPLY, "</a>\n                        </div>\n                    </div>\n                    </div>\n                </div>\n            </div>\n            <div class='comment-wrap' id='comment-post-").concat(post.PostId, "'>\n                <div id='comment-list-").concat(post.PostId, "'></div>\n               \n            </div> \n        </div>");
      return stringTemplate;
    }
  }, {
    key: "RenderComment",
    value: function RenderComment(comment) {
      var _this35 = this;
      var myVote = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var myDate = moment.duration(moment.utc(comment.CreatedAtString).diff(this.now)).humanize(true);
      var stringTemplate = "<div class='review-wrap ".concat(function () {
        if (comment.Status.toLowerCase() === 'rejected') {
          return "rejected-post";
        }
        return "";
      }(), "'>\n            <div class=\"frn-flex-row column review-box ").concat(comment.Status.toLowerCase(), "\" id=\"review-comment-").concat(comment.AttachedToPostId, "-").concat(comment.Id, "\">\n                <div class=\"cell-group review-header mb-2\">\n<div class=\"cell-group profile-header frn-flex-middle\">\n\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image social-profile-navigate\" src=\"").concat(this.avatarPath).concat(comment.Author.ImageKey, "\"  data-profile-id=\"").concat(comment.Author.Id, "\"/>\n                    </div>\n                    <div class=\"cell-group reviewer-info column\">\n                        <div class=\"cell-group verification-group \">\n                            <span class=\"name-cell social-profile-navigate\" data-profile-id=\"").concat(comment.Author.Id, "\">").concat(comment.Author.PublicName, "</span>\n                             ").concat(function () {
        if (comment.ReviewerIsCompanyRep) {
          return "<div class=\"reviewer-status representitive d-none d-sm-flex\"><div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/checkcircle.svg\" caption=\"false\"></div><div class=\"verified-icon-text\">".concat(window.COMPANY_REPRESENTATIVE, "</div></div>");
        } else {
          if (comment.ReviewerIsVerified) {
            return "<div class=\"reviewer-status verified d-none d-sm-flex\"><div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/checkcircle.svg\" caption=\"false\"></div><div class=\"verified-icon-text\">".concat(window.VERIFIED_REVIEWER, "</div></div>");
          } else {
            return "<div class=\"reviewer-status unverified d-none d-sm-flex\"><div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/warningcircle.svg\" caption=\"false\"></div><div class=\"verified-icon-text\">".concat(window.UNVERIFIED_REVIEWER, "</div></div>");
          }
        }
      }(), "  \n            ").concat(function () {
        if (comment.Author.IsModerator) {
          return "<div class=\"cell\"> <span class=\"cell lesser-text inline-forum-label-moderator ml-2\"> ".concat(window.PortalCode, " ").concat(window.MODERATOR, " </span> </div>");
        }
        return "";
      }(), "\n                        </div>\n                        ").concat(function () {
        if (comment.Author.Country != null && comment.Author.Country != undefined) {
          return "<div class=\"cell reviewer-info lesser-text\">".concat(window.LOCATION, ":").concat(comment.Author.Country, "</div>");
        }
        return '';
      }(), "\n\n                        ").concat(function () {
        if (comment.VerifiedAccountsList !== "") {
          return "<div class=\"cell reviewer-info lesser-text\">\n                                            ".concat(window.ACCOUNT_LIST, " ").concat(comment.VerifiedAccountsList, "\n                                        </div>");
        }
        return "";
      }(), "\n</div>\n                    </div>\n                    \n                    <div class=\"cell-group last column\">\n                        <div class=\"cell lesser-text\">\n                                                ").concat(myDate, "\n                        </div>\n                        <div class=\"cell status-cell\">\n                        ").concat(function () {
        if (comment.Status.toLowerCase() === 'pending') {
          return "<span class=\"status-badge\">".concat(window.PENDING, "</span>");
        }
        if (comment.Status.toLowerCase() === 'rejected') {
          return "<span class=\"status-badge\">".concat(window.REJECTED, "</span>");
        }
        return "";
      }(), "\n                        </div>\n                    </div>\n                </div>\n               <div class='flex'>\n               ").concat(function () {
        if (comment.ReviewerIsCompanyRep) {
          return "<div class=\"reviewer-status representitive d-flex d-sm-none\"><div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/checkcircle.svg\" caption=\"false\"></div><div class=\"verified-icon-text\">".concat(window.COMPANY_REPRESENTATIVE, "</div></div>");
        } else {
          if (comment.ReviewerIsVerified) {
            return "<div class=\"reviewer-status verified d-flex d-sm-none\"><div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/checkcircle.svg\" caption=\"false\"></div><div class=\"verified-icon-text\">".concat(window.VERIFIED_REVIEWER, "</div></div> ");
          } else {
            return "<div class=\"reviewer-status unverified d-flex d-sm-none\"><div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/warningcircle.svg\" caption=\"false\"></div><div class=\"verified-icon-text\">".concat(window.UNVERIFIED_REVIEWER, "</div></div>");
          }
        }
      }(), "\n               </div>\n                <div class=\"cell-group review-body row\">\n                ").concat(comment.Comment, "</div>\n\n                ").concat(function () {
        if (comment.HasTranslation) {
          return "<div class='translation-div font-13'><br /><em>".concat(window.TRANSLATION, ":</em><br />").concat(comment.Translation, "</div>");
        }
        return '';
      }(), "\n\n             ").concat(function () {
        var imageCommentGallery = '';
        if (comment.Images && comment.Images.length) {
          imageCommentGallery = "<div class=\"image-row\">";
        }
        comment.Images && comment.Images.forEach(function (num, index) {
          var img = comment.Images[index];
          imageCommentGallery += "<img src=\"".concat(_this35.imagePathComment).concat(img.FileName, "\" class=\"review-img lightbox-slide\" />");
        });
        if (imageCommentGallery.length > 0) {
          imageCommentGallery += "</div>";
        }
        return imageCommentGallery;
      }(), "\n\n                ").concat(function () {
        if (comment.Status.toLowerCase() === 'approved') {
          return "<div class=\"cell hr expand\"></div>\n                            <div class=\"baseline-controls\">\n                                <div class=\"control\">\n                                    <i class=\"thumbsup icon buffer ".concat(function () {
            if (myVote === 'up') {
              return "my";
            }
          }() || '', "\" onClick=\"window.SocialProfile.Thumbs('up','ReviewComment','").concat(comment.Id, "',this)\"></i>\n                                </div>\n                                <div class=\"control vote-score\">").concat(comment.VoteScore, "</div>\n                                <div class=\"control\">\n                                    <i class=\"thumbsdown icon  ").concat(function () {
            if (myVote === 'down') {
              return "my";
            }
          }() || '', "\" onClick=\"window.SocialProfile.Thumbs('down','ReviewComment','").concat(comment.Id, "',this)\"></i>\n                                </div>\n                                <div class=\"control open-reply\">\n                                ").concat(function () {
            if (comment.ReplyCount === 1) {
              return "<a href=\"javascript:void(0)\" onClick=\"window.SocialProfile.OpenReply('".concat(comment.Id, "','").concat(comment.AttachedToPostId, "','Review')\">").concat(window.ONE_REPLY, "</a>");
            } else if (comment.ReplyCount > 0) {
              return "<a href=\"javascript:void(0)\" onClick=\"window.SocialProfile.OpenReply('".concat(comment.Id, "','").concat(comment.AttachedToPostId, "','Review')\">").concat(window.X_REPLIES.replace('{0}', comment.ReplyCount), "</a>");
            } else {
              return "<a href=\"javascript:void(0)\" onClick=\"window.SocialProfile.OpenReply('".concat(comment.Id, "','").concat(comment.AttachedToPostId, "','Review')\">").concat(window.LEAVE_A_REPLY, "</a>");
            }
          }(), "\n                                </div>\n                            </div>\n\n                            <div class='reply-wrap' id='reply-post-").concat(comment.Id, "'>\n                            \n                            </div> ");
        }
        return "";
      }(), "\n            </div>");
      return stringTemplate;
    }
  }, {
    key: "RenderForumComment",
    value: function RenderForumComment(forumStateKey, comment) {
      var _this36 = this;
      var isAnon = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
      var isFirst = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : false;
      var isLast = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
      var replies = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : [];
      var myDate = moment.duration(moment.utc(comment.CreatedAtString).diff(this.now)).humanize(true);
      var myVote = '';
      if (!isAnon) {
        if (comment.UpVoters.includes(this.MyProfile.Id.toString())) {
          myVote = 'up';
        } else if (comment.DownVoters.includes(this.MyProfile.Id.toString())) {
          myVote = 'down';
        }
      } else if (this.AnonSocialProfileLikes.length) {
        var intId = parseInt(comment.Id, 10);
        myVote = this.GetAnonThumbState(intId, 'ForumComment');
      }
      var stringTemplate = "\n        <div class='comment-combo'>\n            <div class='reply-trail ".concat(function () {
        if (replies.length) {
          return "comment-has-replies";
        } else {
          return "";
        }
      }(), "' >\n                <div class='reply-trail-col'>\n                    <div class='reply-trail-line ").concat(function () {
        if (isFirst) {
          return "first";
        }
        return "";
      }(), "'></div>    \n                    <div class='reply-trail-line-tail ").concat(function () {
        if (isLast) {
          return "hide";
        }
        return "";
      }(), "'></div>\n                </div>\n            </div>\n            <div class='forum-post-wrap is-comment' id='forum-comment-box-").concat(comment.Id, "'>\n                <div class=\"frn-flex-row column review-box\">\n                <div class=\"cell lesser-text show-when-small\" style=\"margin-top:-10px\">").concat(myDate, "</div>\n                    <div class=\"cell-group review-header mb-2\">\n                        <div class=\"cell-group profile-header frn-flex-middle expand buffer min-144\">\n                            <div class=\"cell image-cell\">\n                                <img class=\"reviewer-image social-profile-navigate\" src=\"").concat(this.avatarPath).concat(comment.Author.ImageKey, "\" data-profile-id=\"").concat(comment.Author.Id, "\"/>\n                            </div>\n                                <div class=\"cell-group reviewer-info column expand\">\n                                    <div class=\"cell-group verification-group \">\n                                        <span class=\"name-cell social-profile-navigate\" data-profile-id=\"").concat(comment.Author.Id, "\">").concat(comment.Author.PublicName, "</span>\n                                        ").concat(function () {
        if (comment.AuthorIsTopicCreator === true) {
          return "<div class=\"cell\"> <span class=\"cell lesser-text inline-forum-label-discussion-starter ml-2\"> <img src=\"/Content/dist/images/icons/rocket.svg\" />".concat(window.DISCUSSION_STARTER, " </span> </div>");
        }
        return "";
      }(), "\n              ").concat(function () {
        if (comment.Author.IsModerator) {
          return "<div class=\"cell\"> <span class=\"cell lesser-text inline-forum-label-moderator ml-2\"> ".concat(window.PortalCode, " ").concat(window.MODERATOR, " </span> </div>");
        }
        return "";
      }(), "\n                                    </div>\n                                    <div class=\"cell-group expand\">\n                                    <div class=\"cell-group column lesser-text\">\n                                    ").concat(function () {
        if (comment.Author.Country != null && comment.Author.Country != undefined) {
          return "<div class=\"cell reviewer-info\">".concat(window.LOCATION, ": ").concat(comment.Author.Country, "</div>");
        }
        return "";
      }(), "\n\n                ").concat(function () {
        if (comment.Author.JoinedDate != null && comment.Author.JoinedDate != undefined) {
          return "<div class=\"cell reviewer-info\">".concat(window.JOINED, ": ").concat(moment.duration(moment.utc(comment.Author.JoinedDateString).diff(_this36.now)).humanize(true), "</div>");
        }
        return "";
      }(), "      </div>\n                    <div class=\"cell-group expand middle\">\n                     ").concat(function () {
        if (parseInt(comment.ReplyToCommentId, 10) > 0) {
          return "<div class='cell replying-to-info'>".concat(window.REPLYING_TO_COMMENT_BY.replace('{0}', "<a href=\"javascript:void(0)\" onClick=\"window.SocialProfile.ScrollTo('".concat(forumStateKey, "','forum-comment-box-").concat(comment.ReplyToCommentId, "', '").concat(comment.AttachedToPostId, "')\">@").concat(comment.ReplyingTo, "</a>")), "</div>");
        } else {
          return "<div class='cell replying-to-info'>".concat(window.REPLYING_TO_POST_BY.replace('{0}', "<a href=\"javascript:void(0)\" onClick=\"window.SocialProfile.ScrollTo('".concat(forumStateKey, "','post-box-").concat(comment.AttachedToPostId, "')\">@").concat(comment.ReplyingTo, "</a>")), "</div>");
        }
      }(), "\n            </div>\n            </div>\n                                </div>\n                          \n                            </div>\n                  \n                        <div class=\"cell-group last\">\n                            <div class=\"cell buffer lesser-text hide-when-small\" style=\"margin-top:-3px\">").concat(myDate, "</div>\n                              ").concat(function () {
        if (comment.ViewerCanEdit === true) {
          return "<div class=\"cell last dots\"><img src=\"/Content/dist/images/icons/3dots.svg\"  \n                                                            data-toggle='comment-edit-menu'\n                                                            data-forum-holder='".concat(forumStateKey, "'\n                                                            data-target-id='forum-edit-column-menu'\n                                                            data-placement='top'\n                                                            data-trigger='hover toggle'\n                                                            data-html='true'\n                                                            data-commentid='").concat(comment.Id, "'\n                                                            data-postid='").concat(comment.AttachedToPostId, "'/></div>");
        }
        return "";
      }(), "\n                        </div>\n                    </div>\n                   <div class='flex'>\n               \n                   </div>\n                    <div class=\"cell-group review-body row\" data-comment-author=\"").concat(comment.Author.PublicName, "\" \n                    id=\"comment-content-").concat(comment.Id, "\">\n                    ").concat(function () {
        if (comment.DeletedComment === true) {
          return window.DELETED_POST;
        }
        if (comment.Content !== undefined && comment.Content !== null) {
          return comment.Content.trim();
        }
        return "";
      }(), "</div> ").concat(function () {
        if (comment.DeletedComment === true) {
          return "";
        }
        var imageCommentGallery = '';
        if (comment.Images.length) {
          imageCommentGallery = "<div class=\"image-row\">";
        }
        comment.Images.forEach(function (num, index) {
          var img = comment.Images[index];
          imageCommentGallery += "<img src=\"".concat(_this36.imagePathComment).concat(img.FileName, "\" class=\"review-img lightbox-slide\" />");
        });
        if (imageCommentGallery.length > 0) {
          imageCommentGallery += "</div>";
        }
        return imageCommentGallery;
      }(), "\n\n                    ").concat(function () {
        return "\n                            <div class=\"cell hr expand\"></div>\n                            <div class=\"baseline-controls\">\n                                <div class=\"control-group\">\n                                    <div class=\"control\"> ".concat(function () {
          if (comment.Status.toLowerCase() === 'approved') {
            return "<i class=\"thumbsup icon buffer ".concat(function () {
              if (myVote === 'up') {
                return "my";
              }
            }() || '', "\" onClick=\"window.SocialProfile.Thumbs('up','ForumComment','").concat(comment.Id, "',this)\"></i>");
          }
        }() || '', "\n                                    </div>\n                                    <div class=\"control vote-score\">").concat(comment.VoteScore, "</div>\n                                    <div class=\"control\"> ").concat(function () {
          if (comment.Status.toLowerCase() === 'approved') {
            return "<i class=\"thumbsdown icon  ".concat(function () {
              if (myVote === 'down') {
                return "my";
              }
            }() || '', "\" onClick=\"window.SocialProfile.Thumbs('down','ForumComment','").concat(comment.Id, "',this)\"></i>");
          }
        }() || '', "\n                                    </div>\n                                </div>\n                                <div class=\"control-group\">\n                                    <div class=\"control\">\n                                        <i class=\"reply-to-post icon\"></i>\n                                    </div>\n                                    <div class=\"control\">\n                                        <a href=\"javascript:void(0)\" id='open-comment-reply-").concat(comment.Id, "' onClick=\"window.SocialProfile.OpenCommentForCreate(this, '").concat(comment.AttachedToPostId, "','").concat(comment.Id, "','").concat(forumStateKey, "')\">").concat(window.LEAVE_A_REPLY, "</a>\n                                    </div>\n                                </div>\n                            </div>");
      }(), "\n                </div>\n                ").concat(function () {
        if (replies.length) {
          var repliesToCommentString = '';
          var isFirstCommentInList = false;
          var isLastCommentInList = false;
          var numberofComments = replies.length;
          _this36.SortCommentByDate(replies);
          replies.forEach(function (num, index) {
            if (index == 0) {
              isFirstCommentInList = true;
            } else {
              isFirstCommentInList = false;
            }
            if (index == numberofComments - 1) {
              isLastCommentInList = true;
            } else {
              isLastCommentInList = false;
            }
            repliesToCommentString += _this36.RenderForumComment(forumStateKey, replies[index], isAnon, isFirstCommentInList, isLastCommentInList);
          });
          return "<div class='reply-wrap' data-show-under-comment='".concat(comment.Id, "' style='display:block' id='reply-post-").concat(comment.Id, "'>").concat(repliesToCommentString, "</div>");
        }
        return "";
      }(), "\n            </div>\n           \n        </div>\n          ");
      return stringTemplate;
    }
  }, {
    key: "RenderMoreCommentsLink",
    value: function RenderMoreCommentsLink(forumStateKey, numMoreComments, postId) {
      var view_x_replies = VIEW_ALL_X_REPLIES.replace('{0}', numMoreComments);
      var stringTemplate = "\n        <div class='comment-combo'>\n            <div class='reply-trail'>\n                <div class='reply-trail-col'>\n                    <div class='reply-trail-line'></div>    \n                </div>\n            </div>\n            <div class=\"forum-post-wrap\">\n                <div class=\"control\">\n                    <a href=\"javascript:void(0)\"  id='open-post-comment-".concat(postId, "' onClick=\"window.SocialProfile.OpenForumComment('").concat(forumStateKey, "','").concat(postId, "')\">").concat(view_x_replies, "</a>\n                </div>\n            </div>\n        </div>");
      return stringTemplate;
    }
  }, {
    key: "RenderReplyFrame",
    value: function RenderReplyFrame(replyToCommentId, postId, source) {
      var _this37 = this;
      var stringTemplate = "<div class='add-reply frn-flex-row mt-2 pl-2'>\n        <div class=\"cell image-cell\">\n            <img class=\"reviewer-image social-profile-navigate\" src=\"".concat(this.avatarPath).concat(function () {
        if (_this37.MyProfile.ImageKey !== "" && _this37.MyProfile.ImageKey !== undefined && _this37.MyProfile.ImageKey !== null) {
          return _this37.MyProfile.ImageKey;
        }
        return "null";
      }(), "\"  data-profile-id=\"").concat(function () {
        if (_this37.MyProfile.Id !== "" && _this37.MyProfile.Id !== undefined && _this37.MyProfile.Id !== null) {
          return _this37.MyProfile.Id;
        }
        return "self";
      }(), "\"/>\n        </div>\n        <div class=\"cell comment-box expand form-group\" style=\"padding-right:15px\";>\n            <input type=\"text\" class=\"comment-box-input form-control mb-0 frn-override text-box single-line\" style=\"padding-left:0; padding-right:0; text-indent: 10px\" />\n            <div class=\"progress primary-color-light tab-progress\" style=\"display: none;\">\n                <div class=\"indeterminate\"></div>\n            </div>\n        </div>\n\n        <div class=\"submit-comment-div last\">\n            <a href=\"javascript:void(0)\" onclick=\"window.SocialProfile.SaveReply(this,'").concat(postId, "','").concat(replyToCommentId, "')\" role=\"button\" class=\"button waves-effect add-reply-button ").concat(function () {
        if (source == 'ForumPost') return "forum-comment";else return "";
      }(), "\">").concat(window.REPLY, "</a>\n        </div>\n    </div>\n    <div id='reply-list-").concat(replyToCommentId, "'></div>");
      return stringTemplate;
    }

    //RenderForumReply(comment) {

    //    var myDate = moment.duration(moment.utc(comment.CreatedAtString).diff(this.now)).humanize(true);
    //    let stringTemplate = `
    //    <div class='reply-post-wrap is-reply'  id='forum-comment-box-${comment.Id}'>
    //        <div class="frn-flex-row review-box">
    //            <div class="cell reply-group column expand">
    //            <div class="cell-group review-header mb-2">
    //                <div class="cell-group profile-header frn-flex-middle ${(() => {
    //            if (comment.Status.toLowerCase() === 'rejected') {
    //                return `rejected-post`;
    //            } return ``;
    //        })()
    //        }">
    //                    <div class="cell image-cell">
    //                        <img class="reviewer-image social-profile-navigate" src="/content/dist/social/avatars/${comment.Author.Image}" data-profile-id="${comment.Author.Id}"/>
    //                    </div>
    //                    <div class="cell-group reviewer-info column">
    //                        <div class="cell-group verification-group">
    //                            <span class="name-cell social-profile-navigate" data-profile-id="${comment.Author.Id}">${comment.Author.PublicName}</span>
    //                        </div>
    //                        ${(() => {
    //            if (comment.Author.Country != null && comment.Author.Country != undefined) {
    //                return `<div class="cell reviewer-info lesser-text">${window.LOCATION}: ${comment.Author.Country}</div>`;
    //            }
    //            return '';
    //        })()
    //        }
    //                        ${(() => {
    //            if (comment.Author.JoinedDate != null && comment.Author.JoinedDate != undefined) {
    //                return `<div class="cell reviewer-info lesser-text">${window.JOINED}: ${moment.duration(moment.utc(comment.Author.JoinedDateString).diff(this.now)).humanize(true)}</div>`;
    //            }
    //            return ``;
    //        })()
    //        }   
    //                    </div>  
    //                </div>
    //                 <div class="cell-group last">
    //                    <div class="cell buffer lesser-text">
    //                        ${myDate}
    //                    </div>
    //                      ${(() => {
    //            if (comment.ViewerCanEdit === true) {
    //                return `<div class="cell last dots"><img src="/Content/dist/images/icons/3dots.svg"  
    //                                                    data-toggle='comment-edit-menu'
    //                                                    data-target-id='forum-edit-column-menu'
    //                                                    data-placement='top'
    //                                                    data-trigger='hover toggle'
    //                                                    data-html='true'
    //                                                    data-commentid='${comment.Id}'
    //                                                    data-postid='${comment.AttachedToPostId}'/></div>`
    //            }
    //            return ``;
    //        })()}
    //                </div>
    //            </div>

    //            <div class="cell-group review-body row" id="comment-content-${comment.Id}">${comment.Content}</div>
    //            </div>
    //        </div>
    //        </div>
    //        `;

    //    return stringTemplate;
    //}
  }, {
    key: "RenderReply",
    value: function RenderReply(comment) {
      //const dateObject = new Date(comment.CreatedAt);
      var myDate = moment.utc(comment.CreatedAt);
      var stringTemplate = "\n        <div class='reply-post-wrap'>\n            <div class=\"frn-flex-row review-box\" id=\"review-comment-reply-".concat(comment.AttachedToPostId, "-").concat(comment.ReplyToCommentId, "-").concat(comment.Id, "\">\n                <div class=\"cell reply-group column expand\">\n                <div class=\"cell-group review-header mb-2\">\n                    <div class=\"cell-group profile-header frn-flex-middle ").concat(function () {
        if (comment.Status.toLowerCase() === 'rejected') {
          return "rejected-post";
        }
        return "";
      }(), "\">\n                    <div class=\"cell image-cell\">\n                        <img class=\"reviewer-image social-profile-navigate\" src=\"").concat(this.avatarPath).concat(comment.Author.ImageKey, "\" data-profile-id=\"").concat(comment.Author.Id, "\"/>\n                    </div>\n                    <div class=\"cell-group reviewer-info column\">\n                        <div class=\"cell-group verification-group\">\n                            <span class=\"name-cell social-profile-navigate\" data-profile-id=\"").concat(comment.Author.Id, "\">").concat(comment.Author.PublicName, "</span>\n                            ").concat(function () {
        if (comment.ReviewerIsCompanyRep) {
          return "<div class=\"reviewer-status representitive\"><div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/checkcircle.svg\" caption=\"false\"></div></div>";
        } else {
          if (comment.ReviewerIsVerified) {
            return "<div class=\"reviewer-status verified\"><div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/checkcircle.svg\" caption=\"false\"></div></div>";
          } else {
            return "<div class=\"reviewer-status unverified\"><div class=\"verified-icon\"><img src=\"/Content/dist/images/icons/warningcircle.svg\" caption=\"false\"></div></div>";
          }
        }
      }(), "\n\n\n                        </div>\n                        ").concat(function () {
        if (comment.Author.Country != null && comment.Author.Country != undefined) {
          return "<div class=\"cell reviewer-info lesser-text\">".concat(window.LOCATION, ":").concat(comment.Author.Country, "</div>");
        }
        return '';
      }(), "\n                        ").concat(function () {
        if (comment.VerifiedAccountsList !== "") {
          return "<div class=\"cell reviewer-info lesser-text\">\n                                            ".concat(window.ACCOUNT_TYPES, ": ").concat(comment.VerifiedAccountsList, "\n                                        </div>");
        }
        return "";
      }(), "\n                        </div>  \n                    </div>\n                    <div class=\"cell-group last column\">\n                        <div class=\"cell lesser-text\">\n                            ").concat(moment.utc(comment.CreatedAt).format('LL'), "\n                        </div>\n                        <div class=\"cell status-cell\">\n                        ").concat(function () {
        if (comment.Status.toLowerCase() === 'pending') {
          return "<span class=\"status-badge\">".concat(window.PENDING, "</span>");
        }
        if (comment.Status.toLowerCase() === 'rejected') {
          return "<span class=\"status-badge\">".concat(window.REJECTED, "</span>");
        }
        return "";
      }(), "\n                        </div>\n                    </div>\n                </div>\n               \n                <div class=\"cell-group review-body row ").concat(function () {
        if (comment.Status.toLowerCase() === 'rejected') {
          return "rejected-post";
        }
        return "";
      }(), "\">").concat(comment.Comment, "</div>\n                </div>\n            </div>\n            </div>\n            ");
      return stringTemplate;
    }
  }, {
    key: "RenderStarRating",
    value: function RenderStarRating(rating) {
      var stars = '<div class="d-flex align-items-center">';
      var ratingColors = {
        5: "#27AE1E",
        4: "#85DF2C",
        3: "#FDC240",
        2: "#FA9529",
        1: "#FA4C3B"
      };
      var color = ratingColors[rating] || "#000000"; // Default color if no match

      if (rating >= 1 && rating <= 5) {
        stars += "\n            <div class=\"star-holder\" style=\"font-size: 20px; color: ".concat(color, ";\">\n                <span class=\"typcn stars-").concat(rating, "\"></span>\n                <span class=\"typcn outline-stars-").concat(5 - rating, "\"></span>\n                <span class=\"user-review-rating\">").concat(parseFloat(rating).toFixed(1), "</span>\n            </div>");
      } else {
        stars += "<div class='user-review-rating pl-0'>".concat(window.NO_RATING, "</div>");
      }
      stars += "</div>";
      return stars;
    }
  }, {
    key: "RenderStatusBadge",
    value: function RenderStatusBadge(isCompanyRep, isVerified) {
      var statusClass = '';
      var statusText = '';
      if (isCompanyRep) {
        statusClass = 'representitive';
        statusText = window.COMPANY_REPRESENTATIVE;
      } else if (isVerified) {
        statusClass = 'verified';
        statusText = window.VERIFIED_REVIEWER;
      } else {
        statusClass = 'unverified';
        statusText = window.UNVERIFIED_REVIEWER;
      }
      var badge = "\n        <div class=\"reviewer-status ".concat(statusClass, " d-flex\" style=\"margin-left:unset;\">\n            <div class=\"verified-icon\">\n                <img src=\"/Content/dist/images/icons/checkcircle.svg\" caption=\"false\">\n            </div>\n            <div class=\"verified-icon-text\">").concat(statusText, "</div>\n        </div>\n    ");
      return badge;
    }
  }, {
    key: "SubmitReview",
    value: function SubmitReview() {
      var _this38 = this;
      var progress = true;
      var parsed = parseInt($('#review-rating').val(), 10);
      var brokerId = parseInt($('#broker-id').val(), 10);
      var isVerified = parseInt($('#is-verified-value').val(), 10);
      var allAccountTypesChecked = $('#acc-type-all').is(':checked');
      var noRatingChecked = $('#no-rating-checkbox').is(':checked');
      var review = $('#review-input').val();
      var verifyBy = $('input[type="radio"][name="VerificationOption"]:checked').val();
      var login = '';
      var pass = '';
      var mtServer = '';
      if (!allAccountTypesChecked) {
        var accountChecked = false;
        $('#account-type-checkboxes input[type=checkbox]').each(function (i, e) {
          if ($(e).is(":checked")) {
            accountChecked = true;
          }
          ;
        });
        if (!accountChecked) {
          $('#account-type-error').parent().addClass('has-danger');
          progress = false;
        }
      }
      if (isNaN(parsed) || parsed < 1) {
        if (!noRatingChecked) {
          $('#review-rating').parent().addClass('has-danger');
          progress = false;
        }
      }
      if (review === '') {
        $('#review-input').parent().addClass('has-danger');
        progress = false;
      }
      if (isVerified !== 1) {
        if (verifyBy === undefined || verifyBy.isNaN) {
          $('#VerificationOption-error').parent().addClass('has-danger');
          progress = false;
        } else if (verifyBy === "1") {
          login = $('#investor-login').val();
          pass = $('#investor-password').val();
          if (login === undefined || login === "") {
            $('#investor-error').parent().addClass('has-danger');
            progress = false;
          }
          if (pass === undefined || pass === "") {
            $('#investor-password-error').parent().addClass('has-danger');
            progress = false;
          }
          if ($("#mt-broker-select-cell").is(':visible')) {
            mtServer = $("#mt-broker-select").val();
            if (!mtServer) {
              $("#mt-broker-select-error").parent().addClass("has-danger");
              progress = false;
            }
          }
        }
      }
      if (progress) {
        //;) {
        $('#submit-review-progress').show();

        // Create a new FormData object.
        var formData = new FormData();
        // Loop through each of the selected files.
        for (var i = 0; i < this.Lightbox.tmp_files.length; i++) {
          var file = this.Lightbox.tmp_files[i];

          // Check the file type.
          if (!file.type.match('image.*')) {
            continue;
          }
          formData.append('Files', file, file.name);
          // Add the file to the request.
        }

        var hasChecked = false;
        $('div#account-type-checkboxes input[type=checkbox]').each(function () {
          if ($(this).is(":checked")) {
            formData.append('AccountTypes', $(this).val());
            hasChecked = false;
          }
        });
        if (!hasChecked) {
          formData.append('AccountTypes', []);
        }
        formData.append('AllChecked', allAccountTypesChecked === true);
        formData.append('Rating', parsed);
        formData.append('NoRating', noRatingChecked);
        formData.append('PostBody', review);
        formData.append('BrokerId', brokerId);
        formData.append('IsVerified', isVerified);
        formData.append('VerifyBy', verifyBy);
        //formData.append('AccountTypes', rebateAccounts);
        if (verifyBy === "1") {
          formData.append('Login', login);
          formData.append('Pass', pass);
          formData.append("MTBroker", mtServer);
        }
        $.ajax({
          type: "POST",
          cache: false,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          processData: false,
          contentType: false,
          url: window.submitBrokerReviewUrl,
          dataType: "json",
          data: formData,
          async: false,
          success: function success(result) {
            if (result.Success === true) {
              $('#add-review-body').html(result.output);
              _this38.LoadCustomReviewData();
              $('#submit-review-progress').hide();
              _this38.IgniteForm();
              $('#dialog-add-review').modal("hide");
              toastr.success(window.YOUR_COMMENT_HAS_BEEN_SUBMITTED);
              return true;
            } else {
              $('#submit-review-progress').hide();
              $('#dialog-add-review').modal("hide");
              toastr.error(result.Message);
              return false;
            }
          },
          error: function error(result) {
            $('#submit-review-progress').hide();
            alert("An error has occurred " + result.Message);
            return false;
          },
          failure: function failure() {
            $('#submit-review-progress').hide();
            alert("Network error");
            return false;
          }
        });
      }
    }
  }, {
    key: "GetNotificationStatus",
    value: function GetNotificationStatus() {
      var _this39 = this;
      $.ajax({
        type: "POST",
        cache: false,
        url: window.notificationStatusUrl,
        dataType: "json",
        success: function success(result) {
          if (!_this39.notificationChangeState) {
            if ($('input[name=RepliesToMyPosts]').length) {
              $('input[name=RepliesToMyPosts]').prop('checked', result.SubscriptionStatus.RepliesToMyPostsNotifications);
            }
          }
        },
        error: function error(result) {},
        failure: function failure() {}
      });
      ;
    }
  }, {
    key: "GetExistingPostContent",
    value: function GetExistingPostContent(postId) {
      var _this40 = this;
      $.ajax({
        type: "POST",
        cache: false,
        url: window.openForumPostForEditUrl,
        dataType: "json",
        data: {
          postId: postId
        },
        success: function success(result) {
          $('#submit-post-progress').hide();
          if (result.Ok === true) {
            _this40.TopicId = result.TopicId;
            $('#add-post-body').html(result.Content);
            _this40.Lightbox.IgniteAddPostPhotoButton();
            return true;
          } else {
            toastr.error(result.Message);
            return false;
          }
        },
        error: function error(result) {
          $('#submit-post-progress').hide();
          alert("An error has occurred " + result.Message);
          return false;
        },
        failure: function failure() {
          $('#submit-post-progress').hide();
          alert("Network error");
          return false;
        }
      });
      ;
    }
  }, {
    key: "GetExistingCommentContent",
    value: function GetExistingCommentContent(commentId) {
      var _this41 = this;
      $.ajax({
        type: "POST",
        cache: false,
        url: window.openForumCommentForEditUrl,
        dataType: "json",
        data: {
          commentId: commentId
        },
        success: function success(result) {
          $('#submit-comment-progress').hide();
          if (result.Ok === true) {
            _this41.TopicId = result.TopicId;
            $('#add-comment-body').html(result.Content);
            if ($('input[name=RepliesToMyPosts]').length) {
              $('input[name=RepliesToMyPosts]').prop('checked', result.RepliesToMyPostsNotifications);
            }
            _this41.Lightbox.IgniteAddPostPhotoButton();
            $("#submit-comment-button").off("click").on("click", window.SocialProfile.SaveEditedComment);
            return true;
          } else {
            toastr.error(result.Message);
            $('#dialog-add-comment').modal("hide");
          }
        },
        error: function error(result) {
          $('#submit-comment-progress').hide();
          alert("An error has occurred " + result.Message);
          return false;
        },
        failure: function failure() {
          $('#submit-comment-progress').hide();
          alert("Network error");
          return false;
        }
      });
    }
  }, {
    key: "OpenPostForEdit",
    value: function OpenPostForEdit(containerId, postId) {
      $('[data-toggle="post-edit-menu"]').each(function () {
        // Hide the popover when clicking outside
        if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
          $(this).popover('hide');
        }
      });
      $('#submit-post-progress').show();
      $('#dialog-add-post').modal("show");
      $('#dialog-add-post').off('shown.bs.modal').on('shown.bs.modal', function (e) {
        $('#dialog-add-post').data('postId', postId);
        $('#dialog-add-post').data('containerId', containerId);
        window.SocialProfile.GetExistingPostContent(postId);
      });
    }
  }, {
    key: "OpenCommentForEdit",
    value: function OpenCommentForEdit(containerId, commentId, postId) {
      window.SocialProfile.PrepareEditCommentInput(containerId, commentId, postId).then(function (res) {
        if (res) {
          window.SocialProfile.GetExistingCommentContent(commentId);
        }
      });
    }
  }, {
    key: "PrepareEditCommentInput",
    value: function PrepareEditCommentInput(containerId, commentId, postId) {
      return new Promise(function (resolve, reject) {
        $('[data-toggle="comment-edit-menu"]').each(function () {
          // Hide the popover when clicking outside
          if (!$(this).is(e.target) && $(this).has(e.target).length === 0 && $('.popover').has(e.target).length === 0) {
            $(this).popover('hide');
          }
        });
        $('#comment-input').val("loading...");
        $('#dialog-add-comment').off('shown.bs.modal').on('shown.bs.modal', function (e) {
          $('#dialog-add-comment').data('commentId', commentId);
          $('#dialog-add-comment').data('postId', postId);
          $('#dialog-add-comment').data('containerId', containerId);
          $('#submit-comment-button').off('click').on('click', window.SocialProfile.SaveEditedComment);
        }).modal("show");
        $('#submit-comment-progress').show();
        resolve(true);
      });
    }
  }, {
    key: "OpenCommentForCreate",
    value: function OpenCommentForCreate(embeddedbutton, postId, replyToCommentId, containerId) {
      var _this42 = this;
      if (containerId === undefined || containerId === null) {
        var container = embeddedbutton.closest('div.forum-holder');
        if (container != null) {
          containerId = container.id;
        }
      }
      if (!window.userIsOnline) {
        var data = {
          postId: postId,
          replyToCommentId: replyToCommentId,
          containerId: containerId
        };
        window.Access.LoginWithPurpose('OpenCommentForCreate', window.YOU_MUST_BE_LOGGED_IN_TO_PERFORM_THIS_ACTION, 'login', '', JSON.stringify(data), 'window.SocialProfile');
        return;
      }
      this.GetNotificationStatus();
      var author = "";
      window.Lightbox.tmp_files = new Array();
      $('#img-comment-frames').empty();
      if (replyToCommentId != '' && replyToCommentId != undefined && replyToCommentId != null) {
        author = $('#comment-content-' + replyToCommentId).data('comment-author');
      } else if (postId != '') {
        author = $('#post-content-' + postId).data('comment-author');
      }
      $('#submit-comment-progress').hide();
      $('#replying-comment-prompt').html("replying to <a href='javascript:void(0)'>#" + author + "</a>");
      $('#comment-input').val('');
      $('#dialog-add-comment').modal("show");
      $('#dialog-add-comment').off('shown.bs.modal').on('shown.bs.modal', function (e) {
        $('#dialog-add-comment').data('replyingToPostId', postId);
        $('#dialog-add-comment').data('containerId', containerId);
        if (replyToCommentId != '') {
          $('#dialog-add-comment').data('replyingToCommentId', replyToCommentId);
        }
        $('#submit-comment-button').off('click').on('click', _this42.SaveNewComment);
      });
    }
  }, {
    key: "SaveNewComment",
    value: function SaveNewComment() {
      var _this43 = this;
      $('#submit-comment-progress').show();
      $('#submit-comment-button').off('click');
      setTimeout(function () {
        var progress = true;
        var comment = $('#comment-input').val();
        if (comment === '') {
          $('#comment-input').parent().addClass('has-danger');
          progress = false;
          $('#submit-comment-progress').hide();
        }
        if (!progress) {
          $('#submit-comment-button').off('click').on('click', window.SocialProfile.SaveNewComment);
          return;
        }

        // Create a new FormData object.
        var formData = new FormData();

        // Loop through each of the selected files.
        for (var i = 0; i < window.Lightbox.tmp_files.length; i++) {
          var file = window.Lightbox.tmp_files[i];
          if (!file.type.match('image.*')) {
            continue;
          }
          formData.append('Files', file, file.name);
        }
        var repliesToMyPosts = document.querySelector('#RepliesToMyPostsViaComments').checked;
        formData.append('RepliesToMyPosts', repliesToMyPosts);
        var containerId = $('#dialog-add-comment').data('containerId');
        var replyToCommentId = $('#dialog-add-comment').data('replyingToCommentId');
        var postId = $('#dialog-add-comment').data('replyingToPostId');
        formData.append('Body', comment);
        if (replyToCommentId != null && replyToCommentId != undefined && replyToCommentId !== "") {
          formData.append('ReplyToCommentId', replyToCommentId);
          ;
        }
        formData.append('PostId', postId);
        formData.append('AnonKey', _this43.DeviceId);
        $.ajax({
          type: "POST",
          cache: false,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          processData: false,
          contentType: false,
          url: window.submitForumPostCommentUrl,
          dataType: "json",
          data: formData,
          async: false,
          success: function success(result) {
            if (result.Success === true) {
              $('#dialog-add-comment').modal("hide");
              window.Lightbox.tmp_files = new Array();
              result.Comment.ViewerCanEdit = true;
              result.Comment.PostId = result.ParentPostId;
              if (typeof containerId === "string") {
                var repliesStr = window.forumStrings['_0Replies'].replace("{0}", result.TopicReplies);
                var participantsStr = window.forumStrings['_0Participants'].replace("{0}", result.TopicParticipants);
                var stateForForum = _this43.GetState(containerId);
                $("span.topic-".concat(result.TopicId, "-replies")).html(repliesStr);
                $("span.topic-".concat(result.TopicId, "-participants")).html(participantsStr);
                if (stateForForum.forumMode === 'InlineForum' && $('#' + containerId).length) {
                  var _index5 = stateForForum.dataState.reviewModel.Comments.length;
                  stateForForum.dataState.reviewModel.Comments[_index5] = result.Comment;
                  _this43.OpenForumComment(containerId, postId);
                  setTimeout(function () {
                    document.getElementById('forum-comment-box-' + result.Comment.Id).scrollIntoView({
                      block: "center",
                      behavior: 'smooth'
                    });
                  }, 3);
                } else if ($('#forum-list-wrap').length) {
                  var commentToRender = result.Comment;
                  commentToRender.EntityId = result.Comment.Id;
                  commentToRender.EntityType = 'comment';
                  var headline = $("#-".concat(result.Comment.AttachToPostId)).text();
                  commentToRender.Headline = headline;
                  var renderedComment = window.SocialProfile.RenderLatestForumPost(containerId, commentToRender);
                  var currentList = $('#forum-list-wrap').html();
                  $('#forum-list-wrap').html(renderedComment + currentList);
                }
                _this43.Lightbox.InitializeLBImages('inline-forum-template');
                _this43.Lightbox.InitializeLBImages('forum-items-container');
                if ($(location).attr('href').includes('forum/latest/posts')) {
                  window.SocialProfile.IgniteLatestPostsList();
                  window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                  });
                }
              }
              return true;
            } else {
              $('#submit-comment-progress').hide();
              toastr.error(result.Message);
              return false;
            }
          },
          error: function error(result) {
            $('#submit-comment-progress').hide();
            alert("An error has occurred " + result.Message);
            return false;
          },
          failure: function failure() {
            $('#submit-comment-progress').hide();
            alert("Network error");
            return false;
          }
        });
      }, 50);
    }
  }, {
    key: "SaveEditedComment",
    value: function SaveEditedComment() {
      var _this44 = this;
      $('#submit-comment-progress').show();
      setTimeout(function () {
        var progress = true;
        var review = $('#comment-input').val();
        if (review === '') {
          $('#comment-input').parent().addClass('has-danger');
          $('#submit-comment-progress').hide();
          progress = false;
        }
        if (progress) {
          //;) {

          // Create a new FormData object.
          var formData = new FormData();

          // Loop through each of the selected files.
          for (var i = 0; i < window.Lightbox.tmp_files.length; i++) {
            var file = window.Lightbox.tmp_files[i];

            // Check the file type.
            if (!file.type.match('image.*')) {
              continue;
            }
            formData.append('Files', file, file.name);
            // Add the file to the request.
          }

          var repliesToMyPosts = document.querySelector('#RepliesToMyPostsViaComments').checked;
          formData.append('RepliesToMyPosts', repliesToMyPosts);
          var commentId = $('#dialog-add-comment').data('commentId');
          var postId = $('#dialog-add-comment').data('postId');
          formData.append('CommentBody', review);
          formData.append('CommentId', commentId);
          formData.append('PostId', postId);
          formData.append('AnonKey', _this44.DeviceId);
          $.ajax({
            type: "POST",
            cache: false,
            // ReSharper disable once UseOfImplicitGlobalInFunctionScope
            processData: false,
            contentType: false,
            url: window.submitForumCommentUrl,
            dataType: "json",
            data: formData,
            async: false,
            success: function success(result) {
              if (result.Success === true) {
                $('#comment-content-' + commentId).html(review);
                $('#dialog-add-comment').modal("hide");
                window.Lightbox.tmp_files = new Array();
                window.SocialProfile.IgniteInlineForum(window.SocialProfile.TopicId, postId, '', commentId);
                return true;
              } else {
                $('#submit-comment-progress').hide();
                toastr.error(result.Message);
                return false;
              }
            },
            error: function error(result) {
              $('#submit-comment-progress').hide();
              alert("An error has occurred " + result.Message);
              return false;
            },
            failure: function failure() {
              $('#submit-comment-progress').hide();
              alert("Network error");
              return false;
            }
          });
        } else {
          $('#submit-comment-progress').hide();
        }
      }, 0);
    }
  }, {
    key: "SubmitSubscribe",
    value: function SubmitSubscribe() {
      var _this45 = this;
      $('#subscribe-to-discussion-dialog-progress').removeClass('hide');
      setTimeout(function () {
        var progress = true;
        if (progress) {
          //;) {

          // Create a new FormData object.
          var formData = new FormData();
          formData.append('TopicId', _this45.TopicId);
          formData.append('AnonKey', _this45.DeviceId);
          formData.append('EmailFrequency', $('#email-frequency-select option:selected').val());
          var entityId = $('#subscribe-to-discussion-dialog').data("entityId");
          var entityType = $('#subscribe-to-discussion-dialog').data("entityType");
          if (entityId != null && entityType != null) {
            formData.append('EntityId', entityId);
            formData.append('EntityType', entityType);
          }
          $.ajax({
            type: "POST",
            cache: false,
            // ReSharper disable once UseOfImplicitGlobalInFunctionScope
            processData: false,
            contentType: false,
            url: window.submitSubscriptionUrl,
            dataType: "json",
            data: formData,
            success: function success(result) {
              if (result.Success === true) {
                $('#subscribe-to-discussion-dialog-progress').addClass('hide');
                $('#subscribe-to-discussion-dialog').modal("hide");
                toastr.success(window.YOUR_TOPIC_HAS_BEEN_SUBSCRIBED);
                return true;
              } else {
                $('#subscribe-to-discussion-dialog-progress').addClass('hide');
                $('#subscribe-to-discussion-dialog').modal("hide");
                toastr.error(result.Message);
                return false;
              }
            },
            error: function error(result) {
              $('#subscribe-to-discussion-dialog-progress').addClass('hide');
              alert("An error has occurred " + result.Message);
              return false;
            },
            failure: function failure() {
              $('#subscribe-to-discussion-dialog-progress').addClass('hide');
              alert("Network error");
              return false;
            }
          });
        } else {
          $('#subscribe-to-discussion-dialog-progress').addClass('hide');
        }
      }, 50);
    }
  }, {
    key: "CreateInlineForum",
    value: function CreateInlineForum(entityId, entityType, forumStateKey) {
      var _this46 = this;
      setTimeout(function () {
        // Create a new FormData object.
        var formData = new FormData();
        formData.append("EntityId", entityId);
        formData.append("EntityType", entityType);
        $.ajax({
          type: "POST",
          cache: false,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          processData: false,
          contentType: false,
          url: window.createInlineTopicUrl,
          dataType: "json",
          data: formData,
          async: false,
          success: function success(result) {
            if (result.Success === true) {
              if (result.NewlyMintedTopicId !== undefined && result.NewlyMintedTopicId > 0) {
                _this46.LoadTopicPosts(result.NewlyMintedTopicId, 0, '', 0, forumStateKey);
                _this46.moderator = result.Moderate == true;
              }
              _this46.now = moment().utc();
              if (forumStateKey === 'inline-forum') {
                $('#add-post-button').show();
                $('#subscribe-button').show();
              } else if ($('#forum-list-wrap').length) {
                if (result.Posts > 0) {
                  _this46.LoadLatestPosts(1, 'forum-list-wrap');
                }
              } else {}
            }
          },
          error: function error(result) {
            console.log("Back from creation error");
            console.log(result);
          },
          failure: function failure(result) {
            console.log("Back from creation failure");
          }
        });
      }, 50);
    }
  }, {
    key: "SubmitForumPost",
    value: function SubmitForumPost() {
      var _this47 = this;
      $('#submit-post-progress').show();
      var myThis = this;
      var containerId = $('#dialog-add-post').data("containerId");
      if (typeof containerId === "string") {
        var stateForForum = this.GetState(containerId);
        setTimeout(function () {
          var progress = true;
          var review = $('#post-input').val();
          var topicTitle = $('#dialog-add-post #topic-title-input').val();
          var repliesToMyPosts = document.querySelector('#RepliesToMyPosts').checked;
          if (review === '') {
            $('#post-input').parent().addClass('has-danger');
            progress = false;
          }
          if ($('#dialog-add-post #topic-title-input').is(':visible') && topicTitle === '') {
            $('#dialog-add-post #topic-title-input').parent().addClass('has-danger');
            progress = false;
          }
          if (progress) {
            //;) {

            // Create a new FormData object.
            var formData = new FormData();

            // Loop through each of the selected files.
            for (var i = 0; i < _this47.Lightbox.tmp_files.length; i++) {
              var file = _this47.Lightbox.tmp_files[i];

              // Check the file type.
              if (!file.type.match('image.*')) {
                continue;
              }
              formData.append('Files', file, file.name);
              // Add the file to the request.
            }

            formData.append('PostBody', review);
            formData.append('RepliesToMyPosts', repliesToMyPosts);
            if (stateForForum !== undefined) {
              formData.append('TopicId', stateForForum.topicId);
            }
            formData.append('AnonKey', _this47.DeviceId);
            var postId = $('#dialog-add-post').data('postId');
            var entityId = $('#dialog-add-post').data("entityId");
            var entityType = $('#dialog-add-post').data("entityType");
            var categoryId = $('#dialog-add-post').data('categoryId');
            var intpostId = parseInt(postId, 10);
            if (intpostId != null && intpostId > 0) {
              formData.append('PostId', intpostId);
            } else if (entityId != null && entityType != null) {
              formData.append('EntityId', entityId);
              formData.append('EntityType', entityType);
            }
            if (categoryId != null && categoryId > 0) {
              formData.append('CategoryId', categoryId);
              formData.append("TopicTitle", topicTitle);
            }
            $.ajax({
              type: "POST",
              cache: false,
              // ReSharper disable once UseOfImplicitGlobalInFunctionScope
              processData: false,
              contentType: false,
              url: window.submitForumPostUrl,
              dataType: "json",
              data: formData,
              async: false,
              success: function success(result) {
                if (result.Success === true) {
                  _this47.now = moment().utc();
                  if (stateForForum !== undefined) {
                    if (stateForForum.forumMode === 'InlineForum' && $('#' + containerId).length) {
                      _this47.LoadTopicPosts(stateForForum.topicId, 0, '', 0, containerId);
                    } else if ($('#forum-list-wrap').length) {
                      _this47.LoadLatestPosts(1, 'forum-list-wrap');
                    }
                  } else {
                    if (result.NewlyMintedTopicId !== undefined && result.NewlyMintedTopicId > 0) {
                      if ($('#forum-items-container').length) {
                        if (result.NewlyMintedTopicId !== undefined && result.NewlyMintedTopicId > 0) {
                          var newUrl = '/forum?discussion=' + result.NewlyMintedTopicId;
                          window.history.replaceState({
                            path: newUrl
                          }, '', newUrl);
                          myThis.InitForumPage();
                        } else {
                          myThis.InitForumTopicPage(result.NewlyMintedTopicId);
                        }
                      }
                    }
                  }
                  $('#dialog-add-post').modal("hide");
                  _this47.Lightbox.tmp_files = new Array();
                  toastr.success(window.YOUR_COMMENT_HAS_BEEN_SUBMITTED);
                  return true;
                } else {
                  $('#dialog-add-post').modal("hide");
                  toastr.error(result.Message);
                  return false;
                }
              },
              error: function error(result) {
                $('#submit-post-progress').hide();
                alert("An error has occurred " + result.Message);
                return false;
              },
              failure: function failure() {
                $('#submit-post-progress').hide();
                alert("Network error");
                return false;
              }
            });
          } else {
            $('#submit-post-progress').hide();
          }
        }, 50);
      } else {
        console.error("Invalid key type.");
      }
    }
  }, {
    key: "Thumbs",
    value: function Thumbs(direction, channel, id, e) {
      var _this48 = this;
      var intId = parseInt(id, 10);
      var thumbData = {
        direction: direction,
        channel: channel,
        id: intId
      };
      var hashData = this.Hash(JSON.stringify(thumbData), 23);
      thumbData.anonKey = this.DeviceId;
      $.ajax({
        type: "POST",
        cache: false,
        // ReSharper disable once UseOfImplicitGlobalInFunctionScope
        url: window.thumbsUrl,
        dataType: "json",
        data: thumbData,
        success: function success(result) {
          if (result.state.Ok) {
            $(e).closest('div.baseline-controls').find('i.my').removeClass('my');
            if (result.state.PointThumb) {
              $(e).addClass('my');
            }
            var voteScore = $(e).closest('div.baseline-controls').find('div.vote-score');
            voteScore.text(result.state.NewScore);
            if (result.state.SocialProfileId == null && result.state.SocProcAnonKey.length > 0) {
              if (_this48.DeviceId == null) {
                _this48.DeviceId = result.state.SocProcAnonKey;
                localStorage.setItem("SocialProfileDevice", result.state.SocProcAnonKey);
              }
              var SocialProfileLikes = [];
              if (localStorage.getItem("SocialProfileLikes") != null) {
                var data = localStorage.getItem("SocialProfileLikes");
                SocialProfileLikes = JSON.parse(data);
              }
              if (result.state.PointThumb) {
                SocialProfileLikes.push(hashData);
              } else {
                var removeData = {};
                if (direction === 'up') {
                  removeData = {
                    direction: 'down',
                    channel: channel,
                    id: intId
                  };
                } else {
                  removeData = {
                    direction: 'up',
                    channel: channel,
                    id: intId
                  };
                }
                var removeHash = _this48.Hash(JSON.stringify(removeData), 23);
                SocialProfileLikes = _this48.RemoveThumbFromAnonList(removeHash);
              }
              _this48.AnonSocialProfileLikes = SocialProfileLikes;
              localStorage.setItem("SocialProfileLikes", JSON.stringify(SocialProfileLikes));
            }
          } else {
            toastr.error(result.state.Message);
          }
        },
        error: function (_error) {
          function error(_x) {
            return _error.apply(this, arguments);
          }
          error.toString = function () {
            return _error.toString();
          };
          return error;
        }(function (result) {
          console.log(error);
        })
      });
    }
  }, {
    key: "RemoveThumbFromAnonList",
    value: function RemoveThumbFromAnonList(entry) {
      if (this.AnonSocialProfileLikes.length) {
        var outcome = this.AnonSocialProfileLikes.filter(function (el) {
          return el !== entry;
        });
        return outcome;
      }
      return [];
    }
  }, {
    key: "OpenComment",
    value: function OpenComment(id) {
      var _this49 = this;
      if ($('#comment-post-' + id).is(':visible')) {
        $('#comment-post-' + id).hide();
      } else {
        if (this.LoadedReviewComments !== undefined) {
          var intId = parseInt(id, 10);
          var commentsForReview = this.LoadedReviewComments.filter(function (k) {
            return k.AttachedToPostId === intId;
          }).filter(function (k) {
            return !(k.ReplyToCommentId > 0);
          });
          var pendingCommentsForReview = this.MyPendingComments.filter(function (k) {
            return k.AttachedToPostId === intId;
          }).filter(function (k) {
            return !(k.ReplyToCommentId > 0);
          });
          var combinedComments = _toConsumableArray(new Set([].concat(_toConsumableArray(commentsForReview), _toConsumableArray(pendingCommentsForReview))));
          combinedComments.sort(function (a, b) {
            return a.UpdatedAt > b.UpdatedAt ? 1 : -1;
          });
          var output = '';
          var myVote = '';
          if (combinedComments.length > 0) {
            var isAnon = true;
            if (this.MyProfile.Id !== undefined) {
              isAnon = false;
            }
            if (Array.isArray(combinedComments)) {
              combinedComments.forEach(function (num, index) {
                myVote = '';
                if (!isAnon) {
                  if (combinedComments[index].UpVotes.includes(_this49.MyProfile.Id.toString())) {
                    myVote = 'up';
                  } else if (combinedComments[index].DownVotes.includes(_this49.MyProfile.Id.toString())) {
                    myVote = 'down';
                  }
                } else if (_this49.AnonSocialProfileLikes.length) {
                  var _intId = parseInt(combinedComments[index].Id, 10);
                  myVote = _this49.GetAnonThumbState(_intId, 'ReviewComment');
                }
                var comment = combinedComments[index];
                var cthml = _this49.RenderComment(comment, myVote);
                output += cthml;
              });
            } else {
              myVote = '';
              if (!isAnon) {
                if (combinedComments[index].UpVotes.includes(this.MyProfile.Id)) {
                  myVote = 'up';
                } else if (combinedComments[index].DownVotes.includes(this.MyProfile.Id)) {
                  myVote = 'down';
                }
              } else if (this.AnonSocialProfileLikes.length) {
                var _intId2 = parseInt(combinedComments[index].Id, 10);
                myVote = this.GetAnonThumbState(_intId2, 'ReviewComment');
              }
              output = this.RenderComment(combinedComments, myVote);
            }
          }
          $('#comment-list-' + id).html(output);
          $('#comment-post-' + id).show();
        }
      }
    }
  }, {
    key: "OpenForumComment",
    value: function OpenForumComment(forumStateKey, postId) {
      this.OpenCommentToView(forumStateKey, postId);
    }
  }, {
    key: "OpenCommentToView",
    value: function OpenCommentToView(forumStateKey, postId) {
      var _this50 = this;
      return new Promise(function (resolve, reject) {
        var loadedComments = [];
        var state = _this50.GetState(forumStateKey);
        var result = state.dataState;
        if (state.forumMode === 'InlineForum') {
          loadedComments = state.dataState.reviewModel.Comments;
        }
        if (loadedComments !== undefined) {
          var intId = parseInt(postId, 10);
          var commentIds = new Set(loadedComments.map(function (c) {
            return c.Id;
          }));
          console.log(commentIds);
          console.log("levelOneRepliesToPost now equ ", levelOneRepliesToPost);
          var levelOneRepliesToPost = loadedComments.filter(function (k) {
            return k.AttachedToPostId === intId;
          }).filter(function (k) {
            return !(k.DisplayUnderCommentId > 0);
          });
          //let levelOneRepliesToPost = loadedComments
          //    .filter((k) => k.AttachedToPostId === intId)
          //    .filter(k => {
          //        return  !commentIds.has(k.ReplyToCommentId)
          //           // || !(k.DisplayUnderCommentId > 0);
          //    });
          console.log("levelOneRepliesToPost now equals ", levelOneRepliesToPost);
          levelOneRepliesToPost.sort(function (a, b) {
            return a.CreatedAt > b.CreatedAt ? 1 : -1;
          });
          var output = '';
          var myVote = '';
          if (levelOneRepliesToPost.length > 0) {
            var isAnon = true;
            if (_this50.MyProfile.Id !== undefined) {
              isAnon = false;
            }
            if (Array.isArray(levelOneRepliesToPost)) {
              var isFirstCommentInList = false;
              var isLastCommentInList = false;
              var numberofComments = levelOneRepliesToPost.length;
              levelOneRepliesToPost.forEach(function (num, index) {
                if (index == 0) {
                  isFirstCommentInList = true;
                } else {
                  isFirstCommentInList = false;
                }
                if (index == numberofComments - 1) {
                  isLastCommentInList = true;
                } else {
                  isLastCommentInList = false;
                }
                var comment = levelOneRepliesToPost[index];
                var replies = loadedComments.filter(function (k) {
                  return k.AttachedToPostId === intId;
                }).filter(function (k) {
                  return k.DisplayUnderCommentId === comment.Id;
                });
                if (replies.length) {
                  console.log("level one comment \"".concat(comment.Content.trim(), "\" has ").concat(replies.length, " replies"));
                }
                var renderedComment = _this50.RenderForumComment(forumStateKey, comment, isAnon, isFirstCommentInList, isLastCommentInList, replies);
                output += renderedComment;
              });
            } else {
              output = _this50.RenderForumComment(forumStateKey, levelOneRepliesToPost, isAnon);
            }
          }
          $('#comment-list-' + postId).html(output);
          $('.comment-has-replies').each(function (index, el) {
            var replyTrailLine = $(el).find('.reply-trail-line').first();
            var replyTrailLineTail = $(el).find('.reply-trail-line-tail').first();
            var commentContentDiv = $(el).siblings('div.forum-post-wrap.is-comment').find('div.frn-flex-row.column.review-box').first();
            var commentReplyListDiv = $(commentContentDiv).parent().find('div.reply-wrap').first();
            var commentHeight = commentContentDiv.prop('scrollHeight');
            var replyListHeight = commentReplyListDiv.prop('scrollHeight');
            replyTrailLine.css('height', 'calc((' + commentHeight + 'px / 2) + 15px)');
            replyTrailLineTail.css('height', 'calc((' + commentHeight + 'px / 2) + ' + replyListHeight + 'px + 12px)');
          });
          $('#comment-post-' + postId).show();
          if ($('#forum-items-container').length) {
            _this50.Lightbox.InitializeLBImages('forum-items-container');
          }
          if ($('div.inline-forum-template').length) {
            _this50.Lightbox.InitializeLBImages('inline-forum-template');
          }
          _this50.IgnitePopOverMenus();
        }
        resolve(true);
      });
    }
  }, {
    key: "DeleteFromComments",
    value: function DeleteFromComments(id) {
      alert("delete from comments for " + id);
    }
  }, {
    key: "DeleteFromReviewComments",
    value: function DeleteFromReviewComments(id) {
      var index = this.LoadedReviewComments.findIndex(function (obj) {
        return obj.Id === id;
      });
      if (index > -1) {
        this.LoadedReviewComments[index] = this.LoadedReviewComments[this.LoadedReviewComments.length - 1]; // Swap with the last element
        this.LoadedReviewComments.pop(); // Remove the last element
      }
    }
  }, {
    key: "AddToComments",
    value: function AddToComments(comment) {
      alert("addd comment to comments");
    }
  }, {
    key: "AddToReviewComments",
    value: function AddToReviewComments(comment) {
      var index = this.LoadedReviewComments.length;
      this.LoadedReviewComments[index] = comment;
    }
  }, {
    key: "UpdateReplyCounts",
    value: function UpdateReplyCounts(result) {
      if (result.ParentCommentId > 0 && $('#open-comment-reply-' + result.ParentCommentId).length) {
        if (result.ParentCommentReplies > 0) {
          if (result.ParentCommentReplies === 1) {
            $('#open-comment-reply-' + result.ParentCommentId).html(window.ONE_REPLY);
          } else if (result.ParentCommentReplies > 0) {
            $('#open-comment-reply-' + result.ParentCommentId).html(window.X_REPLIES.replace('{0}', result.ParentCommentReplies));
          }
        } else {
          $('#open-comment-reply-' + result.ParentCommentId).html(window.LEAVE_A_REPLY);
        }
      }
      if (result.ParentPostId > 0 && $('#open-post-comment-' + result.ParentPostId).length) {
        if (result.ParentPostReplies > 0) {
          if (result.ParentPostReplies === 1) {
            $('#open-post-comment-' + result.ParentPostId).html(window.ONE_REPLY);
          } else if (result.ParentPostReplies > 0) {
            $('#open-post-comment-' + result.ParentPostId).html(window.X_REPLIES.replace('{0}', result.ParentPostReplies));
          }
        } else {
          $('#open-post-comment-' + result.ParentPostId).html(window.LEAVE_A_REPLY);
        }
      }
    }
  }, {
    key: "OpenReply",
    value: function OpenReply(replyToCommentId, postId, source) {
      var _this51 = this;
      if ($('#reply-post-' + replyToCommentId).is(':visible')) {
        $('#reply-post-' + replyToCommentId).hide();
      } else {
        var isAnon = !(this.MyProfile != null && parseInt(this.MyProfile.Id, 10) > 0);
        if (this.LoadedReviewComments !== undefined) {
          var intReplyToCommentId = parseInt(replyToCommentId, 10);
          var intPostId = parseInt(postId, 10);
          var commentsForReview = this.LoadedReviewComments.filter(function (k) {
            return k.AttachedToPostId === intPostId;
          }).filter(function (k) {
            return k.ReplyToCommentId === intReplyToCommentId;
          });
          var pendingRepliesForReview = this.MyPendingComments.filter(function (k) {
            return k.AttachedToPostId === intPostId;
          }).filter(function (k) {
            return k.ReplyToCommentId === intReplyToCommentId;
          });
          var replyFrame = this.RenderReplyFrame(replyToCommentId, postId, source);
          var replies = '';
          var combinedComments = _toConsumableArray(new Set([].concat(_toConsumableArray(commentsForReview), _toConsumableArray(pendingRepliesForReview))));
          combinedComments.sort(function (a, b) {
            return a.UpdatedAt > b.UpdatedAt ? 1 : -1;
          });
          if (combinedComments.length > 0) {
            if (Array.isArray(combinedComments)) {
              combinedComments.forEach(function (num, index) {
                var comment = combinedComments[index];
                replies += _this51.RenderReply(comment);
              });
            } else {
              replies += this.RenderReply(combinedComments);
            }
          }
          $('#reply-post-' + replyToCommentId).html(replyFrame);
          $('#reply-list-' + replyToCommentId).html(replies);
          this.IgnitePopOverMenus();
          $('#reply-post-' + replyToCommentId).show();
        }
      }
    }
  }, {
    key: "Hash",
    value: function Hash(str) {
      var seed = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var h1 = 0xdeadbeef ^ seed,
        h2 = 0x41c6ce57 ^ seed;
      for (var i = 0, ch; i < str.length; i++) {
        ch = str.charCodeAt(i);
        h1 = Math.imul(h1 ^ ch, 2654435761);
        h2 = Math.imul(h2 ^ ch, 1597334677);
      }
      h1 = Math.imul(h1 ^ h1 >>> 16, 2246822507) ^ Math.imul(h2 ^ h2 >>> 13, 3266489909);
      h2 = Math.imul(h2 ^ h2 >>> 16, 2246822507) ^ Math.imul(h1 ^ h1 >>> 13, 3266489909);
      return 4294967296 * (2097151 & h2) + (h1 >>> 0);
    }
  }, {
    key: "RoundNumberToTwoDecimalPlaces",
    value: function RoundNumberToTwoDecimalPlaces(num) {
      var number = Number(new Intl.NumberFormat('en-US', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(num));
      return number;
    }
    // Function to find an object by ID
  }, {
    key: "FindObjectById",
    value: function FindObjectById(arr, id) {
      return $.grep(arr, function (item) {
        return item.id === id;
      })[0]; // [0] to return the first match
    }
  }, {
    key: "FindCommentsForPost",
    value: function FindCommentsForPost(postId) {
      alert("need to filter comments");
    }
  }, {
    key: "SortCommentByDate",
    value: function SortCommentByDate(filteredComments) {
      // Sort comments based on the CreatedAtString field

      filteredComments.sort(function (a, b) {
        if (isNaN(a.Id) || isNaN(a.Id)) {
          return 0; // Return 0 if one of the dates is invalid to keep original order
        }

        return a.Id - b.Id;
      });
    }
  }, {
    key: "PinPost",
    value: function PinPost(el, postId, state) {
      $(el).addClass('hide');
      $(el).siblings('.spinner-border-sm').removeClass('hide');
      setTimeout(function () {
        var progress = true;
        if (progress) {
          var formData = new FormData();
          if (postId != null && state != null) {
            formData.append('postid', postId);
            formData.append('state', state);
          }
          $.ajax({
            type: "POST",
            cache: false,
            processData: false,
            contentType: false,
            url: window.forumPinpostUrl,
            dataType: "json",
            data: formData,
            success: function success(data) {
              if (data.result.Success === true) {
                toastr.success(data.result.Message);
                window.SocialProfile.IgniteInlineForum(window.SocialProfile.TopicId, 0, 'discussion-counter', 0);
                return true;
              } else {
                toastr.error(data.result.Message);
                return false;
              }
            },
            error: function error(result) {
              return false;
            },
            failure: function failure() {
              return false;
            },
            complete: function complete() {
              $(el).removeClass('hide');
              $(el).siblings('.spinner-border-sm').addClass('hide');
            }
          });
        } else {}
      }, 50);
    }
  }, {
    key: "BringToAddOrEditCategory",
    value: function BringToAddOrEditCategory(categoryObj) {
      $('#dialog-add-category .has-danger').removeClass('has-danger');
      $('#submit-category-progress').hide();
      if (categoryObj !== undefined) {
        $('#category-title-input').val(categoryObj.title);
        $('#category-description-input').val(categoryObj.description);
        $('#category-weight-input').val(categoryObj.weight);
        $('#category-id').val(categoryObj.id);
      } else {
        $('#category-title-input').val('');
        $('#category-description-input').val('');
        $('#category-weight-input').val('');
        $('#category-id').val('');
      }
      $('#dialog-add-category').off('shown.bs.modal');
      $('#add-category-body').show();
      $('#dialog-add-category').modal('show');
    }
  }, {
    key: "SubmitForumCategory",
    value: function SubmitForumCategory() {
      var myThis = this;
      var title = $('#category-title-input').val();
      var description = $('#category-description-input').val();
      var weight = $('#category-weight-input').val();
      var id = $('#category-id').val();
      var validated = true;
      if (title === '') {
        $('#category-title-input').parent().addClass("has-danger");
        validated = false;
      }
      if (validated) {
        //;) {
        $('#submit-category-progress').show();

        // Create a new FormData object.
        var formData = new FormData();
        if (id != '' && id != undefined && id != null) {
          formData.append('CategoryId', id);
        }
        if (weight == '') 0, _readOnlyError("weight");
        formData.append('Name', title);
        formData.append('Description', description);
        formData.append('Weight', weight);
        $.ajax({
          type: "POST",
          cache: false,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          processData: false,
          contentType: false,
          url: '/api/forum/categories/submit',
          dataType: "json",
          data: formData,
          async: false,
          success: function success(result) {
            if (result.Success === true) {
              myThis.LoadCategories();
              $('#submit-category-progress').hide();
              $('#dialog-add-category').modal("hide");
              toastr.success("Category is submitted successfully");
              return true;
            } else {
              $('#submit-category-progress').hide();
              $('#dialog-add-category').modal("hide");
              toastr.error(result.Message);
              return false;
            }
          },
          error: function error(result) {
            $('#submit-category-progress').hide();
            alert("An error has occurred " + result.Message);
            return false;
          },
          failure: function failure() {
            $('#submit-category-progress').hide();
            alert("Network error");
            return false;
          }
        });
      }
    }
  }, {
    key: "BringToAddTopic",
    value: function BringToAddTopic(categoryId, containerId) {
      if (!categoryId) categoryId = this.CategoryId;
      this.TopicId = undefined;
      $("#dialog-add-post #topic-title-input").show();
      $("#dialog-add-post #topic-title-input").val('');
      $('#dialog-add-post').data('categoryId', categoryId);
      this.BringToPost(containerId);
    }
  }, {
    key: "BringToEditTopic",
    value: function BringToEditTopic(categoryId, topicObj) {
      if (!categoryId) categoryId = this.CategoryId;
      $('#dialog-add-topic .has-danger').removeClass('has-danger');
      $('#submit-topic-progress').hide();
      $('#dialog-add-topic').data('categoryId', categoryId);
      if (topicObj !== undefined) {
        $('#dialog-add-topic #topic-title-input').val(topicObj.title);
        $('#dialog-add-topic').data('topicId', topicObj.id);
      } else {
        $('#dialog-add-topic #topic-title-input').val('');
        $('#dialog-add-topic').data('topicId', '');
      }
      $('#dialog-add-topic').off('shown.bs.modal');
      $('#add-topic-body').show();
      $('#dialog-add-topic').modal('show');
    }
  }, {
    key: "SubmitForumTopic",
    value: function SubmitForumTopic() {
      var myThis = this;
      var title = $('#dialog-add-topic #topic-title-input').val();
      var categoryid = $('#dialog-add-topic').data('categoryId');
      var id = $('#dialog-add-topic').data('topicId');
      var validated = true;
      if (title === '') {
        $('#dialog-add-topic #topic-title-input').parent().addClass("has-danger");
        validated = false;
      }
      if (!categoryid) {
        alert("Invalid operation");
      }
      if (validated) {
        $('#submit-topic-progress').show();

        // Create a new FormData object.
        var formData = new FormData();
        formData.append('CategoryId', categoryid);
        if (id != null && id != undefined && id != '') {
          formData.append("TopicId", id);
        }
        formData.append('TopicTitle', title);
        $.ajax({
          type: "POST",
          cache: false,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          processData: false,
          contentType: false,
          url: '/api/forum/topics/submit',
          dataType: "json",
          data: formData,
          async: false,
          success: function success(result) {
            $('#submit-topic-progress').hide();
            $('#dialog-add-topic').modal("hide");
            if (result.Success === true) {
              myThis.LoadCategoryTopics(categoryid);
              toastr.success("Discussion is submitted successfully");
              return true;
            } else {
              toastr.error(result.Message);
              return false;
            }
          },
          error: function error(result) {
            $('#submit-topic-progress').hide();
            alert("An error has occurred " + result.Message);
            return false;
          },
          failure: function failure() {
            $('#submit-topic-progress').hide();
            alert("Network error");
            return false;
          }
        });
      }
    }
  }, {
    key: "InitForumPage",
    value: function InitForumPage() {
      var urlParam = new URLSearchParams(location.search);
      if (urlParam.has('category')) {
        this.InitForumCategoryPage(urlParam.get('category'));
      } else if (urlParam.has('discussion')) {
        var postId = urlParam.get('post');
        var commentId = urlParam.get('comment');
        if (postId === null) {
          postId = urlParam.get('postId');
        }
        if (commentId === null) {
          commentId = urlParam.get('commentId');
        }
        this.IgniteForumTopicPage(urlParam.get('discussion'), postId, commentId);
      } else {
        this.InitForumMainPage();
        $('.forum-page-description').hide();
      }
    }
  }, {
    key: "InitForumPageSkeleton",
    value: function InitForumPageSkeleton(pageType) {
      if (!pageType) {
        var urlParam = new URLSearchParams(location.search);
        if (urlParam.has('category')) {
          pageType = 'category';
        } else if (urlParam.has('discussion')) {
          pageType = 'discussion';
        } else {
          pageType = 'main';
        }
      }
      $("#forum-page-moderator-controls").hide();
      $("#forum-items-container").removeClass('category').removeClass('discussion').removeClass('main');
      $("#forum-items-container").addClass(pageType);
      if (pageType == 'main') {
        var containerHtml = window.forumTemplates['skeleton'] + window.forumTemplates['skeleton'] + window.forumTemplates['skeleton'] + window.forumTemplates['skeleton'];
        $("#forum-items-container").html(containerHtml);
        $("#forum-items-container-pager").html('');
        $("#forum-page-head-controls").html(window.forumTemplates['mainHeadSkeleton']);
      } else if (pageType == 'category') {
        var _containerHtml = window.forumTemplates['skeleton'] + window.forumTemplates['skeleton'] + window.forumTemplates['skeleton'] + window.forumTemplates['skeleton'];
        $("#forum-items-container").html(_containerHtml);
        $("#forum-items-container-pager").html('');
        $("#forum-page-head-controls").html(window.forumTemplates['categoryHeadSkeleton']);
      } else if (pageType == 'discussion') {
        var _containerHtml2 = window.forumTemplates['postItemSkeleton'] + window.forumTemplates['postItemSkeleton'] + window.forumTemplates['postItemSkeleton'] + window.forumTemplates['postItemSkeleton'];
        $("#forum-items-container").html(_containerHtml2);
        $("#forum-items-container-pager").html('');
        $("#forum-page-head-controls").html(window.forumTemplates['topicHeadSkeleton']);
      }
    }
  }, {
    key: "InitForumCategoryPage",
    value: function InitForumCategoryPage(categoryId) {
      this.InitForumPageSkeleton('category');
      this.CategoryId = categoryId;
      this.LoadCategoryTopics(categoryId);
      this.Lightbox.IgniteAddPostPhotoButton();
    }
  }, {
    key: "LoadCategoryTopics",
    value: function LoadCategoryTopics(categoryId) {
      var myThis = this;
      var container = $('#forum-items-container-pager').pagination({
        dataSource: '/api/forum/topics',
        locator: 'Topics.Data',
        pageSize: 25,
        pageRange: 1,
        autoHidePrevious: true,
        autoHideNext: true,
        className: 'paginationjs-small',
        totalNumberLocator: function totalNumberLocator(response) {
          return response.Topics.Count;
        },
        ajax: {
          data: {
            CategoryId: categoryId
          },
          traditional: true,
          type: 'POST'
        },
        formatAjaxError: function formatAjaxError(jqXHR, textStatus, errorThrown) {
          console.log('error', jqXHR, textStatus, errorThrown);
        },
        callback: function callback(data, pagination) {
          if (pagination.originalResponse.CanModerate == true) {
            myThis.moderator = true;
          }
          var html = '<a class="breadcrumb-item" href="/">Home</a>';
          html += '<a class="breadcrumb-item forum-navigation-link" href="/forum">Forums</a>';
          html += '<span class="breadcrumb-item">' + pagination.originalResponse.CategoryName + '</span>';
          $("#site-breadcrumb").html(html);
          myThis.InitForumCategoryPageHeadControls(pagination.originalResponse, categoryId, 'forum-items-container');
          $("#forum-items-container-pager-top").html('');
          $("#forum-items-container-pager-top").append($('#forum-items-container-pager .paginationjs').clone(true));
          $("#forum-items-container").html('');
          for (var i = 0; i < data.length; i++) {
            var _topic$Replies, _topic$NumParticipant;
            var topic = data[i];
            var template = window.forumTemplates['topicItem'];
            template = template.replace(/{{ForumItemId}}/g, topic.Id);
            template = template.replace("{{ForumItemTitle}}", topic.Title);
            var createdBy = 'Created: ';
            var creationDate = moment.utc(topic.CreationDate).format("MMM DD,YYYY");
            createdBy += creationDate;
            template = template.replace("{{ForumItemTopicStarter}}", createdBy);
            var repliesStr = window.forumStrings['_0Replies'].replace("{0}", (_topic$Replies = topic.Replies) !== null && _topic$Replies !== void 0 ? _topic$Replies : 0);
            template = template.replace("{{ForumItemReplies}}", repliesStr);
            var participantsStr = window.forumStrings['_0Participants'].replace("{0}", (_topic$NumParticipant = topic.NumParticipants) !== null && _topic$NumParticipant !== void 0 ? _topic$NumParticipant : 0);
            template = template.replace("{{ForumItemParticipants}}", participantsStr);
            template = template.replace("{{ForumItemLastPostBy}}", topic.LastPostBy || '');
            template = template.replace("{{ForumItemLastPostBySocialId}}", topic.LastPostBySocialProfileId);
            if (topic.LastPostBy) {
              var myDate = moment.duration(moment.utc(topic.LastUpdateDate).diff(moment().utc())).humanize(true);
              template = template.replace(/{{ForumItemLastPostAt}}/g, myDate);
            } else {
              template = template.replace(/{{ForumItemLastPostAt}}/g, '');
            }
            if (topic.ViewerCanEdit == true) {
              var menuHtml = "<ul class=\"dropdown-menu forum-item-moderation-menu\">";
              menuHtml = menuHtml + "<li onclick=\"window.SocialProfile.EditTopic(".concat(topic.Id, ")\">Edit</li>");
              if (!topic.InlineEntity) {
                menuHtml = menuHtml + "<li onclick=\"window.SocialProfile.DeleteTopic(".concat(topic.Id, ")\">Delete</li>");
              }
              if (!topic.InlineEntity && window.SocialProfile.moderator) {
                menuHtml = menuHtml + "<li onclick=\"window.SocialProfile.CurtailUserActivity(".concat(topic.SocialProfileId, ")\">Ban user</li>");
                menuHtml = menuHtml + "<li onclick=\"window.SocialProfile.RemoveUserActivity(".concat(topic.SocialProfileId, ")\">Scrub user activity</li>");
              }
              menuHtml += "</ul>";
              var moderatorControlsHtml = "<div><a data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" data-topicid=\"".concat(topic.Id, "\"><img src='/Content/dist/images/icons/3dots.svg'/></a>").concat(menuHtml, "</div>");
              template = template.replace("{{ForumItemModeratorControls}}", moderatorControlsHtml);
            } else {
              template = template.replace("{{ForumItemModeratorControls}}", '');
            }
            var itemDiv = $(template);
            if (!topic.LastPostBy) {
              itemDiv.find('.last-post-data').remove();
            }
            $("#forum-items-container").append(itemDiv);
          }
          $('.forum-page-description').hide();
        }
      });
    }
  }, {
    key: "InitForumMainPageHomeControls",
    value: function InitForumMainPageHomeControls() {
      var headHtml = window.forumTemplates['headControls'];
      $("#forum-page-head-controls").html(headHtml);
      $("#forum-page-head-controls #forum-page-title").html(window.forumStrings['CommunityForums']);
      $("title").html(window.forumStrings['CommunityForums']);
      $("#forum-page-head-controls #forum-page-controls").html("");
    }
  }, {
    key: "InitForumMainPage",
    value: function InitForumMainPage() {
      this.InitForumPageSkeleton('main');
      var html = '<a class="breadcrumb-item" href="/">Home</a>';
      html += '<span class="breadcrumb-item">Forums</span>';
      $("#site-breadcrumb").html(html);
      this.InitForumMainPageHomeControls();
      this.LoadCategories();
    }
  }, {
    key: "LoadCategories",
    value: function LoadCategories() {
      var myThis = this;
      $.ajax({
        url: '/api/forum/categories',
        type: 'POST',
        cache: false,
        success: function success(result) {
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope

          if (!result.Success) {
            console.error(result.Message);
            return;
          }
          if (result.CanModerate == true) {
            myThis.moderator = true;
            $("#forum-page-head-controls #forum-page-moderator-controls").html("<a id=\"add-category-button\" style=\"\" href=\"javascript:void(0)\" onclick=\"window.SocialProfile.AddCategory()\" role=\"button\" class=\"waves-effect frn-button medium navy navy-border-no-hover curved\">\n                                Add Category\n                            </a>");
            $('#forum-page-moderator-controls').show();
          }
          $("#forum-items-container").html('');
          for (var i = 0; i < result.Categories.length; i++) {
            var _category$Replies, _category$NumParticip;
            var category = result.Categories[i];
            var template = window.forumTemplates['categoryItem'];
            template = template.replace(/{{ForumItemId}}/g, category.CategoryId);
            template = template.replace(/{{ForumItemWeight}}/g, category.Weight);
            template = template.replace("{{ForumItemTitle}}", category.Name);
            template = template.replace("{{ForumItemDescription}}", category.Description);
            var repliesStr = window.forumStrings['_0Replies'].replace("{0}", (_category$Replies = category.Replies) !== null && _category$Replies !== void 0 ? _category$Replies : 0);
            template = template.replace("{{ForumItemReplies}}", repliesStr);
            var participantsStr = window.forumStrings['_0Participants'].replace("{0}", (_category$NumParticip = category.NumParticipants) !== null && _category$NumParticip !== void 0 ? _category$NumParticip : 0);
            template = template.replace("{{ForumItemParticipants}}", participantsStr);
            if (category.LastPostBy) {
              template = template.replace("{{ForumItemLastPostBy}}", category.LastPostBy);
              template = template.replace("{{ForumItemLastPostBySocialId}}", category.LastPostBySocialProfileId);
              var myDate = moment.duration(moment.utc(category.LastPostAt).diff(moment().utc())).humanize(true);
              template = template.replace(/{{ForumItemLastPostAt}}/g, myDate);
            } else {
              template = template.replace("{{ForumItemLastPostBy}}", '');
              template = template.replace("{{ForumItemLastPostBySocialId}}", '');
              template = template.replace(/{{ForumItemLastPostAt}}/g, '');
            }
            if (result.CanModerate == true) {
              var menuHtml = "<ul class=\"dropdown-menu forum-item-moderation-menu\">";
              menuHtml = menuHtml + "<li onclick=\"window.SocialProfile.EditCategory(".concat(category.CategoryId, ")\">Edit</li>");
              if (!category.EntityType) {
                menuHtml = menuHtml + "<li onclick=\"window.SocialProfile.DeleteCategory(".concat(category.CategoryId, ")\">Delete</li>");
              }
              menuHtml += "</ul>";
              var moderatorControlsHtml = "<div><a data-toggle=\"dropdown\" aria-haspopup=\"true\" aria-expanded=\"false\" data-categoryid=\"".concat(category.CategoryId, "\"><img src='/Content/dist/images/icons/3dots.svg'/></a>").concat(menuHtml, "</div>");
              template = template.replace("{{ForumItemModeratorControls}}", moderatorControlsHtml);
            } else {
              template = template.replace("{{ForumItemModeratorControls}}", '');
            }
            var itemDiv = $(template);
            if (!category.LastPostBy) {
              itemDiv.find('.last-post-data').remove();
            }
            $("#forum-items-container").append(itemDiv);
          }
        },
        error: function error(result) {
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope

          alert("there was an error");
        }
      });
    }
  }, {
    key: "InitForumTopicPage",
    value: function InitForumTopicPage(topicId) {
      var _this52 = this;
      var jumpToPostId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      var jumpToCommentId = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;
      var containerId = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'forum-items-container';
      var myThis = this;
      this.InitForumPageSkeleton('discussion');
      var jumpTo = parseInt(jumpToPostId, 10);
      var jumpToC = parseInt(jumpToCommentId, 10);
      if (parseInt(topicId, 10) > 0) {
        var data = {
          TopicId: topicId,
          RenderPagination: true,
          JumpToPostId: jumpTo,
          ContainerId: containerId
        };
        $.ajax({
          type: "POST",
          cache: false,
          // ReSharper disable once UseOfImplicitGlobalInFunctionScope
          url: loadInlineTopicUrl,
          dataType: "json",
          data: data,
          success: function success(result) {
            if (result != null) {
              if (result.Success) {
                _this52.moderator = result.Moderate === true;
                var html = '<a class="breadcrumb-item" href="/">Home</a>';
                html += '<a class="breadcrumb-item forum-navigation-link" href="/forum">Forums</a>';
                html += '<a class="breadcrumb-item forum-navigation-link" href="/forum?category=' + result.reviewModel.CategoryId + '">' + result.reviewModel.CategoryName + '</a>';
                html += '<span class="breadcrumb-item">' + result.reviewModel.TopicTitle + '</span>';
                $("#site-breadcrumb").html(html);
                myThis.InitForumTopicPageHeadControls(result);
                _this52.AddState(containerId, result, "".concat(containerId, "-pager"), 'InlineForum', result.reviewModel.TopicId);
                myThis.ProcessInlineForumData(jumpToPostId, jumpToC, containerId);
                window.Tracker.RecordSocialActivity({
                  'Topic': topicId
                });
                var el = document.getElementById('forum-page-head-controls');
                if (isNaN(jumpTo) && isNaN(jumpToC)) {
                  el.scrollIntoView({
                    block: "start",
                    behavior: 'smooth'
                  });
                }
              } else {
                toastr.error(result.Message);
                _this52.InitForumMainPage();
              }
            }
          },
          error: function error(result) {}
        });
      }
    }
  }, {
    key: "InitForumCategoryPageHeadControls",
    value: function InitForumCategoryPageHeadControls(result, categoryId, containerId) {
      if ($("#forum-page-controls").length == 0) {
        var headHtml = window.forumTemplates['headControls'];
        $("#forum-page-head-controls").html(headHtml);
        $("#forum-page-head-controls #forum-page-title").html(result.CategoryName);
        $('title').html(result.CategoryName);
        $("#forum-page-head-controls #forum-page-controls").html("<div class=\"topic-head-buttons\">\n                        <a id=\"add-topic-button\" style=\"\" href=\"javascript:void(0)\" onclick=\"window.SocialProfile.AddTopic(".concat(categoryId, ", '").concat(containerId, "')\" role=\"button\" class=\"waves-effect frn-button medium navy navy-border-no-hover curved\">\n                            <img class=\"ml-1 mr-1\" src=\"/Content/dist/images/icons/new-message-icon.svg\" />Create Thread\n                        </a>\n                    </div>\n                    "));
      }
    }
  }, {
    key: "InitForumTopicPageHeadControls",
    value: function InitForumTopicPageHeadControls(result) {
      var _result$reviewModel, _result$reviewModel2;
      var headHtml = window.forumTemplates['headControls'];
      $("#forum-page-head-controls").html(headHtml);
      $("#forum-page-head-controls #forum-page-title").html((_result$reviewModel = result.reviewModel) === null || _result$reviewModel === void 0 ? void 0 : _result$reviewModel.TopicTitle);
      $('title').html((_result$reviewModel2 = result.reviewModel) === null || _result$reviewModel2 === void 0 ? void 0 : _result$reviewModel2.TopicTitle);
      var controlHtml = '<div class="topic-head-description d-flex flex-column" style="gap: 8px;">';
      if (result.reviewModel && result.reviewModel.LastPostBySocialProfileId > 0) {
        var topicTitle = result.reviewModel.TopicTitle;
        if (topicTitle === null || topicTitle === undefined) {
          topicTitle = '';
        }
        controlHtml += this.InitForumTopicMetaControl(result.reviewModel.TopicCreatedAt, result.reviewModel.TotalPostAndReplies, result.reviewModel.NumParticipants, result.reviewModel.TopicId, topicTitle);
      }
      controlHtml += "<div class=\"topic-head-buttons\">\n                    <a id=\"add-post-button\" style=\"\" href=\"javascript:void(0)\" onclick=\"window.SocialProfile.AddPost('forum-items-container')\" role=\"button\" class=\"waves-effect frn-button medium navy navy-border-no-hover curved\">\n                        ".concat(window.ADD_A_POST, "\n                    </a>\n                    <a id=\"subscribe-button\" style=\"\" href=\"javascript:void(0)\" onclick=\"window.SocialProfile.SubscribeToDiscussion('forum-items-container')\" role=\"button\" class=\"waves-effect frn-button medium transparent navy-border curved\">\n                        ").concat(window.SUBSCRIBE_TO_THIS_DISCUSSION, "\n                    </a>\n                </div>");
      controlHtml += "</div>";
      $("#forum-page-topic-page-head-controls").html(controlHtml);
      switch (result.reviewModel.EntityType) {
        case window.ENTITY_TYPE_SOCIAL_PROFILE_PAGE:
          var entitylink = "<a href=\"javascript:void(0)\" class=\"social-profile-navigate\" data-profile-id=\"".concat(result.reviewModel.TopicOwnerId, "\">").concat(result.reviewModel.TopicOwner, "</a>");
          var description = window.FORUM_ENTITY_TYPE_SOCIAL_PROFILE_PAGE_DESCRIPTION.replace("{0}", entitylink);
          var avatar = '';
          if (result.reviewModel.TopicOwnerAvatar !== null && result.reviewModel.TopicOwnerAvatar !== undefined) {
            avatar = "<img class=\"social-profile-navigate\" src=\"".concat(this.avatarPath).concat(result.reviewModel.TopicOwnerAvatar, "?w=136&h=136\" style=\"border-radius:50%\" data-profile-id=\"").concat(result.reviewModel.TopicOwnerId, "\">");
          }
          $('#forum-page-description').html(description);
          $('#forum-page-avatar').html(avatar);
          break;
        case window.ENTITY_TYPE_CONTEST_PAGE:
          entitylink = "<a href=\"javascript:void(0)\" class=\"contest-navigate\" data-contest-id=\"".concat(result.reviewModel.EntityId, "\">").concat(result.reviewModel.EntityTitle, "</a>");
          var contest_description = window.FORUM_ENTITY_TYPE_CONTEST_PAGE_DESCRIPTION.replace("{0}", entitylink);
          var contest_logo = '';
          if (result.reviewModel.EntityId !== null && result.reviewModel.EntityId !== undefined) {
            contest_logo = "<img class=\"contest-navigate\" src=\"/content/dist/contests/images/".concat(result.reviewModel.EntityId, "?w=136&h=136\" style=\"border-radius:50%\" data-contest-id=\"").concat(result.reviewModel.EntityId, "\">");
          }
          $('#forum-page-description').html(contest_description);
          $('#forum-page-avatar').html(contest_logo);
          break;
        case window.ENTITY_TYPE_STATS_PAGE:
          entitylink = "<a href=\"javascript:void(0)\" class=\"stats-navigate\" data-stats-id=\"".concat(result.reviewModel.EntityId, "\">").concat(result.reviewModel.EntityId, "</a>");
          var stats_description = "";
          var stats_logo = '';
          if (result.reviewModel.EntityId !== null && result.reviewModel.EntityId !== undefined) {
            stats_description = window.FORUM_ENTITY_TYPE_STATS_PAGE_DESCRIPTION.replace("{0}", entitylink);
            stats_logo = "<img class=\"stats-navigate\" src=\"/content/dist/performance/images/chart.png?w=136&h=136\" style=\"border-radius:50%\" data-stats-id=\"".concat(result.reviewModel.EntityId, "\">");
          }
          $('#forum-page-description').html(stats_description);
          $('#forum-page-avatar').html(stats_logo);
          break;
        case window.ENTITY_TYPE_BROKER_VIEW:
        case window.ENTITY_TYPE_BROKER_REBATE_PROGRAM:
        case window.ENTITY_TYPE_BROKER_CRYPTO_EXCHANGE:
        case window.ENTITY_TYPE_BROKER_PROP_FIRM:
          var brokerLink = "<a href=\"javascript:void(0)\" class=\"thread-navigate\" data-thread-id=\"".concat(result.reviewModel.TopicId, "\">").concat(result.reviewModel.EntityTitle, "</a>");
          var company_description = "";
          var company_logo = '';
          if (result.reviewModel.EntityId !== null && result.reviewModel.EntityId !== undefined) {
            if (result.reviewModel.EntityTitle !== null && result.reviewModel.EntityTitle !== undefined) {
              company_description = window.FORUM_ENTITY_TYPE_COMPANY_PAGE_DESCRIPTION.replace("{0}", brokerLink);
            }
            company_logo = "<img class=\"thread-navigate\" src=\"/content/dist/company/images/".concat(result.reviewModel.EntityId, "/company_logo.png?w=136&h=136\" style=\"border-radius:50%\" data-thread-id=\"").concat(result.reviewModel.TopicId, "\">");
          }
          $('#forum-page-description').html(company_description);
          $('#forum-page-avatar').html(company_logo);
          break;
      }
    }
  }, {
    key: "InitForumTopicMetaControl",
    value: function InitForumTopicMetaControl(topicCreatedAt, replies, participants, topicId) {
      var topicTitle = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : '';
      var myDate = moment.utc(topicCreatedAt);
      var repliesStr = window.forumStrings['_0Replies'].replace("{0}", replies);
      var participantsStr = window.forumStrings['_0Participants'].replace("{0}", participants);
      if ($('#topic-headline').length) {
        if (topicTitle !== '') {
          $('#topic-headline').html(topicTitle);
        }
      }
      return "<div id=\"topic-meta-information\" class=\"topic-meta-information\">\n                        <span>Created: ".concat(myDate.format('LL'), "</span>\n                        <div class=\"d-flex\" style=\"gap: 16px\">\n                            <div class=\"d-flex align-items-center\" style=\"gap: 4px;\"><i class=\"reply-to-post icon\"></i><span class=\"topic-").concat(topicId, "-replies\">").concat(repliesStr, "</span></div>\n                            <div class=\"d-flex align-items-center\" style=\"gap: 4px;\"><i class=\"participants-in-thread icon\"></i><span class=\"topic-").concat(topicId, "-participants\">").concat(participantsStr, "</span></div>\n                        </div>\n                        \n                        \n                    </div>");
    }
  }]);
  return SocialProfile;
}();
var _default = SocialProfile;
exports["default"] = _default;

},{}],4:[function(require,module,exports){
"use strict";

var _SocialProfile = _interopRequireDefault(require("../../includes/SocialProfile.js"));
var _Lightbox = _interopRequireDefault(require("../../includes/Lightbox.js"));
var _Cookie = _interopRequireDefault(require("../../includes/Cookie.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
$(function () {
  window.Lightbox = new _Lightbox["default"]();
  window.SocialProfile = new _SocialProfile["default"](window.Lightbox, new _Cookie["default"]());
});

},{"../../includes/Cookie.js":1,"../../includes/Lightbox.js":2,"../../includes/SocialProfile.js":3}]},{},[4]);
